/*!
 * telemetry-tier0.js — extracted 2026-07-08 from resources/views/layouts/app.blade.php
 * (the AnalyticsEvent::isEnabled()-gated inline telemetry script: __aeCritical,
 * __stage funnel, __withStallGuard, abandon reporter, cookie-consent gate + the
 * real __ae implementation, auto-wiring of tool_error/tool_complete, and the
 * always-on last-action mirror).
 *
 * Loaded SYNCHRONOUSLY (no defer) at the exact old inline position — still inside
 * the same Blade conditional wrapper — so document-order execution is unchanged.
 *
 * Expects this inline-shim global (set by the layout right before this tag):
 *   window.__COOKIE_CONSENT_DB — 'accepted' | 'declined' | null. Account-tied
 *   cookie-consent for logged-in users (was a Blade interpolation mid-block;
 *   consent code only reads it at call time).
 */
    /* Tier-0 telemetry: anonymous critical health signals that fire regardless of
       cookie consent. These carry NO session_id and NO payload strings beyond a
       bounded `src` field — only enough to increment a server-side Redis counter
       keyed by {tool, type, hour}. Safe under GDPR Recital 26 (aggregated
       statistics, no individual tracking). Use for stall/crash/rage signals so
       the dashboard stays readable even when 40% of EU traffic declines cookies. */
    /* Баннер FFmpeg не доезжает до нас — он ЗАНИМАЕТ место причины.
       FFmpeg печатает 11 строк version / built with / configuration / libav*
       ПЕРЕД любой работой, а сообщения об ошибках мы режем по первым 200
       символам. Замер 08.09.2026 на настоящем отказе: из 14 строк лога 11 —
       баннер и 3 по делу («moov atom not found», «Invalid data found»,
       «Aborted()»); в телеметрию уезжало 100% баннера и 0% причины. За 14 дней
       так потеряны 107 отчётов только на /video-merge, где 62 сессии за месяц
       падают на конкретном клипе — и почему, не записано НИ РАЗУ. Жалоба
       Игоря (Премиум, 07.09) — ровно этот случай.

       ⚠️ Чистить надо ДО усечения: обрезка после substring() уже ничего не
       спасает — диагностика к тому моменту отрезана (проверено, первый заход
       правки был именно таким и оставлял «clip 2: libavcodec 59.37.100»).
       Поэтому здесь ОДНА функция, которая и чистит, и режет, и все точки
       сборки сообщений зовут её вместо голого substring.

       ⚠️ И не у источника: FFmpegProcessor._fs.exec отдаёт `logs`, из которых
       семь мест вытаскивают значения регулярками (`Duration:` в /denoise ×4,
       частота, счёт строк декодера в /repair-video, темп кадров в
       video-vitals). Замер показал: фильтрация у источника ЛОМАЕТ определение
       длительности — `Duration:` числится шумом. Баннер мешает транспорту, а
       не читателю логов, значит и чистится в транспорте. */
    var _FF_BANNER=/^\s*(ffmpeg version\b|built with\b|configuration:|lib(av|sw|post)\w+\s+\d)/i;
    window.__ffMsg=function(v,n){
        v=(v==null?'':String(v));
        if(v.indexOf('libav')>=0){
            var kept=v.split(' | ').filter(function(l){return !_FF_BANNER.test(l);});
            /* Первый сегмент часто несёт наш собственный префикс («clip 2: »),
               и из-за него баннер перестаёт стоять в начале строки. Префикс
               нужен — он называет виновника, — а версии за ним нет. */
            if(kept.length&&kept[0].indexOf('libav')>=0)
                kept[0]=kept[0].replace(/^([^|]{0,40}?:\s*)?\s*(ffmpeg version\b|built with\b|configuration:|lib(av|sw|post)\w+\s+\d).*$/i,'$1');
            /* От префикса остаётся «clip 2:» — приклеиваем его к следующей
               строке, иначе в отчёте болтается двоеточие и пустой сегмент. */
            if(kept.length>1&&/:\s*$/.test(kept[0])){kept[1]=kept[0].trim()+' '+kept[1].replace(/^\s+/,'');kept.shift();}
            var out=kept.filter(function(l){return l&&l.trim();}).join(' | ').replace(/^\s+/,'');
            if(out)v=out;   /* пустой отчёт хуже шумного */
        }
        return n>0?v.substring(0,n):v;
    };

    (function(){
        var _critDedup={},_critTTL=30000;
        window.__aeCritical=function(type,data){
            if(!type)return;
            /* sendBeacon throws on file:// — silently skip when user opens a saved page locally */
            if(!/^https?:$/.test(location.protocol))return;
            data=data||{};
            var now=Date.now(),k=(data.slug||'')+'|'+type;
            if(_critDedup[k]&&now-_critDedup[k]<_critTTL)return;
            _critDedup[k]=now;
            var src=(data.slug?'slug='+data.slug+'|':'');
            /* 2026-06-23: per-field cap raised 60→400 + total src cap 400→1200.
               The 60-char per-field cap was hiding the actual cause of every
               sw_register_failed event (Chromium's "Failed to register a
               ServiceWorker for scope ('...') with script ('...'): <REASON>"
               format puts the diagnostic AFTER ~80 chars of preamble, and
               sw_register_failed's err_msg is exactly the field we need to
               see in full to bucket the 1800+/week events into actionable
               root-cause categories). Server-side substr in logClientError
               raised to 1500 to match. */
            /* Имя файла человека не уходит и сюда (17.10.2026, волна 3): аварийный канал пишет
               src в client-errors.log (вместе с IP) и, для ffmpeg-*, в журнал аналитики. Чистит
               та же функция, что у журнала, — window.__fileless (блок __fileless ниже). */
            try{if(typeof window.__fileless==='function')data=window.__fileless(data)||data;}catch(_){}
            for(var key in data){
                if(key==='slug'||typeof data[key]==='object')continue;
                src+=key+'='+String(data[key]).substring(0,400)+'|';
            }
            try{
                navigator.sendBeacon('/api/log-error',JSON.stringify([{
                    type:String(type).substring(0,40),
                    src:src.substring(0,1200),
                    page:location.pathname,
                    ua:navigator.userAgent.substring(0,200)
                }]));
            }catch(_){}
        };
        /* Stage tracker: tools call __stage('wasm_load'), __stage('processing'),
           __stage('complete') at phase boundaries. We compute dwell_ms from the
           prior call and emit `tool_stage` events. Critical stages (error,
           stalled, abandoned) also fire __aeCritical so they reach the dashboard
           without consent. On pagehide we flush a `final_stage` for users who
           leave mid-flow — answers "where did they get stuck?" reliably. */
        var _lastStage=null,_lastAt=Date.now(),_lastFireAt=0;
        var _mt=document.querySelector('meta[name="tool-slug"]');
        var _tool=_mt?_mt.content:null;
        // Terminal state absorption — once a tool reaches a final outcome
        // (`complete`, `abandoned`), late-arriving noise events (`error`,
        // `stalled`, `*_failed`) must not flip the funnel row from success to
        // failure. Documented case (Sentry #116805237 / Pino 2026-05-01):
        // user downloaded video-crop output → 74s later a fullscreen-API
        // rejection fired `__stage('error')`, the row moved processing→error
        // even though the export completed. The guard suppresses that, but
        // logs each suppression as `tool_stage_late_noise` so we can audit
        // how often it triggers and what's leaking.
        //
        // A *fresh* work cycle (`processing`, `file_select`, `wasm_load`, ...)
        // IS allowed and resets `_lastStage` — the funnel must continue to
        // record repeated tool use within a single page lifetime.
        /* ── window.__runMark — «идёт ли РАБОТА прямо сейчас» ──────────────────
           Один факт вместо угадывания по имени стадии.

           Зачем. `_inferStage()` ниже решал этот вопрос регуляркой по НАЗВАНИЮ
           последней стадии (`/process|encode|decode|render|infer|probe|wasm|init/`),
           а названия пишут авторы трёхсот тулов. `wasm_ready` — это «движок
           прогрелся», то есть ПРЯМО ПРОТИВОПОЛОЖНОЕ занятости, — и попадало в
           «идёт обработка» по подстроке `wasm`. Замер на проде за 30 дней
           (2026-09-01): из 8807 `tool_abandon` со `stage:processing`
             · 6608 (75%) — только прогрев, прогон НЕ начинался,
             · 1182 (13%) — человеку показали СТЕНУ капа, он ничего и не мог,
             · 1017 (12%) — настоящая брошенная работа.
           То есть корзина «бросили во время обработки» на 88% состояла из тех,
           кто ничего не запускал. У /pitch там 559 событий и НИ ОДНОГО
           настоящего, у /voice-changer 543 и ни одного, у /reverse 132 и ни
           одного. Эти числа читает `php artisan telemetry:tool <slug>` и
           панель возвратов — то есть по ним заводят расследования и решают
           про деньги.

           Как. Работа начинается и кончается не в туле, а в ОБЩИХ примитивах,
           через которые она и так проходит: `__toolLimit.begin()` → токен →
           `commit()/abort()` (203 блейда) и `FFmpegProcessor.process()`
           (135 блейдов). Оба зовут сюда. Счётчик ссылочный: параллельные
           прогоны не гасят друг друга.

           Страховка от забытого `abort()`: терминальная стадия тула
           (`complete`/`error`/`idle`/`cancelled`) закрывает скобку, которую тул
           не закрыл. Это настоящий сигнал завершения, а не таймаут. */
        /* ── window.__runLedger — прогон, который страница не дожила до конца ─
           Запись о начатом прогоне, переживающая смерть страницы.

           Зачем. Когда iOS/Android выгружает страницу посреди обработки (память
           кончилась или приложение свернули), `pagehide` не шлётся, `tool_abandon`
           не летит, и следующее, что видит человек, — тот же тул, пустой, без
           единого слова. Обращение #7773 (10.09.2026, iPhone, голосовая заметка
           35 мин): четыре запуска в трёх тулах, ни один не дожил, и вопрос
           «почему я не вижу обработанные записи?» — потому что ни страница, ни
           телеметрия не знали, что прогон был. Замер RU за 30 дней: на iOS файлы
           длиннее 15 минут доходят до результата в 5 случаях из 28, на Android
           длиннее 30 минут — в 12 из 36, на Windows — в 199 из 215. Класс был
           невидим по построению: все датчики умирают вместе со страницей.

           Тот же приём, что у `pick_lost_on_reload` в tool-uploader.js, только
           запись — в localStorage: sessionStorage не переживает перезапуск PWA
           (iOS убивает приложение в фоне, оно открывается заново на главной, и
           ровно там человек и не находит результат). Запись пишется, когда
           `__runMark` открывает скобку прогона, бьётся пульсом каждые 5 с,
           снимается на любом честном конце (commit/abort/терминальная стадия) и
           на `pagehide` (перезагрузка, уход, закрытие — всё это НЕ смерть).
           Запись, стоящая при загрузке, означает одно из двух:
             · тот же sid (sessionStorage пережил убийство рендерера) — это ТА ЖЕ
               вкладка после смерти, вердикт сразу;
             · другой sid — либо соседняя живая вкладка (пульс свежий → молчим,
               перепроверим через полминуты), либо перезапуск PWA / новая вкладка
               после смерти (пульс старый → вердикт).
           Вердикт = событие `run_lost_on_reload` (класс наконец получает число) и
           объяснение человеку: на странице того же тула — коробка у зоны
           загрузки с кнопкой «выбрать файл ещё раз», на любой другой — та же
           коробка вверху контента со ссылкой обратно в тул. Никакой автопрокрутки;
           если коробки не видно — та же фраза тостом (урок стены капа 31.08).

           Чего это НЕ делает: не обещает вернуть результат. Его нет — работа шла
           в браузере, и браузер умер. Объяснение и есть починка; следующий шаг
           (серверный лейн для длинных файлов на телефоне) — отдельное решение.
           Сторожа: tests/playwright/run-lost-on-reload.mjs (смерть по контракту:
           без pagehide, хранилище цело, свежий документ; плюс честные уходы,
           которые НЕ должны давать заметку) и tests/Unit/RunLedgerConventionTest. */
        /* ── Слив журнала офлайн-страницы ───────────────────────────────
           `public/offline.html` (её отдаёт setCatchHandler воркера, когда
           навигация провалилась И копии в кэше нет) сама отправить событие
           не может — сети там нет по условию. Она пишет запись в
           localStorage, а сливаем мы, на первой же УДАВШЕЙСЯ загрузке.
           До 20.09.2026 класс был нем: сколько людей видят «Сайт не
           работает», знала только поддержка.
           Поле `cache` — тот самый разделитель: 0 у вошедшего (ответ
           `private`/`no-store`, воркер не кэширует и стирает гостевую
           копию) против 1 у того, кому было чем подстраховаться.          */
        (function(){
            try{
                var raw=localStorage.getItem('tmb_sw_offline');
                if(!raw)return;
                localStorage.removeItem('tmb_sw_offline');
                var list=JSON.parse(raw);
                if(!Array.isArray(list))return;
                var now=Date.now();
                list.slice(-20).forEach(function(r){
                    if(!r||!r.t)return;
                    var p={f:'sw_offline_shown',u:r.u||'',m:r.m||'',on:r.on?1:0,au:r.au?1:0,
                           conn:r.c||'',sw:r.sw?1:0,cache:(typeof r.cache==='number'?r.cache:-1),
                           pc:(typeof r.pc==='number'?r.pc:-1),age_s:Math.round((now-r.t)/1000)};
                    var send=function(){ try{ if(window.__ae){window.__ae('feature_use',p);return true;} }catch(_){} return false; };
                    if(!send())setTimeout(send,2000);
                });
            }catch(_){}
        })();

        window.__runLedger=(function(){
            var KEY='_tb_run_open';
            var BEAT_MS=5000;           // живая вкладка бьётся чаще, чем раз в 25 с
            var DEAD_AFTER_MS=25000;    // старше — никто не бьётся, вкладка мертва
            var RECHECK_MS=32000;       // свежий пульс при чужом sid: перепроверить
            var MAX_AGE_MS=48*3600*1000;
            /* Уход с ОТКРЫТОЙ скобкой (закрыл вкладку, выключил компьютер,
               ушёл по ссылке) — не смерть рендерера, но работа умерла ровно
               так же. Запись при таком уходе не стирается, а помечается, и
               решение принимается на СЛЕДУЮЩЕЙ загрузке по ПАУЗЕ: вернулся
               через секунду — он сам только что перезагрузил и всё понимает;
               вернулся через полчаса — он ищет свою работу и не находит
               (обращение Vladique, 12.09.2026, /auto-captions: «оставил
               загружаться, выключил компьютер, включил — не могу найти, где
               сделанная работа»). До этой правки pagehide стирал запись, и
               такой человек не получал НИ ОДНОГО слова объяснения. */
            var LEFT_GRACE_MS=120000;   // меньше — это «я только что перезагрузил»
            var LEFT_MIN_RAN_S=15;      // короче — работы, о которой стоит говорить, не было
            var ua=navigator.userAgent||'';
            var MOB=/Mobi|Android|iPhone|iPad/i.test(ua)?1:0;
            var T={
                en:{h:'Processing of “{name}” was interrupted',h0:'Processing was interrupted',
                    tailLeft:': you left the page, and files are processed right in this tab — the result was not kept. Choose the file again and keep this page open until it finishes.',
                    tail:': the page was unloaded (the device ran out of memory or the app was moved to the background) and the result was not kept — files are processed in your browser and exist only after you press “Download”. Choose the file again and keep this page open until it finishes.',
                    unspent:'This run was not counted against today’s limit: only a finished result counts.',phone:'On a phone, a long recording is processed more reliably from a computer.',btn:'Choose the file again',back:'Return to the tool',server:'With :plan a file like this can be processed on our server instead: you may close the page, the result appears in “My generations”.'},
                ru:{h:'Обработка файла «{name}» прервалась',h0:'Обработка прервалась',
                    tailLeft:': вы ушли со страницы, а файлы обрабатываются прямо в этой вкладке — результат не сохранился. Выберите файл ещё раз и не закрывайте страницу до конца обработки.',
                    tail:': страница была выгружена (устройству не хватило памяти или приложение было свёрнуто), и результат не сохранился — файлы обрабатываются прямо в браузере и появляются только после нажатия «Скачать». Выберите файл ещё раз и не закрывайте страницу до конца обработки.',
                    unspent:'Сегодняшняя попытка не потрачена: считается только готовый результат.',phone:'На телефоне длинную запись надёжнее обработать с компьютера.',btn:'Выбрать файл ещё раз',back:'Вернуться к инструменту',server:'В :plan такой файл можно обработать на нашем сервере: страницу можно закрыть, результат появится в «Моих генерациях».'},
                uk:{h:'Обробка файлу «{name}» перервалася',h0:'Обробка перервалася',
                    tailLeft:': ви залишили сторінку, а файли обробляються просто в цій вкладці — результат не зберігся. Оберіть файл ще раз і не закривайте сторінку до кінця обробки.',
                    tail:': сторінка була вивантажена (пристрою забракло пам’яті або застосунок згорнули), і результат не зберігся — файли обробляються просто у браузері та з’являються лише після натискання «Завантажити». Оберіть файл ще раз і не закривайте сторінку до кінця обробки.',
                    unspent:'Сьогоднішню спробу не витрачено: рахується лише готовий результат.',phone:'На телефоні довгий запис надійніше обробити з комп’ютера.',btn:'Обрати файл ще раз',back:'Повернутися до інструмента',server:'У :plan такий файл можна обробити на нашому сервері: сторінку можна закрити, результат з’явиться в «Моїх генераціях».'},
                de:{h:'Die Verarbeitung von „{name}“ wurde unterbrochen',h0:'Die Verarbeitung wurde unterbrochen',
                    tailLeft:': Sie haben die Seite verlassen, und Dateien werden direkt in diesem Tab verarbeitet – das Ergebnis wurde nicht gespeichert. Wählen Sie die Datei erneut aus und lassen Sie die Seite bis zum Ende geöffnet.',
                    tail:': Die Seite wurde entladen (dem Gerät ging der Speicher aus oder die App lief im Hintergrund), und das Ergebnis wurde nicht gespeichert – Dateien werden direkt im Browser verarbeitet und existieren erst nach „Herunterladen“. Wählen Sie die Datei erneut aus und lassen Sie die Seite bis zum Ende geöffnet.',
                    unspent:'Dieser Durchlauf zählt nicht zu Ihrem Tageslimit: Es zählt nur ein fertiges Ergebnis.',phone:'Auf dem Telefon lässt sich eine lange Aufnahme zuverlässiger am Computer verarbeiten.',btn:'Datei erneut auswählen',back:'Zurück zum Tool',server:'In :plan lässt sich eine solche Datei auf unserem Server verarbeiten: Seite schließbar, das Ergebnis erscheint unter „Meine Generierungen“.'},
                es:{h:'El procesamiento de «{name}» se interrumpió',h0:'El procesamiento se interrumpió',
                    tailLeft:': saliste de la página y los archivos se procesan en esta misma pestaña: el resultado no se guardó. Elige el archivo otra vez y mantén la página abierta hasta que termine.',
                    tail:': la página se descargó (el dispositivo se quedó sin memoria o la app pasó a segundo plano) y el resultado no se guardó: los archivos se procesan en el navegador y solo existen al pulsar «Descargar». Elige el archivo otra vez y mantén la página abierta hasta que termine.',
                    unspent:'Este intento no se descontó de tu límite de hoy: solo cuenta un resultado terminado.',phone:'En un teléfono, una grabación larga se procesa con más fiabilidad desde una computadora.',btn:'Elegir el archivo otra vez',back:'Volver a la herramienta',server:'En :plan un archivo así se puede procesar en nuestro servidor: puedes cerrar la página y el resultado aparece en «Mis generaciones».'},
                fr:{h:'Le traitement de « {name} » a été interrompu',h0:'Le traitement a été interrompu',
                    tailLeft:' : vous avez quitté la page, et les fichiers sont traités directement dans cet onglet — le résultat n’a pas été conservé. Choisissez le fichier à nouveau et gardez la page ouverte jusqu’à la fin.',
                    tail:' : la page a été déchargée (l’appareil a manqué de mémoire ou l’application est passée en arrière-plan) et le résultat n’a pas été conservé — les fichiers sont traités dans le navigateur et n’existent qu’après « Télécharger ». Choisissez le fichier à nouveau et gardez la page ouverte jusqu’à la fin.',
                    unspent:'Cet essai n’a pas été décompté de votre limite du jour : seul un résultat terminé compte.',phone:'Sur un téléphone, un long enregistrement se traite plus sûrement depuis un ordinateur.',btn:'Choisir le fichier à nouveau',back:'Revenir à l’outil',server:'Avec :plan, un tel fichier peut être traité sur notre serveur : page fermable, résultat dans « Mes générations ».'},
                pt:{h:'O processamento de «{name}» foi interrompido',h0:'O processamento foi interrompido',
                    tailLeft:': você saiu da página, e os arquivos são processados nesta mesma aba — o resultado não foi salvo. Escolha o arquivo novamente e mantenha a página aberta até o fim.',
                    tail:': a página foi descarregada (o dispositivo ficou sem memória ou o aplicativo foi para segundo plano) e o resultado não foi salvo — os arquivos são processados no navegador e só existem depois de «Baixar». Escolha o arquivo novamente e mantenha a página aberta até o fim.',
                    unspent:'Esta tentativa não foi descontada do seu limite de hoje: só conta um resultado pronto.',phone:'No celular, uma gravação longa é processada com mais segurança a partir de um computador.',btn:'Escolher o arquivo novamente',back:'Voltar à ferramenta',server:'No :plan um arquivo assim pode ser processado no nosso servidor: dá para fechar a página, o resultado aparece em «Minhas gerações».'},
                id:{h:'Pemrosesan «{name}» terputus',h0:'Pemrosesan terputus',
                    tailLeft:': Anda meninggalkan halaman, dan file diproses langsung di tab ini — hasilnya tidak tersimpan. Pilih file lagi dan biarkan halaman terbuka sampai selesai.',
                    tail:': halaman dibongkar (memori perangkat habis atau aplikasi berada di latar belakang) dan hasilnya tidak tersimpan — file diproses langsung di browser dan baru ada setelah menekan «Unduh». Pilih file lagi dan biarkan halaman terbuka sampai selesai.',
                    unspent:'Percobaan ini tidak dihitung dalam batas harian Anda: hanya hasil yang selesai yang dihitung.',phone:'Di ponsel, rekaman panjang lebih andal diproses dari komputer.',btn:'Pilih file lagi',back:'Kembali ke alat',server:'Di :plan file seperti ini dapat diproses di server kami: halaman boleh ditutup, hasilnya muncul di «Generasi saya».'},
                ko:{h:'«{name}» 처리가 중단되었습니다',h0:'처리가 중단되었습니다',
                    tailLeft:': 페이지를 벗어났고, 파일은 바로 이 탭에서 처리되므로 결과가 저장되지 않았습니다. 파일을 다시 선택하고 처리가 끝날 때까지 페이지를 열어 두세요.',
                    tail:': 페이지가 언로드되어(기기 메모리 부족 또는 앱이 백그라운드로 전환됨) 결과가 저장되지 않았습니다. 파일은 브라우저에서 처리되며 «다운로드»를 누른 뒤에만 존재합니다. 파일을 다시 선택하고 처리가 끝날 때까지 페이지를 열어 두세요.',
                    unspent:'이번 시도는 오늘 한도에서 차감되지 않았습니다. 완성된 결과만 차감됩니다.',phone:'휴대폰에서는 긴 녹음을 컴퓨터로 처리하는 것이 더 안정적입니다.',btn:'파일 다시 선택',back:'도구로 돌아가기',server:':plan에서는 이런 파일을 저희 서버에서 처리할 수 있습니다. 페이지를 닫아도 되고 결과는 «내 생성물»에 나타납니다.'},
                ar:{h:'توقفت معالجة «{name}»',h0:'توقفت المعالجة',
                    tailLeft:': لقد غادرت الصفحة، وتُعالَج الملفات في هذا التبويب نفسه — لم تُحفظ النتيجة. اختر الملف مرة أخرى وأبقِ الصفحة مفتوحة حتى انتهاء المعالجة.',
                    tail:': أُغلقت الصفحة (نفدت ذاكرة الجهاز أو انتقل التطبيق إلى الخلفية) ولم تُحفظ النتيجة — تُعالَج الملفات داخل المتصفح ولا توجد إلا بعد الضغط على «تنزيل». اختر الملف مرة أخرى وأبقِ الصفحة مفتوحة حتى انتهاء المعالجة.',
                    unspent:'لم تُحتسَب هذه المحاولة من حدّك اليومي: لا يُحتسَب إلا الناتج المكتمل.',phone:'على الهاتف، تُعالَج التسجيلات الطويلة بموثوقية أكبر من الحاسوب.',btn:'اختيار الملف مرة أخرى',back:'العودة إلى الأداة',server:'في :plan يمكن معالجة ملف كهذا على خادمنا: يمكنك إغلاق الصفحة، وتظهر النتيجة في «إنشاءاتي».'}
            };
            var rec=null,beatTimer=null,files=[];
            function sid(){ try{ return sessionStorage.getItem('_as')||''; }catch(_){ return ''; } }
            function read(){ try{ var r=localStorage.getItem(KEY); return r?JSON.parse(r):null; }catch(_){ return null; } }
            function write(r){ try{ localStorage.setItem(KEY,JSON.stringify(r)); }catch(_){} }
            function wipe(){ try{ localStorage.removeItem(KEY); }catch(_){} }
            /* Вкладка, открытая ИЗ идущей (ссылка в новой вкладке), наследует её
               sessionStorage — и sid вместе с ним, поэтому «тот же sid» не
               доказывает «та же вкладка после смерти». Обращение 2026-09-21
               (/id/video-speed): пока 48-минутный прогон жил в своей вкладке,
               две открытые из неё страницы сказали человеку «обработка
               прервалась» (run_lost_on_reload same_sid:1 при пульсе 1–3 с
               назад) и стёрли запись живого прогона. Живая вкладка отвечает за
               свою запись сама; не ответила за 600 мс — её нет. */
            var chan=null;
            try{
                if(typeof BroadcastChannel==='function'){
                    chan=new BroadcastChannel('tb-run-ledger');
                    chan.addEventListener('message',function(e){
                        var d=e&&e.data;
                        if(d&&d.q==='alive?'&&rec&&rec.t===d.t){ try{chan.postMessage({a:'alive',t:d.t});}catch(_){} }
                    });
                }
            }catch(_){ chan=null; }
            function askAlive(r,cb){
                if(!chan){cb(false);return;}
                var done=false;
                var h=function(e){ var d=e&&e.data; if(!done&&d&&d.a==='alive'&&d.t===r.t){done=true;chan.removeEventListener('message',h);cb(true);} };
                chan.addEventListener('message',h);
                try{chan.postMessage({q:'alive?',t:r.t});}catch(_){}
                setTimeout(function(){ if(!done){done=true;chan.removeEventListener('message',h);cb(false);} },600);
            }
            function pwa(){ try{ return (window.matchMedia&&matchMedia('(display-mode: standalone)').matches)||navigator.standalone===true?1:0; }catch(_){ return 0; } }
            function beat(){
                if(!rec)return;
                rec.beat=Date.now();
                if(document.visibilityState==='hidden')rec.hid=rec.beat;
                write(rec);
            }
            /* Экран не гаснет, пока идёт прогон. Wake Lock стоял в 77 тулах
               порознь и отсутствовал ровно там, где умирал 10-минутный прогон
               нейросети (/voice-enhancer, #7773). Скобка прогона — единственное
               место, которое знает «работа идёт», поэтому замок живёт здесь и
               достаётся каждому тулу с капом. Он держит ЭКРАН, не приложение:
               свёрнутую страницу iOS замораживает всё равно — на это отвечает
               заметка выше, а не замок.
               С 10.10.2026 замок — общий примитив window.__wakeLock (js/wake-lock.js,
               layout грузит его на каждой странице), под именем 'run': он проверяет,
               что экран правда держится, сам перехватывает его после ухода в фон,
               заморозки и bfcache и включает беззвучный ролик там, где API нет или
               он отказал (iPhone до 16.4, ярлык на экране iOS до 18.4, Firefox до
               126). Своя копия здесь спрашивала «есть ли объект замка» и молча
               глотала отказы — ровно то, от чего примитив сделан
               (docs/wake-lock-failure-modes.md). Нет примитива — нет и замка. */
            var lockWanted=false,lockHow=null;
            function lockAcquire(){
                if(!lockWanted)return;
                var W=window.__wakeLock;
                if(!W||typeof W.hold!=='function')return;
                try{
                    W.hold('run').then(function(how){
                        if(!lockWanted)return;
                        if(how==='api'||how==='video')lockHow=how;
                        else if(how==='none')hint('noLock');
                    },function(){});
                }catch(_){}
            }
            function lockRelease(){
                lockWanted=false;lockHow=null;
                try{ if(window.__wakeLock)window.__wakeLock.releaseHold('run'); }catch(_){}
            }
            /* Что сказать человеку на ТЕЛЕФОНЕ (10.10.2026). /video-compressor,
               «96:42» на 1 %: браузер свернули на 28-й секунде, Android заморозил
               вкладку, и шестиминутное видео стояло полтора часа. Замок держит
               экран, но не запрещает свернуть браузер — это решает человек, и
               узнать, чем это кончится, он должен ДО, а не после. Три фразы,
               каждая по своему поводу и не чаще раза:
               keep   — через 20 с прогона, раз в сутки на устройство;
               paused — вернулся в идущий прогон после заморозки ≥ 30 с; её меряют
                        часы работы (__activeGaps), а не догадка по времени в фоне;
               noLock — браузер не дал удержать экран ничем, раз на страницу. */
            var K={
                en:{keep:'While it is processing, keep the browser open and the screen on: a phone pauses a minimized tab.',
                    paused:'While the browser was minimized, processing stood still for about {min} min. Keep this page open so it runs without pauses.',
                    noLock:'This browser would not keep the screen on — while it is processing, don’t let the phone go to sleep.'},
                ru:{keep:'Пока идёт обработка, не сворачивайте браузер и не гасите экран: свёрнутую вкладку телефон останавливает.',
                    paused:'Пока браузер был свёрнут, обработка стояла около {min} мин. Чтобы она шла без пауз, держите страницу открытой.',
                    noLock:'Этот браузер не дал удержать экран включённым — пока идёт обработка, не давайте телефону заснуть.'},
                uk:{keep:'Поки триває обробка, не згортайте браузер і не гасіть екран: згорнуту вкладку телефон зупиняє.',
                    paused:'Поки браузер був згорнутий, обробка стояла близько {min} хв. Щоб вона йшла без пауз, тримайте сторінку відкритою.',
                    noLock:'Цей браузер не дав утримати екран увімкненим — поки триває обробка, не давайте телефону заснути.'},
                de:{keep:'Lassen Sie den Browser während der Verarbeitung geöffnet und den Bildschirm an: Einen minimierten Tab hält das Handy an.',
                    paused:'Während der Browser minimiert war, stand die Verarbeitung etwa {min} Min. still. Lassen Sie die Seite geöffnet, damit sie ohne Pausen läuft.',
                    noLock:'Dieser Browser hält den Bildschirm nicht an — lassen Sie das Handy während der Verarbeitung nicht in den Ruhezustand gehen.'},
                es:{keep:'Mientras se procesa, mantén el navegador abierto y la pantalla encendida: el teléfono detiene una pestaña minimizada.',
                    paused:'Mientras el navegador estuvo minimizado, el procesamiento estuvo detenido unos {min} min. Mantén esta página abierta para que avance sin pausas.',
                    noLock:'Este navegador no permitió mantener la pantalla encendida: mientras se procesa, no dejes que el teléfono se suspenda.'},
                fr:{keep:'Pendant le traitement, gardez le navigateur ouvert et l’écran allumé : le téléphone met en pause un onglet réduit.',
                    paused:'Pendant que le navigateur était réduit, le traitement est resté arrêté environ {min} min. Gardez cette page ouverte pour qu’il avance sans pause.',
                    noLock:'Ce navigateur n’a pas permis de garder l’écran allumé — pendant le traitement, ne laissez pas le téléphone se mettre en veille.'},
                pt:{keep:'Durante o processamento, mantenha o navegador aberto e a tela ligada: o celular pausa uma aba minimizada.',
                    paused:'Enquanto o navegador ficou minimizado, o processamento ficou parado por cerca de {min} min. Mantenha esta página aberta para que avance sem pausas.',
                    noLock:'Este navegador não permitiu manter a tela ligada — durante o processamento, não deixe o celular entrar em repouso.'},
                id:{keep:'Selama pemrosesan berjalan, biarkan peramban tetap terbuka dan layar menyala: ponsel menghentikan tab yang diminimalkan.',
                    paused:'Selama peramban diminimalkan, pemrosesan berhenti sekitar {min} menit. Biarkan halaman ini terbuka agar berjalan tanpa jeda.',
                    noLock:'Peramban ini tidak mengizinkan layar tetap menyala — selama pemrosesan, jangan biarkan ponsel tertidur.'},
                ko:{keep:'처리하는 동안 브라우저를 열어 두고 화면을 켜 두세요. 최소화된 탭은 휴대폰이 멈춥니다.',
                    paused:'브라우저가 최소화된 동안 처리가 약 {min}분 멈춰 있었습니다. 멈춤 없이 진행되도록 이 페이지를 열어 두세요.',
                    noLock:'이 브라우저에서는 화면을 켜 둘 수 없습니다. 처리하는 동안 휴대폰이 잠자기 모드로 들어가지 않게 해 주세요.'},
                ar:{keep:'أثناء المعالجة أبقِ المتصفح مفتوحًا والشاشة مضاءة: الهاتف يوقف علامة التبويب المصغّرة.',
                    paused:'أثناء تصغير المتصفح توقفت المعالجة نحو {min} دقيقة. أبقِ هذه الصفحة مفتوحة لتستمر دون توقف.',
                    noLock:'لم يسمح هذا المتصفح بإبقاء الشاشة مضاءة — أثناء المعالجة لا تدع الهاتف يدخل في وضع السكون.'}
            };
            var KEEP_KEY='tmb_keep_open_hint',KEEP_AFTER_MS=20000,PAUSED_MIN_MS=30000,SCREEN_EVENT_MIN_S=60;
            var hinted={},keepTimer=null,hideAt=0,hideGaps=0,runHidMs=0,runFrzMs=0,runDrops0=0;
            function gapsMs(){ try{ return window.__activeGaps?window.__activeGaps().ms:0; }catch(_){ return 0; } }
            function hint(k,min){
                if(!MOB||hinted[k])return;
                hinted[k]=1;
                try{
                    var L=K[loc()]||K.en;
                    if(window.__toast)window.__toast(String(L[k]||K.en[k]).replace('{min}',String(min||1)),'warning');
                    if(window.__ae)window.__ae('feature_use',{slug:_tool,action:'run_hint',hint:k});
                }catch(_){}
            }
            function keepHint(){
                keepTimer=null;
                if(!rec||document.visibilityState!=='visible')return;
                try{
                    var day=new Date().toISOString().slice(0,10);
                    if(localStorage.getItem(KEEP_KEY)===day)return;
                    localStorage.setItem(KEEP_KEY,day);
                }catch(_){ return; }
                hint('keep');
            }
            /* Уход в фон и возврат внутри прогона: сколько страница простояла
               (frozen) — на телефоне сказать, итог — в run_screen. */
            function runHidden(){ if(!hideAt){hideAt=Date.now();hideGaps=gapsMs();} }
            function runShown(){
                if(!hideAt)return;
                var hid=Date.now()-hideAt,frz=Math.max(0,gapsMs()-hideGaps);
                hideAt=0;runHidMs+=hid;runFrzMs+=frz;
                if(frz>=PAUSED_MIN_MS){
                    try{ if(window.__ae)window.__ae('feature_use',{slug:_tool,action:'run_paused_hidden',hid_s:Math.round(hid/1000),frz_s:Math.round(frz/1000),mob:MOB}); }catch(_){}
                    hint('paused',Math.max(1,Math.round(frz/60000)));
                }
            }
            /* Удержался ли экран за прогон — одно событие на прогон от минуты:
               чем держали (api | video | none), сколько раз терялся, сколько
               страница была в фоне и сколько из этого стояла. Отвечает на
               вопрос «гаснет ли экран посреди обработки» по платформам. */
            function screenReport(){
                if(!rec)return;
                var dur=Math.round((Date.now()-rec.t)/1000);
                if(dur<SCREEN_EVENT_MIN_S)return;
                try{
                    var st=window.__wakeLock?window.__wakeLock.state():null;
                    if(window.__ae)window.__ae('feature_use',{slug:_tool,action:'run_screen',phase:rec.phase,dur_s:dur,
                        held:st?(st.mode||'none'):'absent',drops:st?Math.max(0,st.drops-runDrops0):0,esc:st&&st.escalated?1:0,
                        hid_s:Math.round(runHidMs/1000),frz_s:Math.round(runFrzMs/1000),mob:MOB,pwa:pwa()});
                }catch(_){}
            }
            /* Вопрос браузера «точно уйти?» — тому же хозяину, что и замок
               экрана: скобка прогона знает, что работа идёт, и знает это за
               все тулы разом. До 12.09.2026 `__unsavedWork` вооружали ПЯТЬ
               тулов из двух сотен, и /auto-captions среди них не было —
               человек закрывал вкладку посреди сорокаминутной расшифровки без
               единого вопроса (RU, 30 дней: 35 657 сессий ушли со страницы
               посреди работы и ни с чем, медиана времени на странице 18 мин).
               Вооружаем не сразу: прогон короче WARN_AFTER_MS — это работа, о
               которой спрашивать нечего, а диалог на каждый трёхсекундный
               прогон был бы чистым шумом. Чужой заслон не трогаем: тул,
               вооруживший свой (join, enhance-video, …), владеет им сам. */
            var WARN_AFTER_MS=20000;
            var warnTimer=null,warnOurs='';
            function warnArm(){
                if(warnTimer||warnOurs)return;
                warnTimer=setTimeout(function(){
                    warnTimer=null;
                    try{
                        var U=window.__unsavedWork;
                        if(!rec||!U||U.isArmed())return;
                        warnOurs='run:'+(rec.slug||'');
                        U.arm(warnOurs);
                    }catch(_){}
                },WARN_AFTER_MS);
            }
            function warnRelease(){
                if(warnTimer){clearTimeout(warnTimer);warnTimer=null;}
                if(!warnOurs)return;
                try{
                    var U=window.__unsavedWork;
                    if(U&&U.isArmed()&&U.reason()===warnOurs)U.disarm();
                }catch(_){}
                warnOurs='';
            }
            function open(extra){
                if(!_tool)return;
                if(rec){
                    // A run opening over a decode-phase record (AudioDecoderRobust
                    // brackets every decode, 2026-09-12) takes it over: the note
                    // and the event then describe the run, not the decode.
                    if(rec.phase==='decode'&&!(extra&&extra.phase)){rec.phase='run';write(rec);}
                    return;
                }
                rec={v:1,slug:_tool,url:location.pathname,t:Date.now(),beat:Date.now(),hid:0,
                     sid:sid(),files:files.slice(0,3),mob:MOB,pwa:pwa(),phase:(extra&&extra.phase)||'run'};
                write(rec);
                if(!beatTimer)beatTimer=setInterval(beat,BEAT_MS);
                // часы работы заводятся первым чтением — без него заморозку не увидеть
                try{ if(window.__activeNow)window.__activeNow(); }catch(_){}
                hideAt=0;runHidMs=0;runFrzMs=0;
                try{ runDrops0=window.__wakeLock?window.__wakeLock.state().drops:0; }catch(_){ runDrops0=0; }
                if(MOB&&!keepTimer)keepTimer=setTimeout(keepHint,KEEP_AFTER_MS);
                lockWanted=true;lockAcquire();warnArm();
            }
            function runEnd(){
                if(keepTimer){clearTimeout(keepTimer);keepTimer=null;}
                if(rec){ if(hideAt)runShown(); screenReport(); }
            }
            function close(){
                if(beatTimer){clearInterval(beatTimer);beatTimer=null;}
                runEnd();
                if(rec){rec=null;wipe();}
                lockRelease();warnRelease();
            }
            // Имена файлов — из события общего аплоадера (оно всплывает до document).
            // Нужны только для фразы «Обработка файла «X»»; без них фраза короче.
            document.addEventListener('tool-uploader:file',function(e){
                try{
                    var d=e.detail||{};var fs=d.files||(d.file?[d.file]:[]);var names=[];
                    for(var i=0;i<fs.length&&i<3;i++)if(fs[i]&&fs[i].name)names.push(String(fs[i].name).slice(0,80));
                    if(names.length)files=names;
                }catch(_){}
            });
            document.addEventListener('tool-uploader:clear',function(){files=[];});
            document.addEventListener('visibilitychange',function(){ if(rec&&document.visibilityState==='hidden'){beat();runHidden();} else if(rec){runShown();lockAcquire();} });
            /* Уход помечает запись и оставляет её жить. Убитый рендерер этого
               события не шлёт вовсе — по отсутствию метки `left` и отличается
               смерть от ухода, и оба класса дальше считаются отдельно.
               persisted=true — это bfcache: страница может вернуться живой и
               прогон продолжится, поэтому там всё как раньше. */
            function leave(){
                if(!rec){close();return;}
                runEnd();
                rec.left=Date.now();rec.beat=rec.left;write(rec);
                if(beatTimer){clearInterval(beatTimer);beatTimer=null;}
                rec=null;lockRelease();warnRelease();
            }
            window.addEventListener('pagehide',function(e){ if(e&&e.persisted)close(); else leave(); });
            /* …и вернулась. Возврат «Назад» из bfcache посреди прогона: работа тула
               продолжается с того же кадра (скобка __runMark жива), а запись,
               удержание экрана и «точно уйти?» сняты close() на уходе и сами не
               возвращались — остаток прогона шёл без них. Возврат №48 (iPhone,
               /audio-to-video, 15.10.2026): «Что нового» на 5-й минуте экспорта,
               «Назад» — и ещё 12,5 мин рендера экран никто не держал. Chromium
               такую страницу в bfcache не кладёт (удержание экрана — блокер), Safari
               кладёт и возвращает живой. */
            window.addEventListener('pageshow',function(e){ if(e&&e.persisted&&window.__runMark&&window.__runMark.active())open(); });

            function loc(){ return (window.__LOCALE||document.documentElement.lang||'en').substring(0,2); }
            function phrase(r,here){
                var L=T[loc()]||T.en;
                var name=(r.files&&r.files[0])||'';
                var s=(name?L.h.replace('{name}',name):L.h0)+(r.left?(L.tailLeft||L.tail):L.tail);
                if(r.mob||MOB)s+=' '+L.phone;
                // A tool that counts runs a day takes the unit for a finished result only — and a
                // person who had one run and lost it fears it is gone («эх, была одна бесплатная
                // попытка, да и та сорвалась», 13.10.2026, /sheet-music-to-midi: the run died after
                // 180 s, the unit was still there, and the person never tried again). Said only
                // where the limit itself says one is left.
                try{
                    var TL=window.__toolLimit,left=TL&&typeof TL.remaining==='function'?TL.remaining(r.slug):Infinity;
                    if(L.unspent&&isFinite(left)&&left>0)s+=' '+L.unspent;
                }catch(_){}
                // The tool has a server lane (config/server-lane.php → the limit
                // block carries data-tl-server-lane): the note names the way out.
                try{
                    var tl=here?document.querySelector('[data-tool-limit][data-tl-server-lane]'):null;
                    if(tl&&L.server)s+=' '+L.server.replace(':plan',tl.getAttribute('data-tl-plan-paid')||'Premium');
                }catch(_){}
                return s;
            }
            function toastFallback(box,text){
                try{
                    requestAnimationFrame(function(){
                        var rr=box.getBoundingClientRect();
                        var seen=rr.width>0&&rr.height>0&&rr.bottom>0&&rr.top<(window.innerHeight||0);
                        if(!seen&&window.__toast)window.__toast(text,'warning');
                    });
                }catch(_){}
            }
            function show(r,here){
                var L=T[loc()]||T.en;
                var text=phrase(r,here);
                var box=document.createElement('div');
                box.className='tu-pick-help tu-run-lost';
                box.setAttribute('role','status');
                box.setAttribute('aria-live','polite');
                var p=document.createElement('p');
                p.className='tu-pick-help-text';
                p.textContent=text;
                box.appendChild(p);
                var zone=here?document.querySelector('.tool-uploader'):null;
                if(zone){
                    var input=zone.querySelector('input[type=file]')||document.querySelector('input[data-uploader-for="'+zone.id+'"]');
                    if(input){
                        var btn=document.createElement('button');
                        btn.type='button';btn.className='tu-pick-help-btn';btn.textContent=L.btn;
                        btn.addEventListener('click',function(){
                            try{window.__ae&&window.__ae('feature_use',{slug:_tool,f:'run_lost_retry'});}catch(_){}
                            input.click();
                        });
                        box.appendChild(btn);
                    }
                    (zone.parentNode||document.body).insertBefore(box,zone.nextSibling);
                    // Файл выбран заново — заметка своё сказала.
                    zone.addEventListener('tool-uploader:file',function(){ if(box.parentNode)box.parentNode.removeChild(box); });
                }else{
                    if(r.url&&r.url!==location.pathname){
                        var a=document.createElement('a');
                        a.className='tu-pick-help-btn';a.style.display='inline-block';a.style.textDecoration='none';
                        a.href=r.url;a.textContent=L.back;
                        a.addEventListener('click',function(){ try{window.__ae&&window.__ae('feature_use',{slug:r.slug,f:'run_lost_back'});}catch(_){} });
                        box.appendChild(a);
                    }
                    var host=document.querySelector('main .tool-intro, main h1, main')||document.body;
                    if(host.tagName==='MAIN')host.insertBefore(box,host.firstChild);
                    else host.parentNode.insertBefore(box,host.nextSibling);
                }
                toastFallback(box,text);
            }
            function verdict(r,now){
                // Чистая функция — её проверяет сторож. null = молчать.
                if(!r||!r.t||!r.beat)return null;
                var age=now-r.t;
                if(age<0||age>MAX_AGE_MS)return {kind:'expired'};
                var same=!!r.sid&&r.sid===sid();
                if(r.left){
                    /* Ушёл сам. Разделитель — ПАУЗА, а не способ ухода:
                       вернулся сразу (перезагрузил, кликнул ссылку и назад) —
                       он видел, что делал, и заметка была бы шумом; вернулся
                       позже — он ищет результат. */
                    var away=now-r.left;
                    if(away<0)return {kind:'expired'};
                    if(away<LEFT_GRACE_MS)return {kind:'returned'};
                    var ranL=Math.round((r.left-r.t)/1000);
                    if(ranL<LEFT_MIN_RAN_S)return {kind:'returned'};
                    return {kind:'left',same:same?1:0,age_s:Math.round(away/1000),ran_s:ranL,
                            hidden:r.hid?1:0,hid_s:r.hid?Math.round((r.left-r.hid)/1000):0};
                }
                var sinceBeat=now-r.beat;
                if(!same&&sinceBeat<DEAD_AFTER_MS)return {kind:'alive'};   // соседняя вкладка ещё бьётся
                return {kind:'lost',same:same?1:0,age_s:Math.round(sinceBeat/1000),ran_s:Math.round((r.beat-r.t)/1000),
                        hidden:r.hid?1:0,hid_s:r.hid?Math.round((r.beat-r.hid)/1000):0};
            }
            function announce(r,v){
                wipe();
                var here=r.slug===_tool;
                var nav='';try{var n=performance.getEntriesByType('navigation')[0];nav=(n&&n.type)||'';}catch(_){}
                var payload={slug:r.slug,f:r.left?'run_left_unfinished':'run_lost_on_reload',here:here?1:0,same_sid:v.same,age_s:v.age_s,ran_s:v.ran_s,
                             hidden:v.hidden,hid_s:v.hid_s,nav:nav,mob:r.mob||0,pwa:r.pwa||0,phase:r.phase||'run',step:r.step||undefined,step_s:r.step?Math.max(0,Math.round((r.beat-(r.stepAt||r.t))/1000)):undefined,dm:navigator.deviceMemory||0,
                             files:(r.files&&r.files.length)||0,page:_tool||location.pathname};
                var send=function(){ try{ if(window.__ae){window.__ae('feature_use',payload);return true;} }catch(_){} return false; };
                if(!send())setTimeout(send,2000);
                try{show(r,here);}catch(_){}
            }
            function check(){
                var r=read();
                if(!r)return;
                var v=verdict(r,Date.now());
                if(!v)return wipe();
                if(v.kind==='expired')return wipe();
                if(v.kind==='returned')return wipe();   // он и так знает, что ушёл — молчим
                if(v.kind==='left')return announce(r,v);
                if(v.kind==='lost'&&v.same&&Date.now()-r.beat<DEAD_AFTER_MS){
                    askAlive(r,function(alive){
                        if(alive){ try{window.__ae&&window.__ae('feature_use',{slug:r.slug,f:'run_ledger_live_clone',age_s:v.age_s});}catch(_){} return; }
                        /* Молчание за 600 мс — ещё не смерть. Занятая вкладка (прогон
                           гонит задачи по сотням мс, телефон под нагрузкой) отвечает
                           позже, а наш собственный таймер на загрузке страницы может
                           встать в очередь раньше её ответа. Замер 01.10.2026: живая
                           вкладка с задачами по 800 мс — «прервалась» и стёртая запись
                           (300 мс — ответ успевает); прод 28.09–01.10: 1 928 таких
                           вердиктов (same_sid, пульс ≤ 5 с), и у 780 исходная страница
                           ещё работала — выдавала события прогона без нового файла;
                           ответ `run_ledger_live_clone` за 7 дней пришёл 37 раз
                           (обращение #1794: «прервалась» на двух соседних страницах,
                           пока склейка шла). Живая вкладка бьётся раз в BEAT_MS —
                           ждём, когда удар ДОЛЖЕН был прийти, и спрашиваем ещё раз. */
                        setTimeout(function(){
                            var r2=read();if(!r2||r2.t!==r.t)return;
                            if(rec)return;                      // это уже наш собственный прогон
                            if(r2.beat>r.beat){ try{window.__ae&&window.__ae('feature_use',{slug:r.slug,f:'run_ledger_live_beat',age_s:v.age_s});}catch(_){} return; }
                            askAlive(r2,function(alive2){
                                if(alive2){ try{window.__ae&&window.__ae('feature_use',{slug:r.slug,f:'run_ledger_live_clone',age_s:v.age_s,late:1});}catch(_){} return; }
                                var r3=read();if(!r3||r3.t!==r.t)return;
                                var v3=verdict(r3,Date.now());
                                if(v3&&v3.kind==='lost')announce(r3,v3);
                            });
                        },Math.max(0,r.beat+BEAT_MS+1500-Date.now()));
                    });
                    return;
                }
                if(v.kind==='alive'){
                    // Свежий пульс при чужом sid: либо соседняя вкладка, либо мы
                    // открылись через секунды после смерти. Полминуты решат.
                    setTimeout(function(){
                        var r2=read();if(!r2||r2.t!==r.t)return;
                        if(rec)return;                      // это уже наш собственный прогон
                        var v2=verdict(r2,Date.now());
                        if(v2&&v2.kind==='lost')announce(r2,v2);
                    },RECHECK_MS);
                    return;
                }
                announce(r,v);
            }
            if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(check,0);});
            else setTimeout(check,0);
            /* Шаг внутри прогона (29.10.2026, заявка на возврат №56): строка
               run_lost_on_reload говорила «умер во время прогона» и не говорила,
               НА ЧЁМ. /music-genre-detector на iPhone терял половину запусков в
               Safari, и место смерти восстанавливалось только по времени.
               step(name) кладёт имя в запись прогона; строка потери несёт его
               (step) и сколько секунд прогон провёл в нём (step_s, по пульсу). */
            function step(name){
                if(!rec)return;
                rec.step=String(name||'').slice(0,32);rec.stepAt=Date.now();write(rec);
            }
            return {open:open,close:close,step:step,verdict:verdict,KEY:KEY,active:function(){return !!rec;},wakeLockHeld:function(){try{var s=window.__wakeLock&&window.__wakeLock.state();return !!(lockWanted&&s&&s.held);}catch(_){return false;}}};
        })();
        window.__runMark=(function(){
            var n=0,startedAt=0,everStarted=0,lastEndedAt=0,runT0=0,lastRunMs=0;
            /* Сколько шла последняя закрытая скобка. Нужно двери скачивания: результат
               работы, стоившей минут, она держит страховочной копией до подтверждённой
               выдачи (timbrica-core.js, _costlyRun). Своя метка начала — startedAt
               обнуляется раньше, чем скобка успевает сказать, сколько шла. */
            function settle(){ if(runT0){lastRunMs=Date.now()-runT0;runT0=0;} }
            function end(){
                if(n<=0)return;
                if(n===1)settle();
                if(--n===0){startedAt=0;lastEndedAt=Date.now();try{window.__runLedger&&window.__runLedger.close();}catch(_){}}
            }
            return {
                /* Возвращает функцию-закрывашку; она идемпотентна, поэтому
                   двойной вызов (например `finally` поверх явного abort) не
                   уводит счётчик в минус. */
                begin:function(){
                    if(n++===0){startedAt=Date.now();try{window.__runLedger&&window.__runLedger.open();}catch(_){}runT0=startedAt;}
                    everStarted++;
                    /* Новый прогон — новый результат: дверь скачивания снова вправе его объявить. */
                    try{window.__resultDoor&&window.__resultDoor.fresh();}catch(_){}
                    var done=false;
                    return function(){ if(done)return; done=true; end(); };
                },
                active:function(){return n>0;},
                /* Секунд с начала САМОГО РАННЕГО незакрытого прогона. 0 = не идёт. */
                since:function(){return startedAt?Math.round((Date.now()-startedAt)/1000):0;},
                started:function(){return everStarted;},
                endedAt:function(){return lastEndedAt;},
                /* Секунд шла последняя ЗАКРЫТАЯ скобка (0 — закрытых не было). */
                lastRun:function(){return Math.round(lastRunMs/1000);},
                /* Терминальная стадия: всё, что тул не закрыл, закрыто. */
                reset:function(){ n=0;startedAt=0;lastEndedAt=Date.now();try{window.__runLedger&&window.__runLedger.close();}catch(_){} settle(); }
            };
        })();

        /* Момент, когда туда-сюда поднялась СТЕНА капа. Ставит
           `tool-usage-limit.js` (showNote). Отдельный исход, а не разновидность
           «бросил»: человеку отказали, и работу он не начинал. */
        window.__limitWallAt=window.__limitWallAt||0;

        var _STAGE_TERMINAL = /^(complete|abandoned)$/;
        var _STAGE_LATE_NOISE = /^(error|stalled|wasm_load_failed|init_failed|all_attempts_failed|abandoned)$/;

        window.__stage=function(stage,meta){
            if(!_tool||!stage)return;
            var now=Date.now();
            // Weak dedup: identical same-stage calls within 500 ms collapse. Prevents
            // accidental double-fires when both auto-wiring (FFmpegProcessor) and a
            // blade's own manual __stage() call cover the same transition. This is
            // also what collapses __aeToolError's deferred auto `error` stage when
            // the tool has already staged its own (richer, reason-tagged) error —
            // the auto call is a fallback and __aeToolError defers it a microtask
            // so the tool's synchronous __stage('error',{reason}) always lands
            // first; this dedup then drops the redundant auto one.
            if(stage===_lastStage&&(now-_lastFireAt)<500)return;
            if(_lastStage&&_STAGE_TERMINAL.test(_lastStage)&&_STAGE_LATE_NOISE.test(stage)&&stage!==_lastStage){
                try{window.__ae('tool_stage_late_noise',{slug:_tool,after:_lastStage,attempt:stage,dwell_ms:now-_lastAt})}catch(_){}
                return;
            }
            var dwell=now-_lastAt;
            var payload={slug:_tool,from:_lastStage,to:stage,dwell_ms:dwell};
            if(meta&&typeof meta==='object')for(var k in meta)payload[k]=meta[k];
            if(window.__ae)try{window.__ae('tool_stage',payload)}catch(_){}
            if(/^(error|stalled|abandoned|wasm_load_failed|init_failed|all_attempts_failed)$/.test(stage)){
                try{window.__aeCritical('tool_stage_'+stage,payload)}catch(_){}
            }
            // Тул объявил конец — закрываем скобку прогона, даже если он
            // забыл вызвать abort()/commit() на этом пути. См. __runMark.
            if(/^(complete|error|idle|cancelled|abandoned|done)$/.test(stage)){
                try{window.__runMark&&window.__runMark.reset()}catch(_){}
            }
            _lastStage=stage;_lastAt=now;_lastFireAt=now;
            // Mirror to a stable window slot so the tool_abandon emitter
            // (separate IIFE further down) can attach the funnel stage to its
            // payload. Without this, tool_abandon ships as `{slug, d}` with
            // no clue where in the funnel the user gave up — 313 of the last
            // 30 days' audio-to-notes abandons had this dark payload.
            window.__lastStage=stage;
            // Время входа в стадию — рядом с её именем и по той же причине.
            // Из него сборщик ухода выводит run_elapsed_s для тулов, которые
            // не публикуют собственных часов (а таких почти все: за неделю
            // поле было ненулевым у 154 событий из 98792, потому что
            // window.__runElapsed объявлял РОВНО ОДИН тул).
            window.__lastStageAt=now;
        };
        window.addEventListener('pagehide',function(){
            if(!_lastStage||_lastStage==='complete'||_lastStage==='idle')return;
            try{window.__aeCritical('tool_stage_final',{slug:_tool,stage:_lastStage,dwell_ms:Date.now()-_lastAt})}catch(_){}
        });
        /* Конец работы — тоже без согласия (09.10.2026, отзыв #1822 на /speed).
           Настоящий __aeToolComplete и слушатель `file-downloaded` ставит IIFE
           согласия ниже, а при DNT, отказе или открытом баннере она выходит
           раньше них. Тул звал `window.__aeToolComplete()` в try и молча падал,
           стадия оставалась `processing`, и tool_stage_final на уходе называл
           «брошенной обработкой» работу, которая отдала файл: у автора #1822
           (DNT) три «зависания» по 69–292 с не отличались от трёх скачиваний.
           Форма та же, что у настоящей: __ae('tool_complete') + стадия. __ae
           без согласия — пустышка, данных не уходит, но всегда-включённое
           зеркало ниже разошлёт свой сигнал «тул выдал результат» (указатель
           на скачивание, сброс серии обрывов; имя события здесь не пишем —
           ResultCueWiringTest ищет его первое вхождение у зеркала). Два
           объявления одного результата (скачивание и
           вызов тула) сливаются в одно, как дебаунс _sendComplete. С согласием
           IIFE ниже заменит функцию и поставит стадию сама. */
        if(typeof window.__aeToolComplete!=='function'){
            var _t0CompleteAt=0;
            window.__aeToolComplete=function(p){
                var now=Date.now();
                if(now-_t0CompleteAt<1500)return;
                _t0CompleteAt=now;
                try{window.__ae&&window.__ae('tool_complete',Object.assign({slug:_tool},p||{}))}catch(_){}
                try{window.__stage('complete',p||{})}catch(_){}
            };
        }
        /* __resultDoor:begin */
        /* Дверь скачивания — НЕ второй «результат» (16.10.2026).
           До этой даты каждый `file-downloaded` сам становился `tool_complete`
           (и стадией `complete`) с полем `name` — ИМЕНЕМ ФАЙЛА. Прод RU, 7 дней:
           22 % всех tool_complete несли имя, из них 40 % не латиницей — имена
           записей, учеников, классов, то есть текст человека в аналитике; а
           45 733 события (9,9 % всех tool_complete, 365 тулов) были ВТОРЫМ
           «результатом» того же прогона: тул уже объявил свой, человек нажал
           «Скачать» позже окна слияния (800 мс) или скачал ещё раз. Счётные
           панели (TelemetryTool, конверсия /pino/streams) делили на это число.

           Правило: результат объявляет ТУЛ; дверь объявляет его только там,
           где тул промолчал (2,8 % пар сессия×тул — 178 тулов отдают файл и
           больше ничего не говорят), и только раз на одну выдачу:
             · открыто окно слияния `_sendComplete` → поля двери дописываются в
               ТО ЖЕ событие (только недостающие: тул свой размер знает лучше);
             · в этой работе результат уже объявлен не дверью → молчим (доставку
               считает `file_download` примитива — ему и место);
             · тот же файл (расширение + размер) дверь уже объявила → молчим;
             · иначе — одно событие `{src:'download', ext, via, size}`.
           Работа начинается заново, когда выбран файл, открыта рабочая область
           или начат прогон (`__runMark.begin`) — следующий файл того же тула
           снова получает свой результат.
           Имени файла в событии нет нигде: только `ext` — тот же признак, что
           у `file_download` (DeliveryFormatCensus). Решение живёт здесь, во
           всегда-включённой части: им пользуются обе ветки — с согласием и без.
           Ветки решения держит tests/js/result-door.test.mjs, разбор —
           docs/why/primitives/result-door.md. */
        window.__resultDoor=(function(){
            var own=false,keys={};
            function extOf(n){var m=/\.([A-Za-z0-9]{1,8})$/.exec(String(n||''));return m?m[1].toLowerCase():'';}
            function fresh(){own=false;keys={};}
            /* Отпечаток скопированного текста — только для «тот же ли»: в
               событие уходит длина, не текст и не отпечаток. */
            function hashOf(t){var h=5381;for(var i=0;i<t.length;i++)h=((h<<5)+h+t.charCodeAt(i))|0;return h;}
            return {
                fresh:fresh,
                /* Объявление результата прошло через зеркало `__ae`. Своё — всё,
                   что пришло не от двери (вызов тула, блоб-трекер, экран). */
                said:function(p){if(!(p&&(p.src==='download'||p.src==='copy')))own=true;},
                /* «Копировать» — та же дверь, что «Скачать» (16.10.2026, волна 2).
                   До этой даты обёртка буфера обмена слала `tool_complete{action:
                   'copy'}` на КАЖДОЕ копирование, мимо окна слияния: прод RU, 7 дней —
                   30 608 таких событий (6,6 % всех tool_complete, 173 тула), из них
                   27 704 в парах сессия×тул, где тул свой результат уже объявил
                   (/fancy-text: 15 415 копирований при одном результате на сессию по
                   замыслу тула; /russian-word-analysis: разбор, потом «Копировать»).
                   Единственный сигнал копирование давало в 1 282 парах (85 тулов —
                   калькуляторы, генераторы): там оно и остаётся результатом.
                   Ветки те же, что у файла: окно открыто — дописать; тул уже сказал —
                   молчать; тот же текст ещё раз — молчать; иначе — одно событие. */
                copy:function(text,pending,types){
                    var t=String(text==null?'':text);
                    /* types — копия не текста (navigator.clipboard.write, картинка): в событие — типы, ключ повтора — они же. */
                    var p=types?{action:'copy',kind:String(types).slice(0,60)}:{action:'copy',chars:t.length};
                    if(pending)return {act:'merge',p:p};
                    if(own)return {act:'skip',why:'said',p:p};
                    var k=types?('item|'+types):('copy|'+t.length+'|'+hashOf(t));
                    if(keys[k])return {act:'skip',why:'again',p:p};
                    keys[k]=1;
                    p.src='copy';
                    return {act:'complete',p:p};
                },
                /* Одна выдача файла. pending — у `_sendComplete` открыто окно слияния. */
                door:function(d,pending){
                    d=d||{};
                    var p={},x=extOf(d.name);
                    if(x)p.ext=x;
                    if(d.via)p.via=String(d.via).slice(0,24);
                    if(d.size>0)p.size=d.size;
                    if(pending)return {act:'merge',p:p};
                    if(own)return {act:'skip',why:'said',p:p};
                    var k=(x||'?')+'|'+(d.size||0);
                    if(keys[k])return {act:'skip',why:'again',p:p};
                    keys[k]=1;
                    p.src='download';
                    return {act:'complete',p:p};
                }
            };
        })();
        try{
            document.addEventListener('tmb:tool-complete',function(e){window.__resultDoor.said(e&&e.detail);});
            var _rdFresh=function(){window.__resultDoor.fresh();};
            document.addEventListener('change',function(e){var t=e.target;if(t&&t.type==='file'&&t.files&&t.files.length)_rdFresh();},true);
            document.addEventListener('drop',function(e){var f=e.dataTransfer&&e.dataTransfer.files;if(f&&f.length)_rdFresh();},true);
            document.addEventListener('tool-uploader:file',_rdFresh,true);
            window.addEventListener('workspace-activated',_rdFresh);
        }catch(_){}
        /* Стадия `complete` идёт за выдачей файла всегда: забравший файл не
           «бросил обработку» (#1822), даже когда сам результат уже объявлен. */
        window.__resultDoorStage=function(p){
            if(window.__lastStage==='complete')return;
            try{window.__stage('complete',(p&&p.action==='copy')?{src:'copy'}:{src:'download',ext:(p&&p.ext)||''})}catch(_){}
        };
        /* __resultDoor:end */
        /* Программная выдача `<a download>.click()` → `file-downloaded` на window.
           Это ШИНА, а не аналитика: на ней тост «Файл сохранён», история
           скачиваний, счётчик медалей, `_hasResult` и стадия `complete`. До
           16.10.2026 патч стоял за согласием на аналитику, и у отказавшихся
           (cookie_consent=declined, DNT) классическая выдача — главный канал
           десктопа — не давала НИ ОДНОГО из них (стенд: Chromium и WebKit,
           declined — 0 событий, тоста нет, стадия не сменилась; принято — 1).
           Размер едет, когда анкер создал примитив (`__dlSize`): по нему дверь
           отличает повтор того же файла от нового. */
        if(_tool){
            var _origAClick=HTMLAnchorElement.prototype.click;
            HTMLAnchorElement.prototype.click=function(){
                if(this.download){
                    try{window.dispatchEvent(new CustomEvent('file-downloaded',{detail:{name:this.download,size:this.__dlSize||0}}))}catch(e){}
                }
                return _origAClick.apply(this,arguments);
            };
        }
        window.addEventListener('file-downloaded',function(e){
            if(typeof window.__consentOK==='function'&&window.__consentOK())return;
            var d=window.__resultDoor.door(e&&e.detail,false);
            if(d.act==='complete'){try{window.__aeToolComplete(d.p)}catch(_){}}
            else window.__resultDoorStage(d.p);
        });
        /* __copyBus:begin */
        /* «Копировать» — шина, как у выдачи файла (17.10.2026, волна 3).
           До этой даты дверь видела только navigator.clipboard.writeText, и только у тех, кто
           согласился на аналитику. Прибор copy-paths-bench (5 тулов × Chromium/WebKit, жест —
           настоящий клик): копия через document.execCommand('copy') без writeText и копия
           КАРТИНКИ (navigator.clipboard.write([ClipboardItem]) — /qr-code, /screenshot, /merge-images
           и ещё 24 файла) не доходили до двери 10 из 10; у отказавшихся от аналитики копия не
           ставила стадию complete вовсе — tier-0 считал «брошенной обработкой» того, кто
           результат забрал. Прод RU, 30 дней: /merge-images — 37 сессий с копией картинки, в 17
           из них других результатов нет.
           Здесь три входа в буфер обмена — writeText, write(ClipboardItem) и execCommand('copy')
           (текст — ровно тот, что ушёл в буфер: выделение поля в событии copy во время вызова) —
           превращаются в одно событие `tmb:result-copy`; решает дверь (window.__resultDoor.copy):
           тот же текст или картинка ещё раз — молчать, тул уже сказал — молчать. Ручное Ctrl+C
           по тексту страницы — НЕ результат (абзац FAQ иначе стал бы «результатом»: вариант
           «событие copy на документе» дал такой ложный результат в 5 из 10). Своя ссылка
           (приглашение) — не результат. Без согласия — только стадия complete, как у выдачи. */
        (function(){
            function selfLink(t){return typeof t==='string'&&t.indexOf(location.origin)===0;}
            /* window.__copyNotResult — тул копирует ПОБОЧНЫЙ продукт (текст, прочитанный с картинки,
               найденный на ней код или ссылку), а не свой результат: флаг ставится синхронно вокруг
               вызова буфера обмена, и шина молчит. /screen-photo-fix 04.11.2026: копия текста с
               экрана считалась завершением, и одна фотография давала два-три tool_complete. */
            function emit(d){if(window.__copyNotResult)return;try{window.dispatchEvent(new CustomEvent('tmb:result-copy',{detail:d}));}catch(_){}}
            var c=navigator.clipboard;
            try{
                if(c&&typeof c.writeText==='function'){
                    var ow=c.writeText;
                    c.writeText=function(t){
                        try{if(typeof t==='string'&&t&&!selfLink(t))emit({text:t});}catch(_){}
                        return ow.apply(this,arguments);
                    };
                }
                if(c&&typeof c.write==='function'){
                    var owr=c.write;
                    c.write=function(items){
                        try{
                            var ty=[];
                            for(var i=0;items&&i<items.length;i++){var it=items[i];for(var j=0;it&&it.types&&j<it.types.length;j++)ty.push(String(it.types[j]));}
                            if(ty.length)emit({types:ty.sort().join(',')});
                        }catch(_){}
                        return owr.apply(this,arguments);
                    };
                }
            }catch(_){}
            try{
                var oe=document.execCommand,seen=null;
                document.addEventListener('copy',function(e){
                    if(seen===null)return;
                    try{
                        var el=e.target,t='';
                        if(el&&(el.tagName==='TEXTAREA'||el.tagName==='INPUT')&&typeof el.selectionStart==='number')t=el.value.substring(el.selectionStart,el.selectionEnd);
                        if(!t){var all=document.querySelectorAll('textarea,input');for(var i=all.length-1;i>=0;i--){var a=all[i];try{if(typeof a.selectionStart==='number'&&a.selectionEnd>a.selectionStart){t=a.value.substring(a.selectionStart,a.selectionEnd);break;}}catch(_){}}}
                        if(!t)t=String(document.getSelection?document.getSelection():'');
                        seen=t;
                    }catch(_){}
                },true);
                document.execCommand=function(cmd){
                    var copy=String(cmd).toLowerCase()==='copy';
                    if(copy)seen='';
                    var r;
                    try{r=oe.apply(document,arguments);}finally{var t=seen;seen=null;if(copy&&r&&t&&!selfLink(t))emit({text:t,via:'exec'});}
                    return r;
                };
            }catch(_){}
        })();
        window.addEventListener('tmb:result-copy',function(e){
            if(!_tool)return;
            if(typeof window.__consentOK==='function'&&window.__consentOK())return;
            var dd=(e&&e.detail)||{};
            var d=window.__resultDoor.copy(dd.text,false,dd.types);
            if(d.act==='complete'){try{window.__aeToolComplete(d.p)}catch(_){}}
            else window.__resultDoorStage(d.p);
        });
        /* __copyBus:end */
        /* Reusable stall-guard: wrap any FFmpeg call that should abort after N ms
           of no progress signal. Hooks FFmpeg's `progress` event additively so the
           tool's own onProgress handler keeps working; if no progress tick arrives
           for `stallMs`, cancels FFmpeg and rethrows with errorType='stalled'.
           Also fires __stage('stalled') so it shows up in the funnel. Usage:
               await window.__withStallGuard(
                   () => FFmpegProcessor.process(file, args, name),
                   { stallMs: 60000, stage: 'encode' }
               ); */
        window.__withStallGuard=async function(fn,opts){
            opts=opts||{};
            // Phase 2.1 — two-stage stall handling:
            //   softMs: show a non-blocking toast ("slow on your device") so the
            //     user knows it's still alive and can choose to wait or cancel.
            //   hardMs: hard abort. Was the only level — single threshold of 60-
            //     120 s false-positived 420 stall errors/month because encodes
            //     near or over the avg time (94 s) routinely tripped it.
            //   Defaults keep backward compat: if only stallMs is passed, treat
            //   it as hard and synthesize soft = stallMs/2.
            var hardMs=opts.hardMs||opts.stallMs||60000;
            var softMs=opts.softMs!=null?opts.softMs:Math.max(30000,Math.round(hardMs*0.5));
            var stage=opts.stage||'process';
            var meta=opts.meta||{};
            var fp=window.FFmpegProcessor;
            var lastTick=Date.now(),stalled=false,softWarned=false;
            var tripped,stallWatch=new Promise(function(_res,rej){tripped=rej});
            function stallErr(){var e=new Error('Processing stalled (no progress for '+Math.round(currentHardMs()/1000)+'s)');e.errorType='stalled';return e}
            // Wave 2.C (2026-06-01) — adaptive stall threshold. When opts.adaptive
            // is true, hardMs is recomputed every wd cycle as
            //   max(floorMs, 3 × EMA(inter-tick gap))
            // so a slow mobile device that legitimately takes ~90 s per encode
            // segment gets a ~4-5 min threshold while a snappy desktop keeps
            // the tight floor. Closes the audit's "static 240 s false-positives
            // on long-segment slow Android, real stalls go undetected when
            // segments routinely run 2+ min" critique. floorMs default 180 s.
            var adaptive=opts.adaptive===true;
            var floorMs=opts.floorMs||180000;
            var emaGapMs=0; // running EMA of inter-tick interval (ms)
            var tickHook=function(){
                var now=Date.now();
                if(adaptive){
                    var gap=now-lastTick;
                    if(gap>0&&gap<600000){ // ignore the initial 0 + truly absurd gaps
                        emaGapMs=emaGapMs?Math.round(emaGapMs*0.7+gap*0.3):gap;
                    }
                }
                lastTick=now;softWarned=false;
            };
            function currentHardMs(){
                if(!adaptive)return hardMs;
                return Math.max(floorMs,emaGapMs*3);
            }
            // Subscribe to the window-broadcast `ffmpeg-progress` event instead
            // of the FFmpeg instance directly. The instance is replaced on every
            // FFmpegProcessor.reinit() (e.g. join tree-merge does ~37 reinits
            // for 19 tracks); a direct e.on('progress', ...) would only see the
            // first instance's events, then go silent and false-positive a
            // 120 s stall. The window event is dispatched by every new instance
            // in _doInit, so reinit cycles stay observable.
            // Manual tick hook (window event) lets multi-step pipelines mark
            // step boundaries as progress without needing FFmpeg ticks.
            window.addEventListener('ffmpeg-progress',tickHook);
            window.addEventListener('stall-tick',tickHook);
            /* And `ffmpeg-status`, which the engine already publishes for its own
               loading UI. Since 2026-08-31 the guard also wraps the work lanes
               from inside FFmpegProcessor, and wrapOp runs init() inside the lane
               — so a ~32 MB engine download on a slow connection sits in the
               guarded span while emitting no progress at all. That download is
               allowed to take minutes (it is why the 90 s init timeout was
               removed, Sentry 117158248), and cancelling it would be a new bug
               wearing the old bug’s clothes.
               (Prose here uses the typographic apostrophe on purpose.
               InlineLocaleLabelCompletenessTest strips string literals but not
               comments, so a straight apostrophe in prose opens a phantom
               literal that runs to the next one and moves every brace after it.
               That is not only noise: it also SWALLOWS whatever it covers, and
               teaching the lint to strip comments first — a one-line change,
               measured — surfaces 44 locale maps it has been blind to. Its own
               wave; this note is so the next reader does not rediscover it from
               a false positive, as this one did.) */
            window.addEventListener('ffmpeg-status',tickHook);
            // Tab-background rescue (closes Vladislav-cluster Stage 3, 2026-05-09).
            // Telemetry (30 stalled sessions, 2 d) showed 29/30 (97%) had
            // `tab_bg_during_encode` events. Root cause: SAB=0 single-thread
            // FFmpeg WASM runs on the MAIN thread; when the user backgrounds
            // the tab, Chrome aggressively throttles the main thread + the
            // setInterval watchdog, so:
            //   1) FFmpeg keeps working but progress events queue up
            //   2) The watchdog wakes up minutes later, sees `idle = 11+ min`
            //   3) Triggers cancel — killing legitimate work mid-encode
            // Fix: stall detection only matters for *foreground* users actively
            // watching the page. While document.hidden, the wd tick early-
            // returns (no false positive). On visibility return, reset baseline
            // so the next hardMs window starts fresh — user shouldn't be
            // penalised for time spent in BG. Pattern matches /audio-call
            // /baby-monitor /room-connect (every long-running tool already
            // listens to visibilitychange).
            function onVis(){
                if(!document.hidden){lastTick=Date.now();softWarned=false;}
            }
            document.addEventListener('visibilitychange',onVis);
            var wd=setInterval(function(){
                // Skip stall checks while tab is in BG. FFmpeg may be working
                // (postMessage events queued, main thread throttled) and the
                // user isn't waiting on a foreground UI signal — re-anchor
                // baseline on every BG tick so the post-resume math stays sane.
                if(document.hidden){lastTick=Date.now();softWarned=false;return;}
                var idle=Date.now()-lastTick;
                var dynHard=currentHardMs();
                if(!softWarned&&idle>softMs&&idle<dynHard){
                    softWarned=true;
                    try{if(window.__toast)window.__toast(
                        ({en:'Encoding is slow on your device. Wait or click Cancel.',ru:'Кодирование медленное на этом устройстве. Подождите или нажмите «Отмена».',ko:'기기에서 인코딩이 느립니다. 잠시 기다리거나 「취소」를 누르세요.',ar:'الترميز بطيء على جهازك. انتظر أو اضغط «إلغاء».',id:'Encoding lambat pada perangkat Anda. Tunggu atau klik "Batal".',pt:'Codificação lenta neste dispositivo. Aguarde ou clique em "Cancelar".',de:'Codierung ist auf diesem Gerät langsam. Warten oder „Abbrechen" klicken.',es:'La codificación es lenta en tu dispositivo. Espera o pulsa «Cancelar».',fr:'L’encodage est lent sur votre appareil. Patientez ou cliquez sur « Annuler ».', uk: 'Кодування повільне на цьому пристрої. Зачекайте або натисніть «Скасувати».', tr: 'Cihazınızda kodlama yavaş çalışıyor. Bekleyin veya “İptal” düğmesine tıklayın.'}[window.__LOCALE]||'Encoding is slow on your device. Wait or click Cancel.'),
                        'warning')}catch(_){}
                    try{if(window.__ae)window.__ae('feature_use',Object.assign(
                        {slug:meta.slug||(window.__currentSlug||''),action:'stall_soft_warn',stage:stage,idle_ms:idle,hardMs:dynHard,ema:emaGapMs},meta))}catch(_){}
                }
                if(idle>dynHard){
                    stalled=true;
                    if(window.__stage)try{window.__stage('stalled',Object.assign({stage:stage,idle_ms:idle,hardMs:dynHard,ema:emaGapMs,auto:1},meta))}catch(_){}
                    /* Cancel THE THING WE ARE GUARDING. The guard was born
                       wrapping FFmpeg, so `fp.cancel()` was hardcoded — fine
                       while FFmpeg was the only long lane, wrong the moment a
                       second one arrived: a wedged WebCodecs export would tear
                       down an unrelated (often merely warm) FFmpeg instance and
                       leave its own encoder running. `opts.cancel` lets a lane
                       name its own abort; FFmpeg stays the default so every
                       existing caller is unchanged. */
                    try{if(typeof opts.cancel==='function')opts.cancel();else if(fp&&fp.cancel)fp.cancel({notUser:true})}catch(_){}
                    clearInterval(wd);
                    tripped(stallErr());
                }
            },5000);
            /* The trip must SETTLE this call, not merely ask the callee to stop.
               Until 2026-08-31 the throw lived in a `finally` after `await fn()`,
               so it could only happen once fn itself settled — i.e. the watchdog
               was betting that `FFmpegProcessor.cancel()` would always be noticed.
               For the main instance it usually is (terminate() rejects pending
               exec promises), but "usually" is the wrong word for a watchdog: any
               wedge that outlives terminate — or any caller whose promise simply
               never settles — hangs the guard along with the run, which is the
               exact failure it exists to end. Racing removes the bet — the same
               shape /video-compressor’s hardware path has used since it was
               written. */
            /* Once the watchdog wins, cancelling the engine makes the wrapped
               call reject a moment later with "called FFmpeg.terminate()", and
               nobody is awaiting it by then. That does NOT become an unhandled
               rejection: Promise.race subscribes to every input, so the loser is
               already handled — verified by removing an explicit .catch() here
               and watching an `unhandledrejection` listener stay empty. The
               explicit swallow was written first and deleted after measuring;
               this note exists so it is not written a third time. */
            try{ return await Promise.race([Promise.resolve().then(fn), stallWatch]); }
            finally{
                clearInterval(wd);
                try{document.removeEventListener('visibilitychange',onVis)}catch(_){}
                try{window.removeEventListener('ffmpeg-progress',tickHook)}catch(_){}
                try{window.removeEventListener('stall-tick',tickHook)}catch(_){}
                try{window.removeEventListener('ffmpeg-status',tickHook)}catch(_){}
            }
        };
    })();
    /* ── window.__work — did the step FINISH, and was anybody watching? ─────
       Investigating «Виснет что-то обрезка-вырезка» (Nik29051980Maria,
       2026-08-29) hit a wall that no amount of querying could get past: nothing
       in the telemetry can tell a stuck tool from an absent person.

         · a successful step emits NOTHING. Only failures and recoveries do, so
           there is no duration distribution to compare a slow run against;
         · `tool_abandon.prog_still_s` measures "the stage did not change",
           which for a loaded file is just someone sitting there — its maximum
           over 30 days is 9 hours;
         · the gap between two rows cannot be smaller than the batch flush
           (~20-30 s), so timings under half a minute are invisible from the
           server side.

       So four honest questions had to be answered by guesswork, and four
       plausible answers turned out wrong when finally measured directly.

       This primitive answers them. It is the MEASURING half; the controlling
       half already exists as __withStallGuard above, which cancels a wedged
       FFmpeg run. __work never cancels, never toasts, never changes behaviour —
       it only reports, so it is safe to wrap anything.

       The one idea that makes "stuck" separable from "gone": count only the
       time the tab was actually VISIBLE. A person who backgrounds the tab for
       four minutes has not waited four minutes. Everything below is measured in
       visible milliseconds.

           var w = window.__work.begin('decode', { slug: 'trim', fileMB: 7 });
           try { ...; w.end({ sr: 48000 }); }
           catch (e) { w.fail(e); throw e; }

       Emits (all as feature_use):
           work_done         { name, ms, vis_ms, hid_ms, ticks, stalled }
           work_failed       { name, ms, vis_ms, err }
           work_cancelled    { name, ms, vis_ms }                    the person stopped it
           work_stall        { name, at_s, vis_ms, hid_ms, ticks }   once per step
           work_open_at_exit { name, vis_ms, hid_ms, ticks }         sent immediately

       `work_open_at_exit` is the one that names the complaint: the person left
       while a step was still running, having watched it for vis_ms. Leaving
       with nothing open is an ordinary departure and emits nothing. */
    (function () {
        var open = [];                       // steps currently running
        // Visible-time thresholds. 20 s is past any healthy step we have
        // measured (a decode of an 8-minute song is 1.3 s at 6x CPU throttle);
        // the later ones separate "slow" from "never".
        var MARKS = [20000, 60000, 180000];
        var visBase = Date.now();            // start of the current visible span
        var hidden = !!document.hidden;

        function nowVis(w) {
            // Visible ms accumulated by step `w` up to this instant.
            return w.vis + (hidden ? 0 : Date.now() - Math.max(visBase, w.t0));
        }
        function emit(f, w, extra) {
            var p = {
                slug: w.slug, f: f, name: w.name,
                vis_ms: Math.round(nowVis(w)),
                hid_ms: Math.round(w.hid + (hidden ? Date.now() - visBase : 0)),
                ticks: w.ticks,
            };
            for (var k in w.meta) if (Object.prototype.hasOwnProperty.call(w.meta, k)) p[k] = w.meta[k];
            for (var k2 in extra) if (Object.prototype.hasOwnProperty.call(extra, k2)) p[k2] = extra[k2];
            try {
                // Exit reports cannot wait for the next batch — the tab is going.
                var send = (f === 'work_open_at_exit' && window.__aeNow) ? window.__aeNow : window.__ae;
                if (send) send('feature_use', p);
            } catch (_) {}
        }
        function onVis() {
            var now = Date.now();
            var wasHidden = hidden;
            hidden = !!document.hidden;
            for (var i = 0; i < open.length; i++) {
                var w = open[i];
                if (wasHidden) w.hid += now - Math.max(visBase, w.t0);
                else w.vis += now - Math.max(visBase, w.t0);
            }
            visBase = now;
        }
        document.addEventListener('visibilitychange', onVis);

        var timer = null;
        function pump() {
            if (!open.length) { clearInterval(timer); timer = null; return; }
            if (hidden) return;              // nobody is watching; nothing to report
            for (var i = 0; i < open.length; i++) {
                var w = open[i];
                var v = nowVis(w) - w.lastTickVis;
                while (w.mark < MARKS.length && v > MARKS[w.mark]) {
                    emit('work_stall', w, { at_s: Math.round(MARKS[w.mark] / 1000) });
                    w.mark++;
                }
            }
        }
        function exitReport() {
            for (var i = 0; i < open.length; i++) emit('work_open_at_exit', open[i]);
            open.length = 0;
        }
        window.addEventListener('pagehide', exitReport);

        window.__work = {
            begin: function (name, meta) {
                var w = {
                    name: String(name || 'work').slice(0, 32),
                    slug: (meta && meta.slug) || window.__currentSlug || '',
                    meta: meta || {}, t0: Date.now(), vis: 0, hid: 0,
                    ticks: 0, mark: 0, lastTickVis: 0, done: false,
                };
                open.push(w);
                if (!timer) timer = setInterval(pump, 5000);
                var close = function (f, extra) {
                    if (w.done) return;
                    w.done = true;
                    var at = open.indexOf(w);
                    if (at >= 0) open.splice(at, 1);
                    emit(f, w, extra);
                };
                return {
                    // Progress happened: the step is alive, restart its clock.
                    tick: function () { w.ticks++; w.lastTickVis = nowVis(w); },
                    end: function (extra) {
                        close('work_done', Object.assign({
                            ms: Date.now() - w.t0, stalled: w.mark ? 1 : 0,
                        }, extra || {}));
                    },
                    /* A cancel is not a failure (2026-10-08): /video-compressor fed
                       every «Cancel» and every «switch to the fast engine» into
                       fail() — 556 of 556 sessions with «called FFmpeg.terminate()»
                       in 14 days had compress_cancel, and work_failed read as the
                       tool's top failure. A typed cancel (FFmpeg's USER_CANCELLED,
                       `cancelled:true`) routes itself; a tool that knows the
                       person cancelled says cancel(). Never inferred from the
                       message: our own watchdog kills FFmpeg with the same text. */
                    fail: function (err, extra) {
                        if (err && (err.code === 'USER_CANCELLED' || err.cancelled === true)) {
                            close('work_cancelled', Object.assign({ ms: Date.now() - w.t0 }, extra || {}));
                            return;
                        }
                        close('work_failed', Object.assign({
                            ms: Date.now() - w.t0,
                            err: String((err && err.message) || err || '').slice(0, 90),
                        }, extra || {}));
                    },
                    cancel: function (extra) {
                        close('work_cancelled', Object.assign({ ms: Date.now() - w.t0 }, extra || {}));
                    },
                };
            },
            // Test/introspection hook: how many steps are running right now.
            openCount: function () { return open.length; },
        };
    })();
    /* Reusable wake-lock wrapper for long-running operations on mobile.
       Acquires Screen Wake Lock at start, releases at end. Re-acquires on
       visibility-return when the system released the lock (Android tab-bg).
       Without this, Android Doze suspends single-thread WASM encodes when
       the user locks the screen — main-thread freezes mid-process. Pattern
       mirrors screen-recorder/recorder.js + interview-studio + pocket-pet
       (already mature in the codebase). Cross-tool: every long-running
       FFmpeg/WebCodecs export benefits. Telemetry-driven: Mosienko12
       bug-report 2026-05-11 (Samsung A02s, 2 GB RAM, 47 MB MP4) stalled at
       27% for 1h34m — cluster of 6 orphan-export sessions/week with 100%
       SAB=0 profile. Wake Lock keeps screen awake → tab stays foreground
       → main-thread WASM keeps progressing. Doesn't help if user actively
       switches to another app (any platform suspends backgrounded tabs).
       Best-effort: API may be absent (older browsers, Firefox-some), the
       wrapper degrades silently. Usage:
           await window.__withWakeLock(() => exportFn(), { slug: 'enhance-video' });
    */
    window.__withWakeLock=async function(fn,opts){
        opts=opts||{};
        var meta=opts.meta||{};
        var slug=opts.slug||meta.slug||(window.__currentSlug||'');
        var lock=null;
        // ── Heavy-task abandonment telemetry (added 2026-05-17, feedback #433) ──
        // This wrapper is the single place that knows a heavy export is in
        // flight, so it owns the cross-tool abandonment signal. The dominant
        // silent-failure mode on mobile is the user backgrounding the tab
        // mid-encode: the single-thread WASM job freezes, never completes,
        // emits nothing. 30-day funnel on enhance-video — 41 of 95 exports
        // vanished with no tool_complete and no tool_error. `task_abandoned`
        // fires on pagehide-while-pending; `hidden_ms` distinguishes "switched
        // away long ago, froze" from "closed an active foreground tab".
        // (No warning toast here — tools already surface their own in-progress
        // "keep this tab open" hints; a wrapper-level toast is redundant.)
        var _t0=Date.now();
        var _settled=false,_abandonSent=false;
        var _hiddenMs=0,_hiddenAt=0;
        function reportAbandon(){
            if(_settled||_abandonSent)return;
            _abandonSent=true;
            try{
                // Wave 1 (2026-06-01): snapshot the current stage/preset/via/
                // fileMB AT abandonment time (not at wrap-time, which is when
                // meta was captured). Pre-fix 90 task_abandoned events / 16 h
                // were 100 % blind to stage — we couldn't answer "which phase
                // are users abandoning?". opts.snapshot is a function returning
                // an object; called inside try/catch so a broken snapshotter
                // can't suppress the event. Caller-provided fields win over
                // snapshot (explicit > implicit).
                var snap={};
                try{if(typeof opts.snapshot==='function')snap=opts.snapshot()||{};}catch(_){snap={snapshot_err:1};}
                if(window.__ae)window.__ae('feature_use',Object.assign({
                    slug:slug,action:'task_abandoned',
                    elapsed_ms:Date.now()-_t0,
                    hidden_ms:_hiddenMs+(_hiddenAt?Date.now()-_hiddenAt:0),
                    bg:document.visibilityState==='hidden'?1:0
                    /* `mob` / `_b` are NOT set here on purpose. They were,
                       guarded by `typeof _mob!=='undefined'` — but _mob/_br are
                       declared in the NEXT IIFE of this file, so the guard was
                       permanently false and both keys always shipped undefined.
                       __ae() enriches feature_use with exactly these four
                       fields when they are null (see the enrichment block), so
                       the values arrived anyway and the dead ternary read as
                       working code. Kept as a comment because the next reader
                       will otherwise "fix" it back. */
                },snap,meta));
                if(window.__aeFlush)window.__aeFlush(); // page is leaving — deliver now
            }catch(_){}
        }
        /* The screen is held by the shared primitive (js/wake-lock.js, loaded by
           the layout on every page) under the hold 'export' — it verifies the
           lock, re-takes it after a hide or a freeze and falls back to a silent
           clip; this wrapper used to hold a sentinel of its own with none of
           that. Exports overlapping on one page share the hold: it goes back to
           the OS when the last of them ends. */
        async function acquire(){
            var W=window.__wakeLock;
            if(!W||typeof W.hold!=='function')return;
            if(!lock){lock=true;window.__withWakeLockN=(window.__withWakeLockN||0)+1;}
            try{
                var how=await W.hold('export');
                if(how==='none'){try{if(window.__ae)window.__ae('feature_use',Object.assign({slug:slug,action:'wake_lock_failed',err:String((W.state()||{}).lastError||'').slice(0,80)},meta))}catch(_){}}
            }catch(_){}
        }
        function release(){
            if(!lock)return;
            lock=null;
            window.__withWakeLockN=Math.max(0,(window.__withWakeLockN||1)-1);
            try{if(window.__withWakeLockN===0&&window.__wakeLock)window.__wakeLock.releaseHold('export');}catch(_){}
        }
        async function onVis(){
            if(document.visibilityState==='hidden'){
                _hiddenAt=Date.now();
            }else{
                // the primitive re-takes the screen on return by itself
                if(_hiddenAt){_hiddenMs+=Date.now()-_hiddenAt;_hiddenAt=0;}
            }
        }
        document.addEventListener('visibilitychange',onVis);
        window.addEventListener('pagehide',reportAbandon);
        await acquire();
        try{return await fn();}
        finally{
            _settled=true;
            try{document.removeEventListener('visibilitychange',onVis)}catch(_){}
            try{window.removeEventListener('pagehide',reportAbandon)}catch(_){}
            release();
        }
    };
    /* Pre-consent __ae stub — diagnostic mirror for declined-cookies users.
         Defined BEFORE the consent gate so that the LAST_TOOL_ACTION /
         LAST_TOOL_ERROR mirror below ALWAYS captures meaningful events,
         regardless of consent state. Bug-report 2026-05-07 (Yandex Browser
         Android 15 / 2 GB / cookie-declined): user reported "сбой" with
         last_error: null because consent gate returned early and __ae
         stayed undefined → mirror block returned early → null. With this
         stub the mirror runs in-memory (no network) and the feedback
         widget gets actionable diagnostic data. The stub is replaced by
         the real queue+flush implementation when consent is granted. */
    // Account-tied cookie/analytics consent (logged-in users): persisted in
    // users.profile_settings.cookie_consent so the choice follows across devices
    // and we never re-ask — like Google/YouTube. Injected BEFORE the consent gate
    // so consentOK() and the banner both honour it; null for guests (their
    // localStorage + GeoIP banner flow is unchanged).
    // window.__COOKIE_CONSENT_DB is injected by an inline Blade shim in
    // layouts/app.blade.php right before this file's script tag (per-user value;
    // read below only at call time, so the earlier assignment is behaviour-identical).
    /* __aeQ head-shim handover (2026-07-10). layouts/app.blade.php installs a
       tiny QUEUEING __ae in <head>, because this file's sync tag sits near the
       end of <body>: parse-time callers (page-content funnels like
       pro_checkout_view, __jsFallback attempts) used to no-op against their
       `typeof __ae === 'function'` guards and the events vanished. Capture the
       queued events ONCE here and retire the shim to the plain no-op; the
       consent IIFE below replays them through the real __ae ONLY when consent
       is already OK on this run. On the no-consent path they are discarded —
       the same "missed session_start" policy as the comment below (events
       from before consent are never transmitted, even if consent is granted
       later on this pageview). */
    var __aeEarlyQ = (window.__aeQ && window.__aeQ.splice) ? window.__aeQ.splice(0) : [];
    window.__aeQ = null;
    // At this point __ae is either undefined or the head shim (everything else
    // wraps later, post-parse) — retire it unconditionally so no caller can
    // reach the shim after its queue is gone.
    window.__ae = function(){ /* no-op until consent grants real impl */ };
    window.__aeDeferred = function(){ /* см. ниже — настоящая версия после согласия */ };
    window.__aeDeferredCancel = function(){};
    (function(){
        // Three-way consent gate. Order of precedence:
        //   1. DNT=1 — a browser-level opt-out, respected unconditionally.
        //   2. cookie_consent='declined' — user clicked Reject on the banner.
        //   3. Banner is showing and no choice yet made — hold off until they
        //      decide (so we don't log events for an EU visitor who might
        //      reject in 5 seconds). The ccBanner script dispatches a
        //      'cookie-consent-accepted' event that re-enters this IIFE on
        //      acceptance, via the listener below.
        function consentOK(){
            if (navigator.doNotTrack === '1') return false;
            // Account-tied choice (logged-in, cross-device) is authoritative.
            if (window.__COOKIE_CONSENT_DB === 'declined') return false;
            if (window.__COOKIE_CONSENT_DB === 'accepted') return true;
            var c = localStorage.getItem('cookie_consent');
            if (c === 'declined') return false;
            // If the banner is rendered and visible, a decision is pending.
            // Return false so we queue nothing until the user picks.
            var banner = document.getElementById('ccBanner');
            if (banner && banner.classList.contains('cc-visible') && c !== 'accepted') return false;
            return true;
        }
        // Тот же вопрос задаёт журнал задач помощника на главной
        // (home-assistant.js): вторая копия правила разошлась бы с этой.
        window.__consentOK = consentOK;
        if (!consentOK()) {
            // No retry on this pageview. First page after accepting is a
            // missed session_start — fine, they'll be tracked on the next
            // navigation. Avoids a jarring auto-reload immediately after
            // the user clicks "Accept" (worse UX than losing one page-view).
            return;
        }
        var sid=sessionStorage.getItem('_as');
        if(!sid){sid=typeof crypto!=='undefined'&&crypto.randomUUID?crypto.randomUUID():(Math.random().toString(36).substr(2)+Date.now().toString(36));sessionStorage.setItem('_as',sid)}
        /* Сбои движков (/api/log-error: FFmpeg, загрузка ядра) — в ленту ЭТОЙ
           сессии. Мест отправки три десятка, и каждое шлёт голый JSON-массив;
           сервер клал строку под md5(ip + день), поэтому ошибка FFmpeg на /trim
           жила отдельно от человека, с которым случилась (октябрь 2026: «Exactly
           one MP3 audio stream» у WMA под именем .mp3 — экспорт выглядел
           молчаливым). Одна дверь вместо тридцати правок: id ставится только при
           согласии на аналитику — канал без согласия остаётся анонимным. */
        (function(){
            try{
                if(!navigator.sendBeacon||navigator.sendBeacon.__tmbSid)return;
                var nb=navigator.sendBeacon.bind(navigator);
                var stamped=function(url,data){
                    try{
                        if(typeof data==='string'&&data.charAt(0)==='['&&/\/api\/log-error(?:[?#]|$)/.test(String(url))&&consentOK()){
                            var s=sessionStorage.getItem('_as');
                            if(s){var arr=JSON.parse(data);if(Array.isArray(arr)){for(var i=0;i<arr.length;i++){if(arr[i]&&typeof arr[i]==='object'&&!arr[i].sid)arr[i].sid=s;}data=JSON.stringify(arr);}}
                        }
                    }catch(_){}
                    return nb(url,data);
                };
                stamped.__tmbSid=1;
                navigator.sendBeacon=stamped;
            }catch(_){}
        })();
        var queue=[];
        var mt=document.querySelector('meta[name="tool-slug"]');
        var slug=mt?mt.content:null;
        var locale=window.__LOCALE||document.documentElement.lang||'en';
        var t0=Date.now();
        // Centralized taxonomy + cross-type dedup. Tools may emit tool_error with
        // an error_type that's really a user-action (cam_denied), a capability
        // signal (popout_fallback), or a format limitation (format_unsupported).
        // Rewriting here means legacy callers don't need to be migrated, and new
        // callers can't accidentally misclassify — the rule set is the single
        // source of truth for event taxonomy.
        var _AE_BLOCKED=/^(cam_denied|cam_not_found|cam_busy|mic_denied|mic_not_found|mic_busy|format_unsupported|file_too_large|wrong_file_type|empty_file|file_lost|pip_unsupported|media_api_unsupported)$/;
        var _AE_FEATURE=/^(mic_silence_warned|popout_fallback|pip_fallback|adblock_detected|cancelled)$/;
        var _aeXDedup={};
        // Когда по каждому тулу последний раз приходило ТИПИЗИРОВАННОЕ событие
        // об ошибке/блокировке. Окно 2 с: тост показывают в том же обработчике,
        // что и типизированное событие, — задержка между ними это один тик плюс
        // отрисовка. Длиннее окно начало бы глотать настоящую ВТОРУЮ ошибку.
        var _aeTypedAt={},_AE_ECHO_MS=2000;
        /** Освободить одно место в полной очереди, выбросив ПОСЛЕДНЮЮ копию
         *  самой частой пары (тип + `f`). Возвращает false, когда повторов нет
         *  — тогда очередь состоит из 50 РАЗНЫХ наблюдений, и терять любое из
         *  них хуже, чем потерять новое (прежнее поведение). O(50), и только в
         *  момент переполнения. */
        function _aeEvictRepeat(){
            var counts={},i,k,best=null,bestN=1;
            for(i=0;i<queue.length;i++){
                k=queue[i].t+'|'+((queue[i].p&&queue[i].p.f)||'');
                counts[k]=(counts[k]||0)+1;
                if(counts[k]>bestN){bestN=counts[k];best=k}
            }
            if(best===null)return false;
            for(i=queue.length-1;i>=0;i--){
                if(queue[i].t+'|'+((queue[i].p&&queue[i].p.f)||'')===best){queue.splice(i,1);return true}
            }
            return false;
        }
        /* Когда очередь полна, жертвуем ПОВТОРОМ, а не наблюдением.
           Прежнее правило — «полна, значит новое событие в мусор» — делало нас
           тем слепее, чем громче человеку плохо: заявительница 19.09.2026
           (/ar-drawing, камера не открылась) настучала по кнопке 49 раз, эти
           49 одинаковых feature_use заняли очередь целиком, и выброшены были
           ровно те события, которые объясняли отказ, — два `cam_acquire`
           timeout из трёх, `camera_fail` и `tool_blocked` (доставлено 0).
           Мы узнали, что она нажимала, и не узнали почему не сработало.
           Признак «что выбросить» — не список важных типов (он протухнет в
           день, когда появится новый), а САМА повторяемость: 49-я копия
           одного события не несёт ничего, чего нет в первой. Выбрасываем
           последнюю копию самой частой пары (тип + `f`), сохраняя начало
           всплеска; если повторов нет вовсе — ведём себя как раньше. */
        window.__ae=function(type,payload){
            if(queue.length>=50&&!_aeEvictRepeat())return;
            payload=payload||{};
            /* Баннер FFmpeg не доезжает до нас — он ЗАНИМАЕТ место причины.
               FFmpeg печатает 11 строк version/built with/configuration/libav*
               перед любой работой, а сообщения об ошибках режутся по первым
               200 символам (ниже и в двух соседних местах). Замер 08.09.2026 на
               настоящем отказе concat: кольцо из 14 строк, из них 11 баннер и 3
               по делу («moov atom not found», «Invalid data found», «Aborted()»)
               — в телеметрию уезжало 100% баннера и 0% причины. За 14 дней так
               потеряны 107 отчётов только на /video-merge: 62 сессии за месяц
               падают на конкретном клипе, и почему — не записано НИ РАЗУ.
               Жалоба Игоря (Премиум, 07.09) — ровно этот случай.

               Обрезка стоит ЗДЕСЬ, а не в FFmpegProcessor._fs.exec: `logs` там
               читают семь мест регулярками (`Duration:` в /denoise ×4, частота,
               счёт строк декодера в /repair-video, темп кадров в video-vitals),
               и замер показал, что фильтрация у источника ЛОМАЕТ определение
               длительности. Баннер мешает транспорту, а не читателю логов —
               значит и чистится там, где живёт бюджет в 200 символов. Одна
               точка на все тулы, включая те, которых ещё нет. */
            /* Сеть безопасности: точка сборки, которая забудет __ffMsg, всё равно
               не отправит баннер. Режем без усечения — длину уже выбрал вызывающий. */
            if(typeof payload.msg==='string')payload.msg=window.__ffMsg(payload.msg,0);
            if(typeof payload.err_msg==='string')payload.err_msg=window.__ffMsg(payload.err_msg,0);
            // 0. Mark machine traffic. A paid BYO-Browser work order drives the
            //    page through someone's agent, so its events must never be read
            //    as human behaviour — an unmarked API run would move funnel,
            //    dwell and abandon rates and quietly invalidate every product
            //    conclusion drawn from this tool. Tag, don't drop: we still want
            //    to see API usage, just not confuse it with people.
            if(document.body&&document.body.getAttribute('data-api-mode')==='1')payload.via='api';
            // 1. Auto-reclassify by payload.error_type
            if(type==='tool_error'&&payload.error_type){
                if(_AE_BLOCKED.test(payload.error_type)){
                    type='tool_blocked';
                    if(!payload.reason)payload.reason=payload.error_type;
                } else if(_AE_FEATURE.test(payload.error_type)){
                    type='feature_use';
                }
            }
            // 1b. Backstop for cached pre-fix ios-audio-unmute.js. The old
            //     version emitted tool_error{kind:'ios_unmute_play_fail'} on
            //     every NotAllowedError, which polluted every iOS-heavy
            //     tool's error rate (phone-benchmark hit 3241/14d). The new
            //     version uses feature_use, but Service-Worker-cached copies
            //     can survive up to 6 months on returning visitors.
            //     Reclassify here so /pino/streams stays clean.
            if(type==='tool_error'&&payload.kind==='ios_unmute_play_fail'){
                type='feature_use';
                payload.f='ios_unmute_play_fail_legacy';
            }
            // 2. Cross-type dedup error↔blocked (same root error can't be both)
            // 2a. Эхо тоста поверх ТИПИЗИРОВАННОГО события — дедуп по ВРЕМЕНИ,
            //     а не по тексту.
            //     Дедуп ниже (п. 2) сравнивает сообщения, и для этого случая он
            //     не мог сработать никогда: типизированное событие несёт строку
            //     БРАУЗЕРА («NotAllowedError: Permission denied»), а тост —
            //     НАШ локализованный совет («Доступ к камере запрещён…»).
            //     Совпадать им нечем.
            //     Замер 30 дней (07.08): toast_error 25 463, из них 2 069 —
            //     эхо разрешений микрофона/камеры, где MicManager уже отправил
            //     tool_blocked. Механизмы против этого существуют с 06-02
            //     (opts.silent, err.alreadyReported), но требуют, чтобы КАЖДЫЙ
            //     из 324 тулов о них помнил, — и утекает 2 тыс. событий в месяц.
            //     Сторож, зависящий от памяти автора, рано или поздно протекает.
            //     Роняем ТОЛЬКО безымянный toast_error и только в узком окне
            //     после типизированного события того же тула: типизированная
            //     строка остаётся всегда, теряется лишь её пересказ.
            if(type==='tool_error'&&payload.error_type==='toast_error'){
                var _tk=payload.slug||slug||'';
                if(_aeTypedAt[_tk]&&(Date.now()-_aeTypedAt[_tk])<_AE_ECHO_MS)return;
            } else if((type==='tool_blocked'||type==='tool_error')&&payload.error_type&&payload.error_type!=='toast_error'){
                _aeTypedAt[payload.slug||slug||'']=Date.now();
            }
            if(type==='tool_error'||type==='tool_blocked'){
                var _msg=(payload.msg||payload.err_msg||payload.error||'').substring(0,120);
                if(_msg){
                    var _dk=(payload.slug||slug||'')+'|'+_msg;
                    var _now=Date.now();
                    if(_aeXDedup[_dk]&&(_now-_aeXDedup[_dk])<60000)return;
                    _aeXDedup[_dk]=_now;
                    // Cap map size
                    var _ks=Object.keys(_aeXDedup);
                    if(_ks.length>40)_ks.forEach(function(k){if(_now-_aeXDedup[k]>60000)delete _aeXDedup[k];});
                }
            }
            // 3. Wave 2 (2026-06-03): central device-class enrichment so
            //    direct __ae('tool_complete'|'feature_use', …) callers
            //    inherit mob/_b/devMem/maxMB without going through
            //    __aeToolComplete / __aeFeature helpers. Pre-fix: mob=NULL
            //    on 91 % of tool_complete events (33 tools emit
            //    tool_complete directly, plus every engine_warm_* feature_use
            //    from EngineWarmer.startWarming bypassed __aeFeature). Honors
            //    explicit caller-supplied values — only fills missing fields.
            //    Phase W (2026-06-03): also enrich 'tool_error' here — the
            //    workflow wf_8a55e2b3 found 40 direct __ae('tool_error') call
            //    sites across 28 blades that bypassed __aeToolError's
            //    closure-merge of slug + _b + mob + devMem + maxMB. Pre-fix
            //    those rows had NULL on browser/mob/dm dimensions →
            //    impossible to slice on /pino/streams. Single-line addition
            //    closes 40 sites without per-blade migration. The named
            //    __aeToolError still adds dedup/terminate-classification/
            //    auto-stage that bypass-callers also lose — those features
            //    are separate; this just patches the device-class gap.
            //    Wave 3 (2026-08-04): the INP pair joins the list. Without `mob`
            //    the metric cannot be compared to the thing that is actually
            //    failing — Search Console reports 276 ms for MOBILE, while our
            //    all-device p75 came out 152 (RU) / 136 (intl), i.e. green. Two
            //    green numbers next to one red one is not a contradiction to
            //    explain away, it is a sign we were measuring a different
            //    population; the flag is what makes the comparison possible.
            if(type==='tool_complete'||type==='feature_use'||type==='tool_diagnostic'||type==='tool_error'
               ||type==='inp_slow'||type==='web_vital'){
                if(payload.mob==null)payload.mob=_mob;
                if(payload._b==null)payload._b=_br;
                if(payload.devMem==null)payload.devMem=_devMem;
                if(payload.maxMB==null)payload.maxMB=_maxMB;
            }
            queue.push({s:sid,t:type,g:slug,l:locale,p:payload});
        };
        function flush(){
            if(!queue.length)return;
            /* sendBeacon throws on file:// — silently drop when user opens a saved page locally */
            if(!/^https?:$/.test(location.protocol)){queue.length=0;return}
            var batch=queue.splice(0,20);
            try{
                // Chrome temporarily disabled non-CORS-safelisted MIMEs in
                // sendBeacon Blob bodies (crbug.com/490015) — using
                // 'application/json' here surfaces as SecurityError. text/plain
                // IS safelisted; the server-side /api/analytics handler reads
                // the body via getContent() + json_decode, so Content-Type
                // doesn't affect parsing. Closes Sentry TIMBRICA-FRONTEND-6S
                // (Chrome Mobile 146 Android /ru/dementia-test, same class).
                var blob=new Blob([JSON.stringify(batch)],{type:'text/plain'});
                var sent=navigator.sendBeacon && navigator.sendBeacon('/api/analytics',blob);
                // sendBeacon returns false if adblockers / browser refuses / payload too big.
                // Low-volume urgent events can't afford the loss, so fall
                // back to keepalive fetch which routes through a different code path and is
                // often NOT on adblock lists for /api/analytics.
                if(!sent){fetch('/api/analytics',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(batch),keepalive:true,credentials:'same-origin'}).catch(function(){})}
            }catch(e){}
        }
        // Public hook: call this after queuing a rare+important event to deliver it now,
        // rather than waiting for the next 30s interval or tab close.
        window.__aeFlush=flush;
        // Replay the head-shim queue (captured before the consent gate) through
        // the real __ae above — original order, full taxonomy/enrichment/dedup.
        // Reached only when consent was OK on this run; the 'cookie-consent-
        // accepted' re-entry finds an empty array (splice(0) below), so
        // pre-consent events are never transmitted.
        __aeEarlyQ.splice(0).forEach(function(e){
            try { window.__ae(e[0], e[1]); } catch(_) {}
        });
        /* ── Отложенное событие, которое НЕ теряется при уходе со страницы ──
           Приём «подождать N мс тишины и тогда отправить» нужен там, где событие
           описывает ИТОГ набора текста: слать по событию на каждую букву — шум.
           Но у него есть тихий изъян: если ДЕЙСТВИЕ, означающее успех, уводит
           человека со страницы, таймер умирает вместе со вкладкой, и событие не
           отправляется НИКОГДА. А неуспех оставляет человека на месте, тишина
           выдерживается, и он записывается исправно.

           Замерено 25.08 на поиске: `search_miss` показывал спасение промаха в
           29% случаев. При этом прямая проба движка спасает все спорные формы,
           а `search_click` в `/flight-tracker` — 150 за 30 дней по ТЕМ ЖЕ
           запросам, что числились неспасёнными. Прибор терял успехи и хранил
           провалы, а по нему решают, что строить.

           Осушение стоит в тех же двух выходах и ДО `flush()`, поэтому порядок
           слушателей роли не играет: событие попадает в очередь раньше, чем
           очередь уходит. */
        var _deferred = Object.create(null);
        function drainDeferred(){
            for (var k in _deferred){
                var d = _deferred[k];
                if (!d) continue;
                clearTimeout(d.timer);
                _deferred[k] = null;
                try { window.__ae(d.type, d.payload); } catch(_){}
            }
        }
        /** Отправить `type` через `ms` тишины; повторный вызов с тем же `key`
            отменяет предыдущий. Уход со страницы досылает немедленно. */
        window.__aeDeferred = function(key, type, payload, ms){
            var prev = _deferred[key];
            if (prev) clearTimeout(prev.timer);
            var rec = { type: type, payload: payload };
            rec.timer = setTimeout(function(){
                if (_deferred[key] !== rec) return;
                _deferred[key] = null;
                try { window.__ae(type, payload); } catch(_){}
            }, ms || 1200);
            _deferred[key] = rec;
        };
        /** Снять отложенное — когда исход перестал быть тем, что описывало событие. */
        window.__aeDeferredCancel = function(key){
            var prev = _deferred[key];
            if (prev){ clearTimeout(prev.timer); _deferred[key] = null; }
        };

        setInterval(flush,30000);
        document.addEventListener('visibilitychange',function(){
            if(document.visibilityState==='hidden'){ drainDeferred(); flush(); }
        });
        // pagehide fires reliably on tab close / iOS Safari (visibilitychange may not).
        // Without this, users who close the tab quickly never deliver telemetry.
        window.addEventListener('pagehide',function(){ drainDeferred(); flush(); });
        // Helpers for tool blade files. __aeToolComplete also fires __stage('complete')
        // so every tool using the standard completion helper gets stage-trace for free.
        /* ── Событие, которое обязано уйти ДО того, как вкладку может убить ──
           Обычные события копятся в очереди и уходят при уходе со страницы
           (pagehide/visibilitychange). Для тяжёлых операций это поздно: если
           браузер убивает вкладку по памяти, ни одно из этих событий не
           отправляется, и отказ выглядит так, будто человек ничего не делал.

           Живой случай 2026-08-11 (Екатерина, m4a 207 МБ, 3 ч 05 мин, Android
           4 ГБ): она открыла обрезку, вкладка умерла, в телеметрии — НОЛЬ
           событий за всю попытку. Мы знали о падении только из чата поддержки,
           а причину искали вслепую два круга.

           __aeNow ставит событие в очередь и НЕМЕДЛЕННО сливает её тем же
           путём, что и обычный flush (sendBeacon → keepalive fetch). Звать его
           надо ПЕРЕД тяжёлым шагом, а не после: смысл в том, чтобы сигнал
           пережил смерть вкладки. Для обычных событий не годится — это лишний
           сетевой запрос на каждое. */
        window.__aeNow=function(type,payload){
            try{window.__ae(type,payload||{})}catch(_){}
            try{flush()}catch(_){}
        };
        window.__aeToolComplete=function(p){window.__ae('tool_complete',Object.assign({slug:slug},p||{}));if(window.__stage)try{window.__stage('complete',p||{})}catch(_){}};
        var _errDedup={},_errDedupTTL=5000;
        window.__aeToolError=function(p){
            // _b (browser tag) embedded on every error event so investigations
            // are single-query — no JOIN with session_start needed to attribute
            // an error to a browser. Same logic as rage_click (line 3296+).
            var d=Object.assign({slug:slug,devMem:_devMem,maxMB:_maxMB,_b:_br,mob:_mob},p||{});
            // Filter noise: browser extensions and FFmpeg version-info-only crashes
            var _m=(d.msg||d.err_msg||'').replace(/@\s*0x[0-9a-f]+/gi,'');
            if(/contentScript|VisibilityChanged|webkit-masked-url/i.test(_m))return;
            if(/^FFmpeg exit code.*libavdevice\s+\d/.test(_m)&&!/error|fail|invalid|denied|not found/i.test(_m))return;
            // "called FFmpeg.terminate()" / "Aborted()" is a control-flow signal
            // when WE called terminate (user cancel, between-attempts reinit, probe
            // recovery). But it ALSO fires when WASM dies spontaneously — codec
            // panic, internal _exit, memory abort. Same error message, different
            // intent. Pre-fix (2026-05-29 sid 1d738efb + 7+ cross-tool sessions):
            // ALL terminate-shaped errors were routed to feature_use:cancelled →
            // genuine WASM panics became dashboard noise + Tier 3 (AudioRecover)
            // declined → users stuck with no actionable telemetry.
            // Etalon: FFmpegProcessor sets window.__ffmpegIntentionalTerminateAt
            // = Date.now() right BEFORE every e.terminate() call (cancel, reinit,
            // probe, abort, init-cleanup). __aeToolError checks the timestamp:
            // within 5 s of an intentional terminate → cancelled. Otherwise →
            // real tool_error with error_type:'wasm_spontaneous_terminate'.
            if(/called\s+ffmpeg\.terminate|terminate\(\)/i.test(_m)){
                var _intTs = window.__ffmpegIntentionalTerminateAt || 0;
                if (Date.now() - _intTs < 5000) {
                    try{window.__ae('feature_use',Object.assign({f:'cancelled'},d))}catch(_){}
                    return;
                }
                // Spontaneous WASM death — classify as real tool_error.
                if (!d.error_type) d.error_type = 'wasm_spontaneous_terminate';
            }
            if(d.err_msg)d.err_msg=d.err_msg.replace(/@\s*0x[0-9a-f]+/gi,'');
            if(d.msg)d.msg=d.msg.replace(/@\s*0x[0-9a-f]+/gi,'');
            // Deduplicate: skip if same msg within 5 seconds (regardless of error_type)
            var key=_m.substring(0,80);
            var now=Date.now();
            if(_errDedup[key]&&(now-_errDedup[key])<_errDedupTTL)return;
            _errDedup[key]=now;
            // Cleanup old keys every 20 entries
            var keys=Object.keys(_errDedup);
            if(keys.length>20){keys.forEach(function(k){if(now-_errDedup[k]>_errDedupTTL)delete _errDedup[k];})}
            // SNAPSHOT for tool_abandon's last_error_type field. Pre-fix the
            // abandon-emitter read window.__LAST_TOOL_ERROR but only two
            // specific sites wrote to it (pick_reject line 77, wasm_init line
            // 3538). Every other __aeToolError call dispatched a tool_error
            // event without setting the snapshot — so 21/80 abandons on
            // /ai-music-cleaner (cluster #2 of the diegr workflow, 2026-05-29)
            // landed with last_stage='error' but last_error_type=null,
            // making error-driven abandons structurally invisible across all
            // multi-stage tools. Snapshotting here makes every error the
            // funnel sees a candidate for the next abandon attribution.
            // NOTE: last_error_type is null on ~98% of tool_abandons BY DESIGN —
            // __LAST_TOOL_ERROR is page-scoped and most users abandon before
            // triggering any error. For cross-pageview attribution JOIN
            // tool_abandon to prior tool_error by session_id at query time.
            try{
                window.__LAST_TOOL_ERROR={
                    tool:d.slug||slug||null,
                    error_type:d.error_type||null,
                    msg:window.__ffMsg(d.msg||d.err_msg,200),
                    ts:now,
                };
            }catch(_){}
            // Strip the funnel-control flag before posting — it's an
            // internal signal between emitTierError and this handler,
            // not a field the ingest/dashboards should see in tool_error
            // rows. Captured to a local so the auto-stage branch below
            // can still read the original intent.
            var _skipAutoStage = !!d._no_auto_stage;
            if (d._no_auto_stage !== undefined) { delete d._no_auto_stage; }
            window.__ae('tool_error',d);
            // Auto-stage('error') — no-wiring funnel fallback for simple tools.
            // Deferred a microtask + tagged `auto:1` so a tool that stages its
            // OWN error (e.g. text-to-speech: __stage('error',{reason:...}))
            // runs first, synchronously, and __stage drops this redundant auto
            // call. Without the deferral the auto call fired FIRST and the
            // tool's reason-tagged call lost the 500 ms same-stage dedup —
            // /pino/streams then saw 95% of stage:error rows with no reason.
            // Microtask (not setTimeout) so it still lands before paint/unload.
            //
            // `_no_auto_stage:1` flag SKIPS the auto-stage for diagnostic
            // errors that are intermediate steps in a recovery chain (e.g.
            // AudioDecoderRobust tier 0/1/1.5/2 — tier 3 + fatals still
            // flip the funnel). Pre-fix (Olga #770, 2026-06-17, iPhone Yandex
            // 332MB MOV): tier-1 native decode failed → emitted tool_error →
            // auto-stage fired stage:error → tier-1.5 WebCodecs RESCUED 1.4s
            // later → funnel still showed "errored". 78 events/4d on
            // add-music-to-video alone, plus the same cohort polluted on
            // every tool using AudioDecoderRobust. The tool_error row still
            // emits (diagnostics preserved), only the funnel side-effect
            // is suppressed.
            if(window.__stage && !_skipAutoStage){
                var _autoStageMeta={error_type:d.error_type||'',msg:window.__ffMsg(d.msg||d.err_msg,120),auto:1};
                var _fire=function(){try{window.__stage('error',_autoStageMeta)}catch(_){}};
                if(typeof queueMicrotask==='function')queueMicrotask(_fire);
                else Promise.resolve().then(_fire).catch(function(){});
            }
        };
        // Shared error-context builder for tool blade onerror / catch handlers.
        // Extracts err_name + err_msg + file_ext + file_type + file_size so
        // /pino/streams rows are self-describing without per-blade boilerplate.
        // Does NOT include slug / _b / mob / devMem / maxMB — __aeToolError
        // closure already merges those (line 4710). Use as:
        //   window.__aeToolError(Object.assign({
        //       error_type: 'decode_failed'
        //   }, window.__errCtx(err, file)));
        // Tools that bypass __aeToolError and call window.__ae('tool_error', ...)
        // directly should still call __errCtx for the err+file portion AND
        // additionally pass {slug, _b:_br, mob:_mob, devMem:_devMem} themselves.
        window.__errCtx=function(err,file){
            var n=(file&&file.name)||'';
            var dotAt=n.lastIndexOf('.');
            var ext=(dotAt>=0&&dotAt<n.length-1)?n.slice(dotAt+1).toLowerCase().slice(0,8):'';
            return {
                err_name:(err&&err.name)||'Error',
                err_msg:window.__ffMsg((err&&err.message)||(err&&typeof err==='string'?err:''),200),
                file_ext:ext,
                file_type:((file&&file.type)||'').slice(0,32),
                file_size:(file&&file.size)||0,
            };
        };
        window.__aeFeature=function(f,p){window.__ae('feature_use',Object.assign({slug:slug,f:f},p||{}))};
        window.__aeRating=function(stars){window.__ae('rating_intent',{slug:slug,stars:stars})};
        // User-action events that aren't bugs: permission denied, file too large, wrong file type.
        // Kept in telemetry for product insight but separated from tool_error.
        window.__aeBlocked=function(p){window.__ae('tool_blocked',Object.assign({slug:slug,_b:_br,mob:_mob},p||{}))};
        // Expected diagnostic events for salvage-style tools (e.g. repair-video strategy attempts).
        window.__aeDiagnostic=function(p){window.__ae('tool_diagnostic',Object.assign({slug:slug},p||{}))};
        // Show a "user-action" toast — same UX as __toast(msg,'error') but the telemetry
        // event becomes tool_blocked with a structured reason, so dashboards can keep
        // tool_error meaningful. Use this for size/type/format guards instead of plain __toast.
        window.__toastBlocked=function(msg,reason){window.__nextToastBlocked=reason||'user_blocked';window.__toast(msg,'error')};
        // Centralized confirmation dialog. Returns a Promise resolving to one of
        // opts.choices[i].id, or 'cancel' if dismissed. Use this whenever we need to
        // ask the user before taking an action that changes their output (quality
        // downgrade, format change, retry at lower resolution, etc.) — never do a
        // silent downgrade. opts: {title, message, choices:[{id, label, primary?}]}.
        window.__confirmDialog=function(opts){
            return new Promise(function(resolve){
                var ov=document.createElement('div');
                ov.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px';
                var d=document.createElement('div');
                d.setAttribute('role','dialog');d.setAttribute('aria-modal','true');
                d.style.cssText='background:var(--bg-primary,#1a1a2e);border:1px solid var(--border,#333);border-radius:16px;padding:24px;max-width:480px;width:100%;color:var(--text-primary,#fff);max-height:80vh;overflow:auto';
                var html='<div style="font-size:16px;font-weight:600;margin-bottom:8px">'+(opts.icon||'⚠️')+' '+(opts.title||'')+'</div>';
                html+='<div style="font-size:14px;color:var(--text-secondary,#aaa);margin-bottom:16px;line-height:1.4">'+(opts.message||'')+'</div>';
                html+='<div style="display:flex;flex-direction:column;gap:8px">';
                (opts.choices||[{id:'ok',label:'OK',primary:true}]).forEach(function(c){
                    var style=c.primary
                        ?'padding:12px;background:var(--accent-gradient,linear-gradient(135deg,#38bdf8,#0ea5e9));color:var(--on-accent);border:none;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer'
                        :'padding:10px;background:transparent;color:var(--text-secondary,#aaa);border:1px solid var(--border,#333);border-radius:10px;font-size:13px;cursor:pointer';
                    html+='<button data-id="'+c.id+'" style="'+style+'">'+c.label+'</button>';
                });
                html+='</div>';
                d.innerHTML=html;
                ov.appendChild(d);document.body.appendChild(ov);
                function close(id){try{document.body.removeChild(ov)}catch(_){}resolve(id)}
                d.addEventListener('click',function(e){var b=e.target.closest('[data-id]');if(b)close(b.dataset.id)});
                ov.addEventListener('click',function(e){if(e.target===ov)close('cancel')});
                document.addEventListener('keydown',function k(e){if(e.key==='Escape'){document.removeEventListener('keydown',k);close('cancel')}});
            });
        };
        // Hotkey usage tracking — logs which keyboard shortcuts users actually use
        var _hkLast='',_hkT=0;
        document.addEventListener('keydown',function(e){
            if(!slug)return;
            if(document.body&&document.body.hasAttribute('data-kbd-capture'))return; // game owns the keys
            if(e.target.tagName==='INPUT'||e.target.tagName==='TEXTAREA'||e.target.tagName==='SELECT')return;
            if(e.target.isContentEditable)return;
            var k='';
            if(e.ctrlKey||e.metaKey)k+='Ctrl+';
            if(e.shiftKey)k+='Shift+';
            if(e.altKey)k+='Alt+';
            var code=e.code||e.key||'';
            if(/^(Control|Shift|Alt|Meta)$/.test(e.key))return;
            k+=code;
            if(!k||k==='Ctrl+'||k==='Shift+'||k==='Alt+')return;
            // Debounce: same key within 2s → skip
            var now=Date.now();if(k===_hkLast&&now-_hkT<2000){_hkT=now;return;}
            _hkLast=k;_hkT=now;
            // Only log keys that tools typically bind
            if(/^(Space|Escape|Home|End|Delete|Backspace|ArrowLeft|ArrowRight|ArrowUp|ArrowDown)$/.test(code)
               ||/^Ctrl\+/.test(k)||/^Shift\+/.test(k)){
                window.__ae('feature_use',{slug:slug,action:'hotkey',key:k});
            }
        },{passive:true});
        // Auto: tool_complete — debounced + smart-merged. Multiple sources fire
        // (manual __aeToolComplete from blade, file-downloaded from FFmpegProcessor.download,
        // <a download> click patch). Without this they used to emit 3 separate tool_complete
        // rows per export — making success-rate impossible to count. Now we accumulate
        // payload over an 800 ms window, merge fields giving priority to non-zero numerics
        // and non-empty strings, and emit ONE event per completion.
        //
        // No post-flush lockout: a session can legitimately produce multiple completions
        // (e.g. preview-frame tool_complete from FFmpegProcessor.process auto-tracker fires
        // first, then real export 30 s later). Each new call restarts the debounce timer;
        // flush closes the merge period and the next call opens a fresh one.
        var _completeBuf=null,_completeTimer=null,_bufOwn=false,_bufStaged=false;
        /* Окно, которое открыла ДВЕРЬ скачивания (тул своего ещё не сказал), ждёт тула не 800 мс, а до
           следующего жеста человека (pointerdown/keydown), ухода со страницы или 15 с (16.10.2026).
           Тул, объявляющий результат ПОСЛЕ `await __downloadFile` (окно сохранения, share sheet, запись на
           диск — секунды), попадал за 800 мс и давал второй tool_complete того же результата; а новый
           результат без нового жеста не бывает (выдача — один файл на жест), поэтому жест и есть граница
           результата, а не догадка о секундах. Уход со страницы досылает окно сразу — до этой даты
           tool_complete, объявленный менее чем за 800 мс до ухода, умирал вместе с таймером вкладки.
           Замеры — docs/why/primitives/result-door.md, «Дверь раньше тула». */
        var _DOOR_WAIT_MS=15000;
        function _mergePayload(prev,next){
            for(var k in next){
                var nv=next[k],pv=prev[k];
                if(nv==null||nv==='')continue;
                if(typeof nv==='number'&&nv===0&&typeof pv==='number'&&pv>0)continue;
                if(typeof nv==='string'&&!nv&&pv)continue;
                prev[k]=nv;
            }
            return prev;
        }
        /* fromDoor — поля выдачи файла (window.__resultDoor решил, что им место
           здесь): в чужое открытое окно они только ДОПИСЫВАЮТСЯ, а событие,
           которое начала дверь и в которое потом пришёл вызов тула, перестаёт
           быть «от двери» (src:'download' снимается — это результат тула). */
        function _sendComplete(d,fromDoor){
            if(!d)d={};
            if(!fromDoor)_bufOwn=true;
            if(fromDoor&&_completeBuf){
                for(var _k in d){if(_completeBuf[_k]==null||_completeBuf[_k]==='')_completeBuf[_k]=d[_k];}
            }else _completeBuf=_mergePayload(_completeBuf||{slug:slug},d);
            if(_completeTimer)clearTimeout(_completeTimer);
            _completeTimer=setTimeout(_flushComplete,_bufOwn?800:_DOOR_WAIT_MS);
        }
        function _flushComplete(){
                if(_completeTimer){clearTimeout(_completeTimer);_completeTimer=null;}
                var payload=_completeBuf;
                if(!payload)return;
                var staged=_bufStaged;
                if(_bufOwn&&(payload.src==='download'||payload.src==='copy'))delete payload.src;
                _completeBuf=null;_completeTimer=null;_bufOwn=false;_bufStaged=false;
                if(_encStart){payload.encode_sec=Math.round((Date.now()-_encStart)/1000);_encStart=0;}
                // exec_ms — сумма длительностей вызовов движков (FFmpeg / WebCodecs /
                // canvas) для ЭТОГО результата; копится в самих движках на
                // window.__execWork, потому что они грузятся раньше нас. В отличие
                // от proc_sec не зависит от пауз человека между шагами. Отдали —
                // обнулили, чтобы следующий результат начал с нуля.
                // В миллисекундах: copy-режим укладывается в десятки мс, и в секундах
                // медиана такого тула читалась бы как «0» — потеря всей информации.
                try{var __w=window.__execWork;if(__w&&__w.n){payload.exec_ms=Math.round(__w.ms);payload.exec_n=__w.n;__w.ms=0;__w.n=0;}}catch(_){}
                // Wave 1 breadcrumbs (2026-06-01): enrich every tool_complete
                // with device-class fields so /pino can slice success rate
                // by mobile/desktop / browser / memory. Pre-fix every
                // enhance-video tool_complete had mob=NULL (100 % of 589
                // events / 16 h). Mirrors __aeError:4614 and __aeToolError:4938.
                if(payload._b==null)payload._b=_br;
                if(payload.mob==null)payload.mob=_mob;
                if(payload.devMem==null)payload.devMem=_devMem;
                if(payload.maxMB==null)payload.maxMB=_maxMB;
                window.__ae('tool_complete',payload);
                // Стадию окна двери поставила сама выдача (ниже) — второй complete→complete не нужен.
                if(window.__stage&&!staged)try{window.__stage('complete',payload)}catch(_){}
        }
        /* Конец ожидания двери: новый жест человека — граница результата. */
        var _doorWaitEnds=function(){if(_completeBuf&&!_bufOwn)_flushComplete();};
        window.addEventListener('pointerdown',_doorWaitEnds,true);
        window.addEventListener('keydown',_doorWaitEnds,true);
        /* Уход: открытое окно — сразу в очередь, и очередь — в сеть (её pagehide-слушатель стоит раньше). */
        var _completeOnLeave=function(){if(!_completeBuf)return;_flushComplete();try{window.__aeFlush&&window.__aeFlush()}catch(_){}};
        document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')_completeOnLeave();});
        window.addEventListener('pagehide',_completeOnLeave);
        /* Выдача файла — результат только там, где тул его не объявил сам, и
           без имени файла: правило и замер — у window.__resultDoor выше. */
        window.addEventListener('file-downloaded',function(e){
            var d=window.__resultDoor.door(e&&e.detail,!!_completeBuf);
            if(d.act==='skip'){window.__resultDoorStage(d.p);return;}
            /* Файл у человека — стадия `complete` сейчас, а не когда закроется окно: уход в это окно
               иначе читался бы «брошенной обработкой» (#1822). */
            if(d.act==='complete'){window.__resultDoorStage(d.p);_bufStaged=true;}
            _sendComplete(d.p,true);
        });
        // Encode timer — set explicitly by tools that wrap FFmpeg.process so
        // tool_complete payload carries actual processing time. proc_sec (legacy,
        // counts from workspace activation) stays for backward compat.
        var _encStart=0;
        window.__startEncodeTimer=function(){_encStart=Date.now()};
        // Auto-cache files on selection AND drag-drop to prevent FILE_LOST.
        // Two contracts that interact badly without care:
        //   1) FFmpegProcessor exists on EVERY page as a __sharedModule queue-stub
        //      (timbrica-core.js). `window.FFmpegProcessor && FFmpegProcessor.cacheFile`
        //      is therefore truthy everywhere — including on pure-JS tools (qr-code,
        //      colorblind-simulator, gif-compressor, social-photo-resize, etc.) that
        //      never load the real ffmpeg-processor.js script. Calling cacheFile
        //      on the stub queues a deferred Promise that rejects after 15 s with
        //      "module never loaded (15s timeout)" → unhandled rejection → Sentry.
        //      Telemetry 30 d: ~1500 such errors across 30+ tools, gif-compressor
        //      alone 336. (2026-05-03 root-cause investigation, see tool_gif_compressor.md.)
        //   2) Even on FFmpeg tools, the script may load slightly AFTER the user's
        //      first drop (rare, but happens on cold caches over 3G). In that case
        //      we still want to cache once the real impl arrives.
        // Fix: gate the page on actual ffmpeg-processor.js script tag presence (the
        // same signal pageUsesFFmpeg() uses for warm-up). No tag → no listeners,
        // no queue, no stub-leaked rejections. Tag present but stub still installed
        // → use _hasReal() discriminator and queue until real impl drains.
        var _pendingCacheFiles=[];
        function _hasReal(){return !!(window.FFmpegProcessor && !window.FFmpegProcessor.__isStub && FFmpegProcessor.cacheFile);}
        function _cacheInputFiles(files){
            if(!files)return;
            var arr=[];for(var i=0;i<Math.min(files.length,10);i++)arr.push(files[i]);
            if(_hasReal()){
                arr.forEach(function(f){try{FFmpegProcessor.cacheFile(f)}catch(e){}});
            }else{
                // Real impl not drained yet — queue files, cache when stub is replaced
                _pendingCacheFiles=_pendingCacheFiles.concat(arr);
                if(!window._cacheRetryTimer){
                    window._cacheRetryTimer=setInterval(function(){
                        if(_hasReal()){
                            clearInterval(window._cacheRetryTimer);window._cacheRetryTimer=null;
                            _pendingCacheFiles.forEach(function(f){try{FFmpegProcessor.cacheFile(f)}catch(e){}});
                            _pendingCacheFiles=[];
                        }
                    },1000);
                    setTimeout(function(){if(window._cacheRetryTimer){clearInterval(window._cacheRetryTimer);window._cacheRetryTimer=null;_pendingCacheFiles=[]}},30000);
                }
            }
        }
        if(document.querySelector('script[src*="ffmpeg-processor.js"]')){
            document.addEventListener('change',function(e){
                if(e.target.type==='file'&&e.target.files)_cacheInputFiles(e.target.files);
            },true);
            document.addEventListener('drop',function(e){
                if(e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files.length)_cacheInputFiles(e.dataTransfer.files);
            },true);
        }
        // (Патч клика по <a download>, превращающий программную выдачу в
        //  `file-downloaded`, переехал в всегда-включённую часть выше — к
        //  window.__resultDoor: здесь, за согласием, его не было у тех, кто от
        //  аналитики отказался, и классическая выдача у них молчала целиком.)
        // Auto: track processing time (workspace active → tool_complete)
        var _procStartTime=0;
        window.addEventListener('workspace-activated',function(){_procStartTime=Date.now();
            // Новый файл — новый счёт: работа движков по прошлому файлу не
            // должна попасть в exec_sec следующего результата.
            try{var w=window.__execWork;if(w){w.ms=0;w.n=0;}}catch(_){}});
        // Patch __aeToolComplete to include processing time + dedup
        window.__aeToolComplete=function(p){
            var d=Object.assign({},p||{});
            if(_procStartTime){d.proc_sec=Math.round((Date.now()-_procStartTime)/1000);_procStartTime=0;}
            if(window.FormatSmart&&FormatSmart.getChannels){var ch=FormatSmart.getChannels();if(ch&&ch!=='auto')d.channels=ch;}
            _sendComplete(d);
        };
        // Wave 1 helper (2026-06-01) — same device-class enrichment used by
        // _sendComplete, exposed for direct __ae('tool_complete',…) callers
        // that can't go through the 800 ms debounce (clipboard, screen-result
        // observer) without losing semantics.
        function _enrichComplete(p){
            p=p||{slug:slug};
            if(p._b==null)p._b=_br;
            if(p.mob==null)p.mob=_mob;
            if(p.devMem==null)p.devMem=_devMem;
            if(p.maxMB==null)p.maxMB=_maxMB;
            return p;
        }
        // Auto: clipboard copy = tool_complete for text tools — the copied text
        // IS the result (a generated word, password, hash, JSON, etc) — but only
        // where the tool has not announced its result itself: the copy goes
        // through the same door as a download (window.__resultDoor.copy, above;
        // numbers in docs/why/primitives/result-door.md). Before 16.10.2026 every
        // copy was its own tool_complete, past the merge window.
        // EXCEPTION: a copied self-origin URL is a share / invite / "copy link"
        // action (room codes for the P2P games & room tools, shareable-state
        // links), NOT the tool's product, so it must not count as a completion.
        // Without this guard every "copy invite link" fired a false tool_complete
        // and inflated completion funnels (feedback 2026-06-23, /air-hockey-game:
        // copying the room link counted as finishing the game).
        // Копирование приходит шиной `tmb:result-copy` (блок __copyBus выше: writeText,
        // ClipboardItem, execCommand('copy'); своя ссылка туда не попадает).
        window.addEventListener('tmb:result-copy',function(e){
            try{
                var dd=(e&&e.detail)||{};
                if(!slug)return;
                var _cd=window.__resultDoor.copy(dd.text,!!_completeBuf,dd.types);
                if(_cd.act==='skip')window.__resultDoorStage(_cd.p);
                else{
                    /* как у выдачи файла: стадия `complete` сейчас, окно двери ждёт следующего жеста */
                    if(_cd.act==='complete'){window.__resultDoorStage(_cd.p);_bufStaged=true;}
                    _sendComplete(_cd.p,true);
                }
            }catch(_){}
        });
        // Global file context for error reporting — auto-captured from all file inputs
        window.__currentFileInfo=null;
        window.__setFileInfo=function(file){
            if(!file)return;
            var name=(file.name||'').toLowerCase();
            var ext=name.split('.').pop()||'';
            window.__currentFileInfo={ext:ext,size:file.size||0,type:file.type||''};
        };
        // Auto-capture file info from any file input or drop event
        document.addEventListener('change',function(e){
            var t=e.target;if(t&&t.type==='file'&&t.files&&t.files[0])window.__setFileInfo(t.files[0]);
        },true);
        document.addEventListener('drop',function(e){
            var f=e.dataTransfer&&e.dataTransfer.files;if(f&&f[0])window.__setFileInfo(f[0]);
        },true);
        // Auto: tool_error — patch __handleError after timbrica-core.js defines it
        var _ua=navigator.userAgent;
        // YaBrowser must come BEFORE Chrome/Safari — its UA contains both
        // tokens (the Yandex Browser is a Chromium fork on Android + a
        // Safari WebKit wrapper on iOS), so the Edge/CriOS/Chrome/Safari
        // ladder mis-buckets every Yandex session as one of those upstream
        // browsers. Pre-fix telemetry split Yandex sessions across two
        // dashboard buckets — undercounted Yandex Browser cohort by ~half
        // (2026-05-30 workflow audit).
        // ⚠️⚠️ Вендорские оболочки и встроенные браузеры приложений ДО Chrome:
        // их UA несёт токен Chrome, поэтому прежняя лестница записывала их всех
        // в 'chrome', и целый класс был для нас невидим. Цена этой слепоты
        // измерена 19.09.2026: Премиум-пользовательница перешла из
        // Яндекс-браузера во встроенный браузер Xiaomi, и там множественный
        // выбор фотографий перестал доходить до страницы — а в телеметрии оба
        // браузера выглядели одинаково, и найти оболочку удалось только по
        // User-Agent из диагностического снимка поддержки, не по данным.
        // ⚠️ Ряды 'chrome' ДО и ПОСЛЕ этой правки несравнимы: из него выйдут
        // miui/samsung/huawei/android-wv и приложения. Это не падение Chrome.
        // ⚠️ 'ya-app' — оба диалекта UA приложения Яндекса: старый
        // (…YaSearchApp/x webOmni) и новый (…YaApp_Android/x YaSearchBrowser/x
        // BroPP/1.0, без YaSearchApp) — четверть трафика приложения. До
        // 26.09.2026 здесь был только старый, и новый писался в 'chrome':
        // Премиум-пользовательница, два часа не могшая сохранить файл, в
        // данных выглядела обычным Chrome. Ряды 'chrome' и 'ya-app' до и после
        // этой правки несравнимы. Набор токенов общий с детекторами в
        // timbrica-core.js — YandexAppUaIsOneRuleTest.
        window.__brOf=function(ua){ua=ua||'';
            return /YaSearchApp|YaSearchBrowser|YaApp_Android|webOmni/.test(ua)?'ya-app'
                :/YaBrowser/.test(ua)?'yandex'
                :/MiuiBrowser/.test(ua)?'miui'
                :/SamsungBrowser/.test(ua)?'samsung'
                :/HuaweiBrowser|HuaweiChrome/.test(ua)?'huawei'
                :/\bOPR\/|OPiOS|\bOpera/.test(ua)?'opera'
                :/FBAN|FBAV|FB_IAB/.test(ua)?'fb-app'
                :/Instagram/.test(ua)?'ig-app'
                :/VKAndroidApp|VKClient/.test(ua)?'vk-app'
                :/Edg/.test(ua)?'edge'
                :/CriOS/.test(ua)?'chr-ios'
                :/FxiOS/.test(ua)?'fx-ios'
                // «; wv)» — метка Android WebView: так себя называет страница,
                // открытая ВНУТРИ приложения (почта, мессенджер, маркетплейс),
                // а не в браузере. У такой оболочки свой файловый пикер.
                :/;\s*wv\)/.test(ua)?'android-wv'
                :/Chrome/.test(ua)?'chrome'
                // WKWebView на iOS не пишет токен Safari — этим он и отличим
                // от настоящего Safari, у которого он есть всегда.
                :(/iPhone|iPad|iPod/.test(ua)&&!/Safari/.test(ua))?'ios-wv'
                :/Safari/.test(ua)?'safari'
                :/Firefox/.test(ua)?'firefox'
                :'other';};
        var _br=window.__brOf(_ua);
        var _mob=/Mobi|Android/i.test(_ua)?1:0;
        // Device info for telemetry only (not used for limits)
        var _isMob=/Mobi|Android|iPhone|iPad/i.test(_ua);
        var _devMem=navigator.deviceMemory||0;
        // _maxMB is a GLOBAL telemetry-enrichment field — NOT the upload
        // size cap. It is hardcoded 0 ("no artificial limit") and auto-
        // merged into every feature_use/tool_complete/tool_error/
        // tool_diagnostic payload below. The /trim 2026-06-07 bug report
        // (potolok62@inbox.ru) had a payload with maxMB:0 that looked like
        // a zero-cap rejection — it wasn't. The uploader's REAL adaptive
        // cap comes from window.__effectiveFileLimit(kind) (see tool-
        // uploader.js:497 and __FILE_LIMITS at app.blade.php:2587) and is
        // exposed under a different JSON path. If you grep for "maxMB" in
        // a telemetry trace, you're looking at this enrichment, not a cap.
        var _maxMB=0;
        window.__devMem=_devMem;window.__maxMB=_maxMB;
        window.addEventListener('DOMContentLoaded',function(){
            var orig=window.__handleError;
            if(!orig)return;
            window.__handleError=function(err,ctx){
                // Normalize ctx to a string up-front. Most call sites pass a
                // string ("Script error @file.js:42"), but some tools pass an
                // object like {slug:'screen-recorder'} for richer telemetry
                // payload. Previously this branch did ctx.indexOf(...) which
                // throws TypeError on an object ctx, and the throw is
                // swallowed by the orchestrator's try/catch — silently killing
                // the error UI for every tool that passes object ctx
                // (Ольга #584: 1.5 h recording lost, never saw any error msg,
                // because screen-recorder.blade passed {slug:'screen-recorder'}
                // and this filter blew up). Normalize so the downstream regex
                // and indexOf calls all see a real string.
                if(ctx&&typeof ctx!=='string'){
                    try{ ctx=(ctx.slug||ctx.context||ctx.where||JSON.stringify(ctx)||'').slice(0,80); }
                    catch(_){ ctx=String(ctx); }
                }
                // User actions (permission denied, no device) are not bugs — skip telemetry
                var eName=err&&err.name||'';
                if(eName==='NotAllowedError'||eName==='NotFoundError'||eName==='NotReadableError'||eName==='OverconstrainedError')return orig.apply(this,arguments);
                var m=err&&err.message||String(err);
                if(m.indexOf('ResizeObserver loop')!==-1||m.indexOf('no supported sources')!==-1||m.indexOf('Script error')!==-1||m==='undefined'||m.indexOf('Background Sync')!==-1||m.indexOf('@'+'context')!==-1||m.indexOf('terminate()')!==-1||m.indexOf('FetchEvent.respondWith')!==-1||m.indexOf('chrome-extension://')!==-1||m.indexOf('moz-extension://')!==-1||m.indexOf('isMetaMask')!==-1||(ctx&&ctx.indexOf('chrome-extension://')!==-1)||(ctx==='Unhandled promise'&&m==='Load failed')||(ctx==='Unhandled promise'&&m.indexOf('Unable to decode')!==-1)||(ctx==='Unhandled promise'&&m.indexOf('Decoding failed')!==-1)||(ctx==='Unhandled promise'&&m.indexOf('PIPELINE_ERROR')!==-1))return orig.apply(this,arguments);
                // Third-party library internal errors — we always wrap their calls in try/catch
                // and have our own fallback paths, so these script-level throws are noise.
                // (heic2any retired 2026-06-20 — HEIC decodes via heic-to now, whose
                // errors are caught by HeicDecode's try/catch, so no entry is needed.)
                // Sentry bundle.min.js 8.55.0 has its own null-classList.contains deref
                // (~14 events/day across all tools, all pointed at line 2:49111). It's
                // upstream SDK code, our wrappers already catch the original error so
                // suppressing the reporter's self-fail keeps tool_error noise honest.
                if(ctx&&/pdfjs.*worker|tesseract\.min\.js|html2pdf\.min\.js|ffmpeg\/umd|sentry[\\\/]bundle|^\/?vendor\/sentry|bundle\.min\.js/i.test(ctx))return orig.apply(this,arguments);
                var payload={slug:slug,msg:window.__ffMsg(m,200),ctx:ctx||'',br:_br,mob:_mob,t:Math.round(performance.now()/1000),devMem:_devMem,maxMB:_maxMB};
                if(window.__currentFileInfo)payload.file=window.__currentFileInfo;
                // AudioContext state(s) — helps diagnose null analyser/panner errors
                if(window.__acPool&&window.__acPool.length){
                    var acs=[];for(var i=0;i<window.__acPool.length;i++){try{acs.push(window.__acPool[i].state)}catch(e){acs.push('err')}}
                    payload.ac=acs.join(',');
                }
                window.__ae('tool_error',payload);
                return orig.apply(this,arguments);
            };
        });
        // (Removed duplicate file-downloaded listener — _sendComplete above
        //  already handles this path with debounce+merge so tools no longer
        //  emit two separate tool_complete rows per export.)
        /* Здесь стояла обёртка getUserMedia с комментарием о том, что она
           что-то делает. Тело было `.catch(function(err){ throw err; })` —
           поймать и перебросить, то есть ничего, ценой лишнего промиса на
           КАЖДЫЙ вызов камеры на сайте. Снята 19.09.2026, а настоящая сетка
           безопасности (сторож зависания для вызовов мимо CameraManager)
           живёт в timbrica-core.js — снаружи `if (!consentOK()) return;`,
           потому что повисшая камера про согласие не знает. */
        // window.__ensureFFmpeg lives in the layout since 2026-09-23 (next to
        // __hasRealFFmpeg). Here it sat below this closure's consent gate, so
        // a visitor with DNT or a declined/unanswered banner had no such
        // function while /denoise called it unguarded.
        // Global helper: load external library with CDN → local fallback + telemetry
        // Usage: await __loadLib('html2pdf', 'https://cdn.jsdelivr.net/...', '/vendor/html2pdf/...')
        //   or:  await __loadLib('pdfjs', cdnUrl, localUrl, 'module')  for ESM
        // Returns: true if loaded, throws if both fail
        // Logs: lib_fallback (CDN failed, local worked), lib_fail (both failed)
        window.__loadLib = function(name, cdnUrl, localUrl, type) {
            return new Promise(function(resolve, reject) {
                function logEvent(evt, src, err) {
                    if (window.__ae) window.__ae('tool_error', {
                        slug: (document.querySelector('meta[name="tool-slug"]') || {}).content || '',
                        msg: 'lib_' + evt + ': ' + name,
                        ctx: 'lib-load|src=' + src + (err ? '|err=' + (err.message || '').substring(0, 100) : ''),
                        br: window.__BR || '', mob: /Mobi|Android/i.test(navigator.userAgent) ? 1 : 0
                    });
                }
                function loadScript(url, onOk, onFail) {
                    if (type === 'module') {
                        import(url).then(function(m) { onOk(m); }).catch(onFail);
                        return;
                    }
                    var s = document.createElement('script');
                    s.src = url;
                    s.onload = function() { onOk(); };
                    s.onerror = function() { onFail(new Error('Script load failed: ' + url)); };
                    document.head.appendChild(s);
                }
                loadScript(cdnUrl, function(mod) {
                    resolve(mod || true);
                }, function(cdnErr) {
                    if (!localUrl) { logEvent('fail', cdnUrl, cdnErr); reject(cdnErr); return; }
                    logEvent('fallback', cdnUrl, cdnErr);
                    loadScript(localUrl, function(mod) {
                        resolve(mod || true);
                    }, function(localErr) {
                        logEvent('fail', localUrl, localErr);
                        reject(localErr);
                    });
                });
            });
        };

        // Auto: wrap FFmpegProcessor methods to report errors for ALL tools (lazy-loaded)
        (function(){
            var _patched=false;
            function _patchFFmpeg(){
                if(_patched||!window.FFmpegProcessor)return;
                _patched=true;
                // Cancel workspace timer when FFmpeg starts (init/probe may take time before process)
                ['init','probe'].forEach(function(name){
                    var orig=FFmpegProcessor[name];
                    if(typeof orig!=='function')return;
                    FFmpegProcessor[name]=async function(){
                        if(window.__wsTimer){clearTimeout(window.__wsTimer);window.__wsTimer=null;window.__wsChecked=true}
                        // Auto-retry init on network/timeout failures (not on OOM or logic errors).
                        // Also log which attempt succeeds so we can monitor CDN/network issues.
                        if(name!=='init')return orig.apply(this,arguments);
                        var lastErr=null;
                        for(var attempt=0;attempt<3;attempt++){
                            try{
                                var res=await orig.apply(this,arguments);
                                if(attempt>0&&window.__ae){window.__ae('tool_diagnostic',{slug:slug,error_type:'ffmpeg_init_retry_ok',attempts:attempt+1})}
                                return res;
                            }catch(e){
                                lastErr=e;
                                /* A cancel is not a failure to retry: init(n,{signal}) rejects
                                   with AbortError when the export of the caller was cancelled while
                                   the engine was still downloading (report 16.09: six Cancel
                                   clicks into a 73-min wait). Retrying it three times here
                                   turned the cancel into a 4-s delay before the export noticed. */
                                if(e&&e.name==='AbortError')break;
                                var em=(e&&e.message||String(e)).toLowerCase();
                                // Only retry on network-looking errors — don't retry programming bugs
                                var retryable=/network|timeout|fetch|load|abort|503|502|504|429|offline/i.test(em);
                                if(!retryable||attempt===2)break;
                                // Exponential backoff: 1s, 3s
                                await new Promise(function(r){setTimeout(r,attempt===0?1000:3000)});
                            }
                        }
                        throw lastErr;
                    };
                });
                ['process','processMulti','processSegments','concatSegments','reencodeAndConcat'].forEach(function(name){
                    var orig=FFmpegProcessor[name];
                    if(typeof orig!=='function')return;
                    // Stash the captured original on the object itself so (a) reinit() or a
                    // late-loading second script instance can still reach it via the dotted
                    // name, and (b) if something ever pulls `orig` out of our closure we
                    // get a diagnostic rather than a cryptic "undefined.apply" crash.
                    FFmpegProcessor['_orig_'+name]=orig;
                    FFmpegProcessor[name]=async function(){
                        if(window.__wsTimer){clearTimeout(window.__wsTimer);window.__wsTimer=null;window.__wsChecked=true}
                        var _fn=orig;
                        if(typeof _fn!=='function'){
                            // Closure unexpectedly lost `orig`. Surface WHY via diagnostic
                            // telemetry so we can find the root cause instead of patching
                            // around it. Common suspects: FFmpegProcessor redefined by a
                            // duplicate script load; method reassigned by the library.
                            try{window.__ae&&window.__ae('tool_diagnostic',{slug:slug,error_type:'ffmpeg_orig_missing',method:name,have_obj:!!window.FFmpegProcessor,have_method:window.FFmpegProcessor&&typeof window.FFmpegProcessor[name],have_stash:window.FFmpegProcessor&&typeof window.FFmpegProcessor['_orig_'+name]})}catch(_){}
                            _fn=window.FFmpegProcessor&&window.FFmpegProcessor['_orig_'+name];
                            if(typeof _fn!=='function')_fn=window.FFmpegProcessor&&window.FFmpegProcessor[name];
                            if(typeof _fn!=='function')throw new Error('FFmpegProcessor.'+name+' unavailable (see tool_diagnostic)');
                        }
                        try{return await _fn.apply(this,arguments)}
                        catch(err){
                            try{
                                var em=err&&err.message||String(err);
                                if(em.indexOf('terminate()')!==-1){throw err}// user cancelled — not a bug
                                if(window.__suppressWasmLog){throw err}// retry in progress — tool logs once at end
                                // Typed user-input errors (FileTooLargeError from auto-guard, etc.)
                                // are NOT WASM bugs — they were thrown intentionally before FFmpeg ran.
                                // Let them bubble without wasm_process telemetry; __handleError routes
                                // them to tool_blocked with the right reason.
                                if(err&&(err.name==='InvalidInputError'||err.name==='FileTooLargeError'||err.code==='FFMPEG_MEMORY_GUARD')){throw err}
                                if(window.ToolErrors&&window.ToolErrors.InvalidInputError&&err instanceof window.ToolErrors.InvalidInputError){throw err}
                                var _f=arguments[0];
                                var fs=_f&&(_f.size||_f.byteLength)||0;
                                var ft=_f&&_f.type||'';
                                var fn=_f&&_f.name||'';
                                var out=(name==='reencodeAndConcat'?arguments[3]:arguments[2])||'';
                                // Strip FFmpeg version/library noise from error message — keeps only real errors
                                var cleanEm=em.replace(/\s*lib(av|sw|post)\w+\s+\d+\.\s*\d+\.\d+\s*\/\s*\d+\.\s*\d+\.\d+\s*/g,'').replace(/\s*\|\s*\|\s*/g,' | ').replace(/^\s*FFmpeg exit code \d+:\s*\|\s*/,'FFmpeg exit code: ').trim();
                                if(!cleanEm||cleanEm.length<10)cleanEm=em;// fallback if filter removed everything
                                // Capture FFmpeg args for diagnostics (args = arguments[1] in process())
                                var _args=arguments[1];
                                var argsStr='';
                                if(Array.isArray(_args)){var vfIdx=_args.indexOf('-vf');if(vfIdx!==-1)argsStr=_args[vfIdx+1]||'';if(!argsStr){var fcIdx=_args.indexOf('-filter_complex');if(fcIdx!==-1)argsStr=(_args[fcIdx+1]||'').substring(0,150)}}
                                var payload={slug:slug,error_type:'wasm_process',method:name,err_msg:window.__ffMsg(cleanEm,400),file_size:fs,file_type:ft,file_name:fn.split('.').pop(),out_name:out,br:_br,mob:_mob,devMem:_devMem,maxMB:_maxMB};
                                if(argsStr)payload.vf=argsStr.substring(0,200);
                                // repair-video's whole job is to process files that FFmpeg rejects (moov
                                // missing, bad streams, etc.). Failed strategies there are an expected
                                // diagnostic signal, not a bug in our code.
                                var _errEvt=(slug==='repair-video')?'tool_diagnostic':'tool_error';
                                window.__ae(_errEvt,payload);
                                // Suggest repair-video for corrupted video files (not on repair-video itself)
                                if(slug&&slug!=='repair-video'&&/moov atom|Invalid data.*process|No start code|NAL unit|corrupt|truncat|EBML.*pars|end of file|unexpected end/i.test(em)){
                                    setTimeout(function(){
                                        if(document.getElementById('repairHint'))return;
                                        var tc=document.getElementById('toastContainer');if(!tc)return;
                                        var repairTexts={en:'Video file appears damaged.',ru:'\u0412\u0438\u0434\u0435\u043e\u0444\u0430\u0439\u043b \u043f\u043e\u0432\u0440\u0435\u0436\u0434\u0451\u043d.',ko:'\ube44\ub514\uc624 \ud30c\uc77c\uc774 \uc190\uc0c1\ub418\uc5c8\uc2b5\ub2c8\ub2e4.',ar:'\u0645\u0644\u0641 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u062a\u0627\u0644\u0641.',id:'File video rusak.',pt:'O arquivo de v\u00eddeo est\u00e1 danificado.',de:'Die Videodatei scheint besch\u00e4digt zu sein.',es:'El archivo de video parece da\u00f1ado.',fr:'Le fichier vid\u00e9o semble endommag\u00e9.',uk:'\u0412\u0456\u0434\u0435\u043e\u0444\u0430\u0439\u043b \u043f\u043e\u0448\u043a\u043e\u0434\u0436\u0435\u043d\u043e.'};
                                        var repairCta={en:'Try Repair Video tool \u2192',ru:'\u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u041f\u043e\u0447\u0438\u043d\u0438\u0442\u044c \u0432\u0438\u0434\u0435\u043e \u2192',ko:'\ube44\ub514\uc624 \ubcf5\uad6c \ub3c4\uad6c \uc0ac\uc6a9 \u2192',ar:'\u062c\u0631\u0651\u0628 \u0623\u062f\u0627\u0629 \u0625\u0635\u0644\u0627\u062d \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u2192',id:'Coba alat Perbaiki Video \u2192',pt:'Experimente a ferramenta Reparar V\u00eddeo \u2192',de:'Tool \u201eVideo reparieren\u201c testen \u2192',es:'Prueba la herramienta Reparar video \u2192',fr:'Essayez l\u2019outil R\u00e9parer la vid\u00e9o \u2192',uk:'\u0421\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0456\u043d\u0441\u0442\u0440\u0443\u043c\u0435\u043d\u0442 \u00ab\u0412\u0456\u0434\u043d\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0432\u0456\u0434\u0435\u043e\u00bb \u2192'};
                                        var lo=locale||'en';
                                        var el=document.createElement('div');el.id='repairHint';
                                        el.className='toast-msg toast-msg--info show';el.setAttribute('role','alert');
                                        el.innerHTML='<svg class="toast-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span>'+(repairTexts[lo]||repairTexts.en)+' <a href="/'+lo+'/repair-video" style="color:var(--accent);text-decoration:underline">'+(repairCta[lo]||repairCta.en)+'</a></span><button class="toast-close" aria-label="Close">&times;</button>';
                                        tc.appendChild(el);
                                        el.querySelector('.toast-close').onclick=function(){el.remove()};
                                        setTimeout(function(){if(el.parentNode)el.remove()},15000);
                                    },800);
                                }
                            }catch(e){if(e===err)throw e}
                            throw err;
                        }
                    };
                });
            }
            var _iv=setInterval(function(){if(window.FFmpegProcessor){_patchFFmpeg();clearInterval(_iv)}},500);
            setTimeout(function(){clearInterval(_iv)},30000);
        })();
        // (file caching moved to global _cacheInputFiles above)
        // Workspace placeholder click → open file picker (works for all tools)
        document.addEventListener('click',function(e){
            var ph=e.target.closest('.workspace-placeholder');
            if(!ph)return;
            var ws=ph.closest('.workspace');
            if(ws&&ws.classList.contains('active'))return; // already has file
            var fi=document.querySelector('.upload-zone input[type=file], [id*="FileInput"], [id*="fileInput"], [id*="file-input"]');
            if(fi)fi.click();
        });
        // Track "Another file" clicks (delegated — works for all tools)
        document.addEventListener('click',function(e){
            var btn=e.target.closest('[id*="NewFileBtn"],[id*="new-file-btn"],[id*="newBtn"],[id*="NewBtn"],[id*="anotherBtn"]');
            if(btn&&slug)window.__ae('feature_use',{slug:slug,action:'new_file'});
        });
        // Session start (once per session). Server-side UA parser enriches
        // the payload with {_ua:{os,osv,br,brv,engine}} at ingest time —
        // adding OS/browser parsing here too would duplicate that work and
        // bloat the beacon. Just carry the two flags the server can't infer
        // from UA alone: PWA install state (display-mode:standalone) and
        // in-app WebView detection (already done in timbrica-core.js).
        // ── Пререндер: считать сессию только после активации ──
        //
        // Chrome выполняет скрипты пререндеренной страницы ДО того, как её
        // открыл человек. Сессия, засчитанная там, — это знаменатель во ВСЕХ
        // воронках без единого шанса дойти до числителя: человек не открывал
        // страницу и ничего на ней не сделает. Тот же капкан уже накручивал
        // «использовал тул» и реф-визиты (timbrica-core.js) — там его закрыли,
        // а здесь он стоял открытым.
        //
        // Сервер свою часть уже держит (TrackUserActivity::isSpeculativeFetch
        // по Sec-Purpose), но заголовок не останавливает JS внутри страницы.
        //
        // `pr:1` на session_start — чтобы впервые УЗНАТЬ долю пререндера:
        // сейчас она не измерена нигде, а Playwright ответить не может —
        // подключённый DevTools выключает пререндер (проверено через CDP
        // Preload: PrerenderingDisabledByDevTools).
        var _wasPrerendered = 0;
        function _afterActivation(fn){
            if (document.prerendering) {
                _wasPrerendered = 1;
                document.addEventListener('prerenderingchange', fn, { once: true });
            } else {
                // Активация могла случиться ДО того, как мы сюда дошли: тогда
                // document.prerendering уже false, но activationStart > 0.
                try {
                    var _n = performance.getEntriesByType('navigation')[0];
                    if (_n && _n.activationStart > 0) _wasPrerendered = 1;
                } catch(_) {}
                fn();
            }
        }
        _afterActivation(function(){
        // ── СКОЛЬКО пререндеров ДОШЛО до человека ──
        //
        // Поле `pr` на session_start для этого НЕ ГОДИТСЯ, и это моя же ошибка
        // от 24.08: session_start шлётся ОДИН раз за сессию (гарант `_ass`),
        // а пререндер активируется чаще всего НА ВТОРОЙ и последующих
        // страницах. То есть `pr` мерил почти невозможное событие и честно
        // показывал 0.05 % — а я чуть не прочитал это как «пререндер не работает».
        //
        // Здесь событие шлётся НА КАЖДОЙ странице, но ТОЛЬКО когда она
        // действительно была активирована из пререндера — случай редкий, то есть
        // объём мал по построению. Вместе с серверным счётчиком `spec_fetch:*`
        // это даёт наконец обе половины: сколько предзагрузили и сколько
        // пригодилось. Без второй половины любой рост первой неотличим
        // от чистой траты трафика человека.
        if(_wasPrerendered){
            try{
                var _nav = performance.getEntriesByType('navigation')[0];
                window.__ae('feature_use', {
                    action: 'prerender_activated',
                    mob: /Mobi/i.test(navigator.userAgent)?1:0,
                    // Сколько времени страница готовилась ДО активации — это и есть
                    // выигранное время, ради которого всё затевалось.
                    saved_ms: _nav ? Math.round(_nav.activationStart||0) : 0
                });
            }catch(_){}
        }
        if(!sessionStorage.getItem('_ass')){
            sessionStorage.setItem('_ass','1');
            var _pwa=(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||window.navigator.standalone===true?1:0;
            var _wv=window.__isWebView?1:0;
            // `ia` is the wider question — an in-app browser with no address bar,
            // whether or not its engine is crippled. Reported separately because
            // it was invisible until 2026-08-03: a sixth of RU mobile traffic is
            // the Yandex Search app's in-app browser and `wv` said 0 for all of it.
            var _ia=window.__isInAppBrowser?1:0;
            // Тема: `th` — что РЕАЛЬНО применено (light/dark), `thp` — что
            // выбрал человек (light/dark/system). До 23.08.2026 доли светлой
            // темы не знал никто: заявка «сделайте экран светлее» на карте
            // не с чем было сопоставить, потому что вопрос «а сколько у нас
            // вообще людей на светлой теме» не имел ответа ни в одной строке.
            var _rt=document.documentElement;
            window.__ae('session_start',{
                w:screen.width, h:screen.height,
                m:/Mobi/i.test(navigator.userAgent)?1:0,
                pwa:_pwa, wv:_wv, ia:_ia,
                dpr:window.devicePixelRatio||1,
                th:_rt.getAttribute('data-theme')||'',
                thp:_rt.getAttribute('data-theme-pref')||'',
                pr:_wasPrerendered,
            });
        }
        });
        // Scroll depth removed — GA/Metrika track this natively
        // Search query tracking removed — not used for decisions

        // Web Vitals removed — PageSpeed Insights / Search Console provide accurate CWV data

        // ── Tool Funnel — file_select only (processing tracked via perf, complete via tool_complete) ──
        if(slug){
            window.__aeFunnel=function(stage,data){
                if(stage==='processing'||stage==='workspace_active')return; // tracked elsewhere
                window.__ae('tool_funnel',Object.assign({slug:slug,stage:stage},data||{}));
            };
            var _funnelSent={};
            function funnelFileSelect(f){
                if(!f)return;
                /* The error context follows the file on screen, not the first one
                   of the visit: with it set once, every later toast was filed
                   under the first photo's size and type (a /photo-repair buyer's
                   four errors on four photos all read 5695108 bytes, 2026-10-22). */
                window.__fileCtx={name:f.name,size:f.size,type:f.type||''};
                if(_funnelSent.file_select)return;_funnelSent.file_select=1;
                // dm + hintMB + fileMB: lets us later correlate "user picked
                // a file > adaptive hint" with WASM OOM to validate (or
                // tighten) __effectiveFileLimit's 250 MB/GB formula.
                var mime=f.type||'';
                var kind=/video/i.test(mime)?'video':/image/i.test(mime)?'image':'audio';
                var hintMB=0;
                if(typeof window.__effectiveFileLimit==='function'){
                    hintMB=Math.round(window.__effectiveFileLimit(kind)/1048576);
                }
                var fileMB=Math.round((f.size||0)/1048576);
                window.__aeFunnel('file_select',{
                    ext:(f.name||'').split('.').pop().toLowerCase(),
                    size:f.size,type:mime,
                    dm:navigator.deviceMemory||0,
                    hintMB:hintMB,fileMB:fileMB,
                    overHint:(hintMB && fileMB>hintMB)?1:0,
                });
                // FFmpeg WASM warmup intentionally removed from this funnel
                // 2026-05-21: it fired on EVERY raw `change`/`drop` event,
                // BEFORE the uploader's accept-gate ran — so dragging an
                // image into /enhance-video loaded 32 MB of WASM that the
                // upload was about to reject (real user log on /es). The
                // legitimate warmup path (gated by `pageUsesFFmpeg()` AND
                // by tool-uploader:file post-validation) lives in the
                // __warmUpFFmpeg IIFE above. One trigger, one gate.
            }
            document.addEventListener('change',function(e){
                var t=e.target;if(t&&t.type==='file'&&t.files&&t.files[0])funnelFileSelect(t.files[0]);
            },true);
            document.addEventListener('drop',function(e){
                var f=e.dataTransfer&&e.dataTransfer.files;if(f&&f[0])funnelFileSelect(f[0]);
            },true);
            // Paste / Web-Share-Target / programmatic picks route through the shared
            // uploader's emit() (a `tool-uploader:file` custom event), NOT a native
            // change/drop — so they never reached funnelFileSelect and the file_select
            // funnel denominator was understated (conversion looked higher than real).
            // funnelFileSelect is idempotent (_funnelSent.file_select), so this never
            // double-counts the click/drop paths that also dispatch the custom event.
            document.addEventListener('tool-uploader:file',function(e){
                var d=e.detail||{};var f=(d.files&&d.files[0])||d.file;if(f&&f.size!=null)funnelFileSelect(f);
            });
        }

        // Workspace activation — lightweight, just dispatch event for tools that need it
        if(slug){(function(){
            var ws=document.querySelector('.workspace,[class*="-workspace"]');
            if(!ws)return;
            var obs=new MutationObserver(function(){
                if(ws.classList.contains('active')){
                    try{window.dispatchEvent(new Event('workspace-activated'))}catch(e){}
                    obs.disconnect();
                }
            });
            obs.observe(ws,{attributes:true,attributeFilter:['class']});
        })()}

        // ── Processing Performance — auto-instrument FFmpegProcessor ──
        if(slug){
            window.__aePerfStart=function(){window.__perfT0=performance.now()};
            window.__aePerfEnd=function(data){
                if(!window.__perfT0)return;
                var ms=Math.round(performance.now()-window.__perfT0);
                window.__perfT0=null;
                window.__ae('perf',Object.assign({slug:slug,ms:ms},data||{}));
            };
            // Perf timing is installed inside ffmpeg-processor.js itself (see its
            // "Perf instrumentation" block). It used to be an outside patcher and
            // kept losing the wrapper-ordering race — 1.2% coverage on multi-input
            // tools, 0% on some. These two hooks stay here; the caller moved.
        }

        // ── Device Capabilities — once per session ──
        //
        // `gpu` / `gpuad` добавлены 2026-08-14. Зачем: для тяжёлых ONNX-тулов
        // единственный путь ускорения, НЕ требующий cross-origin изоляции
        // (она под постоянным запретом — ломает рекламу и bfcache), — это
        // WebGPU. Но решать, стоит ли на него опираться, было не по чему:
        // device_cap писал wasm/sab/cores/mem и молчал про GPU. Замер
        // /vocal-remover: Kim_Vocal_2 в один поток WASM даёт RTF 10.6, то есть
        // 34 минуты на медианный файл 194 с — так что вопрос «у скольких есть
        // адаптер» решает судьбу всего бесплатного лейна.
        //
        // gpu   — есть ли сам API (синхронно, дёшево)
        // gpuad — удалось ли получить АДАПТЕР: 1 да, 0 нет, -1 не ответил
        // gpudv — удалось ли создать УСТРОЙСТВО: 1 да, 0 нет, -1 не ответил
        //
        // ⚠️⚠️ Три поля, а не одно, и это не педантизм. Адаптер — НЕ устройство:
        // requestAdapter() возвращает объект, а requestDevice() падает
        // (драйвер в blocklist, нет dxil.dll, виртуалка). ORT при провайдерах
        // ['webgpu','wasm'] в этом случае МОЛЧА уходит на wasm. Замер
        // 14.08 на этом и погорел: стенд рапортовал «WebGPU есть», мерил wasm
        // и дал вывод «видеокарта не помогает». На живом устройстве Kim
        // ускорился в 25 раз (28.7 мин -> 1.1 мин). Считать по адаптеру
        // означало бы записать в «есть GPU» тех, у кого его фактически нет.
        //
        // Вторая волна полей добавлена 2026-08-24 (аудит новых возможностей
        // браузеров). Зачем отдельная запись, а не «посмотреть долю браузеров
        // в логах»: доля UA НЕ отвечает на вопрос о поддержке. Замер 24.08 по
        // access-логам дал Яндекс.Браузер 44.6 % RU-трафика — и ни одна
        // таблица совместимости в интернете не говорит, что он умеет, потому
        // что его там просто нет. Ровно так же Edge = 46 % intl. Решать
        // «внедрять ли X» по доле Chrome означало бы гадать про половину
        // аудитории.
        //
        // Принцип полей — тот же, что выстрадан выше на gpuad/gpudv: писать
        // ФАКТИЧЕСКУЮ ГОТОВНОСТЬ, а не наличие имени в window. Поэтому у
        // встроенного переводчика три состояния, а не «есть/нет»: сам объект
        // `Translator` существует задолго до того, как модель скачана, и
        // «переводчик есть» по наличию объекта — это ровно та ошибка, что
        // «GPU есть» по адаптеру.
        //
        //  tr / ld  — Translator / LanguageDetector (Chrome 138+, на устройстве):
        //             -1 нет API, 0 недоступен, 1 готов, 2 скачается по запросу,
        //             3 качается сейчас
        //  pip      — Document PiP (окно поверх других приложений)
        //  vt       — View Transitions (переходы между страницами)
        //  sr       — Speculation Rules (предзагрузка навигации)
        //  sda      — анимации по скроллу (вне главного потока — см. замер 23.08)
        //  opfs     — OPFS (файлы >2 ГиБ в обход лимита Blob)
        //  wnn      — WebNN
        //  vce      — есть ли WebCodecs-кодировщик вообще
        //  vch2/vcs2 — H.264 1080p АППАРАТНО / ПРОГРАММНО (-1 не спросили, 0 нет, 1 да).
        //  ⚠️ Имена с «2» намеренно: под vch/vcs лежат 5 дней НЕГОДНЫХ значений
        //  (сломанная строка кодека, см. ниже). Одно имя на два периода —
        //  это запрос, который молча усредняет правду с артефактом.
        //  ade/aen  — ЗВУКОВЫЕ AudioDecoder / AudioEncoder (-1 не спросили,
        //             0 нет, 1 есть). Отдельно от vce: Safari добавил
        //             AudioEncoder/AudioDecoder только в 26, а VideoEncoder
        //             у него был давно — то есть vce НЕ отвечает за звук, и
        //             считать по нему означало бы записать в «умеет» тех, у
        //             кого умеет только видео. Вопрос практический: у нас 117
        //             блейдов тянут 30 МБ FFmpeg WASM ради задач, часть
        //             которых (декод входа, перекодирование выхода) делает
        //             аппаратный кодек. Прежде чем это строить, надо знать
        //             долю ПО ВСЕЙ аудитории, а не по таблице совместимости:
        //             Яндекс.Браузер — 44.6 % RU-трафика, и его в тех
        //             таблицах просто нет.
        //
        // ⚠️ vcs — не любопытство. Открытый дефект: «Encoder creation error.»
        // на мобильных, где отказ кодировщика роняет прогон (32.6 % доходят
        // против 72.2 % на десктопе, замер 24.08). Рабочая гипотеза была — у
        // мобильного Chromium НЕТ программного H.264, поэтому там некуда
        // отступать.
        //
        // ✅ ОТВЕТ ПОЛУЧЕН 2026-09-01, гипотеза ПОДТВЕРЖДЕНА. 137 460 сессий с
        // исправленным прибором (29.08→01.09), разрез по `touch`+`mem`, потому
        // что поля `mob` тогда ещё не было:
        //
        //     сенсорные,  8 ГБ (Android)   аппаратный 93 %   ПРОГРАММНЫЙ 27 %
        //     сенсорные,  4 ГБ             аппаратный 84 %   ПРОГРАММНЫЙ 32 %
        //     сенсорные,  2 ГБ             аппаратный 68 %   ПРОГРАММНЫЙ 25 %
        //     без сенсора (десктоп)        аппаратный 77 %   ПРОГРАММНЫЙ 68 %
        //     mem=0 (WebKit/iOS)           аппаратный 97 %   ПРОГРАММНЫЙ 98 %
        //
        // То есть на Android программного H.264 нет примерно у ДВУХ ТРЕТЕЙ, и
        // отступать там действительно НЕКУДА. Практический вывод для
        // /enhance-video (372 сессии с этой ошибкой за 14 дней, все прилетают
        // как unhandledrejection): пересдача на `prefer-software`, которая
        // работает в webcodecs-pipeline, для большинства телефонов
        // бесполезна — лечить надо ГЕОМЕТРИЕЙ (апскейл ×4 просит у кодировщика
        // кадр, которого аппаратный уровень не берёт), а не подсказкой.
        //
        // ⚠️⚠️ ДАННЫЕ ЗА 24–29.08 НЕГОДНЫ — прибор был сломан (см. _encCfg ниже:
        // спрашивали Level 3.1 на кадре 1080p, что запрещено стандартом).
        // Замер по 235 105 сессиям с этим полем читался так: «H.264 умеет 1.1 %
        // десктопов против 33.4 % мобильных» — то есть гипотеза выше выглядела
        // не просто неподтверждённой, а перевёрнутой. Это артефакт вопроса, а не
        // факт об аудитории: на исправной машине сломанная строка отвечает «нет»,
        // а исправная — «да». Копить заново с даты этой правки; сравнивать
        // мобильных с десктопом можно только внутри нового периода.
        // Мораль та же, что у фикстуры 64×64 в CodecMatrix: прибор, чей вопрос
        // невалиден, отвечает про себя, а выглядит как ответ про мир.
        /* ── Who holds the gigabytes? (2026-09-26, support #649) ──────────────────
           `device_cap.su` says how much this site keeps on the device, not what. RU,
           30 d: 149 iOS sessions arrived with ≥ 5 GB of our data (mean 25.9 GB, max
           283 GB), across /video-compressor, /video-trim, /extract-audio,
           /enhance-video, /add-music-to-video…; on the iPad of support #649 55.5 GB of
           it sat on the device while the Photos picker, which needs free space to
           hand a 4K video over, delivered nothing for 35 minutes. Android shows the
           class barely (6 sessions ≥ 5 GB): Chrome evicts, WebKit keeps. This reports
           the breakdown — OPFS by prefix/directory, Cache Storage by cache, IndexedDB
           by name — only where there is something to explain (≥ 1 GB), once a page,
           after the page has settled. Read-only: nothing is deleted here. */
        function _storageBreakdown(suMB){
            if(window.__storageBreakdownSent) return; window.__storageBreakdownSent=true;
            var out={su:suMB,opfs:{},caches:{},cacheN:{},opaque:0,idb:''}, jobs=[];
            function mb(n){return Math.round(n/1048576);}
            function grp(name){ return String(name).replace(/[0-9a-f]{8,}.*$/i,'*').replace(/\d{6,}.*$/,'*').replace(/-\d+-\d+$/,'-*').slice(0,28); }
            function add(k,n){ out.opfs[k]=(out.opfs[k]||0)+n; }
            if(navigator.storage&&typeof navigator.storage.getDirectory==='function') jobs.push(navigator.storage.getDirectory().then(async function(root){
                var it=root.entries(), st, seen=0;
                while(!(st=await it.next()).done && seen<3000){
                    seen++; var name=st.value[0], h=st.value[1];
                    try{
                        if(h.kind==='file'){ add('f:'+grp(name),(await h.getFile()).size); }
                        else{
                            var it2=h.entries(), st2, tot=0, n2=0;
                            while(!(st2=await it2.next()).done && n2<3000){ n2++; if(st2.value[1].kind==='file') tot+=(await st2.value[1].getFile()).size; }
                            add('d:'+String(name).slice(0,24)+'('+n2+')',tot);
                        }
                    }catch(_){}
                }
            }).catch(function(){}));
            if(window.caches&&typeof caches.keys==='function') jobs.push(caches.keys().then(async function(names){
                for(var i=0;i<names.length;i++){
                    try{
                        var c=await caches.open(names[i]), reqs=await c.keys(), tot=0;
                        out.cacheN[names[i]]=reqs.length;
                        for(var j=0;j<reqs.length&&j<400;j++){
                            var r=await c.match(reqs[j]); if(!r) continue;
                            if(r.type==='opaque'){ out.opaque++; continue; }
                            tot+=+(r.headers.get('content-length')||0);
                        }
                        out.caches[names[i]]=tot;
                    }catch(_){}
                }
            }).catch(function(){}));
            if(window.indexedDB&&typeof indexedDB.databases==='function') jobs.push(indexedDB.databases().then(function(d){
                out.idb=(d||[]).map(function(x){return x.name;}).slice(0,20).join(',').slice(0,300);
            }).catch(function(){}));
            /* Storage buckets (27.09.2026): FileBytes' copies live in `copies`, saved
               work in `work` — outside the default bucket this breakdown walks. */
            if(navigator.storageBuckets&&typeof navigator.storageBuckets.keys==='function') jobs.push(navigator.storageBuckets.keys().then(function(ks){
                return Promise.all((ks||[]).slice(0,8).map(function(k){
                    return navigator.storageBuckets.open(k).then(function(b){return b.estimate();}).then(function(e){return k+'='+mb((e&&e.usage)||0);},function(){return k+'=?';});
                })).then(function(list){out.buckets=list.join(';');});
            }).catch(function(){}));
            var done=false;
            function send(){
                if(done) return; done=true;
                function top(o){ return Object.keys(o).sort(function(a,b){return o[b]-o[a];}).slice(0,8).map(function(k){return k+'='+mb(o[k]);}).join(';'); }
                var opfsT=0,cacheT=0,k; for(k in out.opfs)opfsT+=out.opfs[k]; for(k in out.caches)cacheT+=out.caches[k];
                try{ window.__ae&&window.__ae('feature_use',{f:'storage_breakdown',su:out.su,opfs_mb:mb(opfsT),cache_mb:mb(cacheT),
                    opfs:top(out.opfs).slice(0,400),caches:top(out.caches).slice(0,400),opaque:out.opaque,idb:out.idb,buckets:out.buckets||''}); }catch(_){}
            }
            Promise.all(jobs).then(send,send);
            setTimeout(send,20000);
        }
        _afterActivation(function(){
        if(!sessionStorage.getItem('_adc')){
            sessionStorage.setItem('_adc','1');
            var dc={mem:navigator.deviceMemory||0,cores:navigator.hardwareConcurrency||0,conn:(navigator.connection&&navigator.connection.effectiveType)||'',wasm:typeof WebAssembly!=='undefined'?1:0,sab:typeof SharedArrayBuffer!=='undefined'?1:0,simd:window.__noSimd?0:1,touch:'ontouchstart' in window?1:0,gpu:('gpu' in navigator)?1:0,gpuad:-1,gpudv:-1};
            // Синхронные признаки — стоят наносекунды, спрашиваем сразу.
            try{ dc.pip = (window.documentPictureInPicture && typeof window.documentPictureInPicture.requestWindow==='function')?1:0 }catch(_){ dc.pip=0 }
            try{ dc.vt  = (typeof document.startViewTransition==='function')?1:0 }catch(_){ dc.vt=0 }
            try{ dc.sr  = (typeof HTMLScriptElement!=='undefined' && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))?1:0 }catch(_){ dc.sr=0 }
            try{ dc.sda = (window.CSS && CSS.supports && CSS.supports('animation-timeline','scroll()'))?1:0 }catch(_){ dc.sda=0 }
            try{ dc.opfs= (navigator.storage && typeof navigator.storage.getDirectory==='function')?1:0 }catch(_){ dc.opfs=0 }
            try{ dc.wnn = ('ml' in navigator)?1:0 }catch(_){ dc.wnn=0 }
            try{ dc.vce = (typeof VideoEncoder!=='undefined')?1:0 }catch(_){ dc.vce=0 }
            /* mse / mms — Media Source Extensions, и ОТДЕЛЬНО управляемый
               вариант. Два поля, а не одно, потому что это два разных мира:
               iPhone-Safari не имеет обычного MediaSource вообще, но с 17.1
               имеет ManagedMediaSource, и весь сегментный лейн плеера
               (audio-track-sidecar.js: смена аудиодорожки без пересборки файла)
               живёт ровно на этом различии. Без замера доля айфонов, которым
               достался быстрый путь, остаётся догадкой по таблицам
               совместимости — а Яндекс.Браузера в таблицах нет. */
            try{ dc.mse = (typeof MediaSource!=='undefined')?1:0 }catch(_){ dc.mse=0 }
            try{ dc.mms = (typeof ManagedMediaSource!=='undefined')?1:0 }catch(_){ dc.mms=0 }
            dc.tr=-1; dc.ld=-1; dc.vch2=-1; dc.vcs2=-1; dc.ade=-1; dc.aen=-1;
            /* ⚠️⚠️ БЕЗ ЭТИХ ДВУХ ПОЛЕЙ ПРИБОР НЕ ОТВЕЧАЛ НА СВОЙ СОБСТВЕННЫЙ ВОПРОС.
               device_cap заведён, чтобы сравнить МОБИЛЬНЫХ с десктопом (см. про
               «Encoder creation error.» выше) — и не записывал, мобильный ли это:
               141 773 события с 29.08, поле `mob` пустое во ВСЕХ. Разрез, ради
               которого прибор строили, был невозможен, и это не было видно —
               данные-то шли. Приходилось подменять его признаком `touch`, который
               считает сенсорный ноутбук телефоном. Остальная телеметрия эти поля
               кладёт с самого начала (см. __ae выше) — device_cap просто собирает
               свой объект с нуля и о них не знал. */
            dc.mob=_mob; dc._b=_br;

            var _dcSent=0,_dcSend=function(){if(_dcSent)return;_dcSent=1;try{window.__ae('device_cap',dc)}catch(_){}};
            // Потолок по времени: событие обязано уйти, даже если запрос
            // зависнет — иначе починка телеметрии стоила бы самой телеметрии.
            // Взведён БЕЗУСЛОВНО (до 24.08 — только в ветке с GPU): теперь
            // ждём несколько независимых проб, и любая из них может не
            // ответить. Одного сторожа хватает на все — _dcSend идемпотентен.
            setTimeout(_dcSend,3000);
            var _dcPend=1, _dcDone=function(){ if(--_dcPend<=0) _dcSend() };

            /* ⚠️ Сколько НАШИХ данных лежит у человека в браузере — до 20.09.2026
               мы этого не знали вовсе, и вопрос «не засоряем ли мы память»
               оставался ощущением, а не числом. Заводится заодно со вторым,
               более неприятным вопросом: у постоянного пользователя сайт может
               деградировать по мере накопления (обращение 19.09.2026 —
               страница в Яндекс-браузере открывалась 0.3 с, через две недели
               183 с, при 1.3 с в соседнем браузере на ТОМ ЖЕ телефоне в тот же
               день), и без этих полей причина не отличима от «сеть медленная».
               ⚠️ Это ВЕСЬ origin — кэш движка, OPFS, черновики всех тулов, — а
               не один инструмент; на вопрос «кто именно занял» отвечают
               счётчики самого тула, а не это поле. Считаем в МБ: байты здесь
               ничего не добавляют, а ряд делают длиннее.
               ⚠️ `sq` на большинстве сборок Chromium — НЕ квота: estimate()
               отвечает usage + 10 GiB, каков бы ни был настоящий грант (замер
               25.09.2026: sq − su = 10240 ровно у 81 % сессий Chrome, 94 % Edge;
               чат поддержки 647 — грант около нуля при sq − su = 10240). `sqs:1`
               помечает такой ответ; настоящий грант меряет только
               window.__storageEstimate, и здесь его не зовём — зонд с файлом в
               OPFS на каждой странице каждого посетителя ради телеметрии не
               оправдан. Класс «диск полон» считают `opfs_room_refused`. */
            if(navigator.storage && typeof navigator.storage.estimate==='function'){
                dc.su=-1; dc.sq=-1; _dcPend++;
                try{ navigator.storage.estimate().then(function(e){
                        if(e){ dc.su=Math.round((e.usage||0)/1048576); dc.sq=Math.round((e.quota||0)/1048576);
                               if(((e.quota||0)-(e.usage||0))===10737418240) dc.sqs=1; }
                        _dcDone();
                        if(dc.su>=1024) setTimeout(function(){ _storageBreakdown(dc.su); },15000);
                    },function(){_dcDone()}) }
                catch(_){ _dcDone() }
            }

            /* Точная сборка браузера. User-Agent заморожен («153.0.0.0»), а
               вопрос разбора 23.09.2026 был ровно про сборку: Edge 153.0.4234.32
               (10.09) замораживал ввод в окне, 153.0.4234.46 (17.09) — уже нет,
               и по UA эти двое неотличимы. Client Hints отдают полный номер по
               JS-запросу без Accept-CH; у не-Chromium поле пустое по
               построению. Первая марка, что не «Chromium» и не «Not-A-Brand»,
               — это сам браузер (Microsoft Edge / Google Chrome / YaBrowser /
               Opera …); если такой нет — версия Chromium.
               И система под ним — по той же причине: строка заморожена и на ОС.
               У Chromium ≥ 110 любой Windows пишет «Windows NT 10.0», поэтому
               Windows 7/8.1 с Яндексом 24.10 (последняя сборка для них) весь
               сентябрь 2026 выглядела в данных как «Windows 10» — и ровно эта
               когорта роняла вкладку на libmp3lame (комментарий #1740, см.
               FFmpegMp3Lane в ffmpeg-processor.js). pv — platformVersion
               (Windows 7/8/8.1 → «0.x», 10 → «1…10», 11 → «13+»), bit —
               разрядность процесса браузера, arch — x86/arm. */
            dc.bf='';
            if(navigator.userAgentData && typeof navigator.userAgentData.getHighEntropyValues==='function'){
                _dcPend++;
                try{ navigator.userAgentData.getHighEntropyValues(['fullVersionList','platformVersion','bitness','architecture']).then(function(h){
                        try{
                            var l=(h&&h.fullVersionList)||[], pick='', chromium='';
                            for(var i=0;i<l.length;i++){
                                var b=String(l[i].brand||''), ver=String(l[i].version||'');
                                if(/Not.A.Brand/i.test(b)) continue;
                                if(/^Chromium$/i.test(b)){ chromium=ver; continue; }
                                if(!pick) pick=ver;
                            }
                            dc.bf=(pick||chromium).substring(0,24);
                            if(h&&h.platformVersion) dc.pv=String(h.platformVersion).substring(0,16);
                            if(h&&h.bitness) dc.bit=String(h.bitness).substring(0,4);
                            if(h&&h.architecture) dc.arch=String(h.architecture).substring(0,8);
                        }catch(_){}
                        _dcDone();
                    },function(){_dcDone()}) }
                catch(_){ _dcDone() }
            }

            // Готовность встроенного переводчика. availability() только
            // СПРАШИВАЕТ — модель не качает, платить за замер нечем.
            var _availCode=function(v){ return v==='available'?1 : v==='downloadable'?2 : v==='downloading'?3 : 0 };
            if(typeof Translator!=='undefined' && Translator && typeof Translator.availability==='function'){
                dc.tr=0; _dcPend++;
                try{ Translator.availability({sourceLanguage:'en',targetLanguage:'ru'})
                        .then(function(v){dc.tr=_availCode(v);_dcDone()},function(){_dcDone()}) }
                catch(_){ _dcDone() }
            }
            if(typeof LanguageDetector!=='undefined' && LanguageDetector && typeof LanguageDetector.availability==='function'){
                dc.ld=0; _dcPend++;
                try{ LanguageDetector.availability()
                        .then(function(v){dc.ld=_availCode(v);_dcDone()},function(){_dcDone()}) }
                catch(_){ _dcDone() }
            }
            /* WebXR AR — откроет ли браузер сессию 'immersive-ar' (ARCore на
               Android). Заведено 28.10.2026 под вопрос «AR-рулетка в измерительных
               тулах»: у /online-ruler из Android-сессий 54 % в Chrome и 43 % в
               Яндекс.Браузере, а есть ли WebXR у второго, не написано ни в одной
               таблице совместимости. Пара как gpu/gpuad: `xr` — есть ли сам API,
               `xrar` — ответ isSessionSupported: 1 да, 0 нет, -1 не ответил,
               -2 отказ (политика разрешений). Вызов только спрашивает: сессию не
               открывает и ARCore не ставит — то же на каждой загрузке делает
               model-viewer.
               ⚠️ Только на телефоне: на десктопном Chrome вопрос будит
               XR-рантайм системы (OpenXR, у кого-то SteamVR), а AR на десктопе
               нам ни к чему. */
            try{ dc.xr = (navigator.xr && typeof navigator.xr.isSessionSupported==='function')?1:0 }catch(_){ dc.xr=0 }
            if(dc.xr && _mob){
                dc.xrar=-1; _dcPend++;
                try{ navigator.xr.isSessionSupported('immersive-ar')
                        .then(function(v){dc.xrar=v?1:0;_dcDone()},function(){dc.xrar=-2;_dcDone()}) }
                catch(_){ dc.xrar=-2; _dcDone() }
            }
            // H.264 1080p двумя подсказками. Размер взят НЕ с потолка: именно
            // 1920x1080 и 1080x1920 — два самых частых размера среди отказов
            // «Encoder creation error.» (14 и 9 случаев за 4 дня), то есть
            // самые обычные кадры, а не экзотика.
            if(dc.vce && VideoEncoder.isConfigSupported){
                // ⚠️ Уровень обязан СООТВЕТСТВОВАТЬ размеру кадра. Здесь стояло
                // `avc1.42001f` — Baseline **Level 3.1**, а её потолок 3600
                // макроблоков = 1280×720; спрашивать её на 1920×1080 (8100 МБ)
                // значит спрашивать конфигурацию, запрещённую самим стандартом.
                // Chromium это проверяет и честно отвечает `supported:false` —
                // на машине, которая H.264 1080p кодирует и аппаратно, и
                // программно. Проверено настоящим Chrome (не bundled Chromium,
                // у того нет проприетарных кодеков) через VideoEncoder
                // .isConfigSupported: 42001f@1080p → hw=no/sw=no, 42e028@1080p →
                // hw=YES/sw=YES на ТОЙ ЖЕ машине, оба размера.
                // Цена ошибки была не косметическая: поле заведено 24.08, чтобы
                // решить судьбу 30 МБ FFmpeg WASM на 117 блейдах, и за 5 дней
                // (236k сессий) отрапортовало «H.264 умеет 1.1% десктопов» —
                // вывод, обратный правде. Ровно этот дефект уже чинили в
                // webcodecs-pipeline.js (там жёстко стоял Level 5.1 и кодировщик
                // отвергал ВСЕ профили) — см. h264LevelHex и комментарий над
                // H264_ENCODER_PROFILES; в измерительный прибор он вернулся.
                // Профиль тоже приведён к тому, что реально шлёт конвейер:
                // 0x42e0 (Constrained Baseline) — последняя, самая
                // принимаемая ступень его каскада, т.е. вопрос «умеет ли эта
                // машина H.264 1080p ХОТЬ КАК-НИБУДЬ».
                // 0x28 = Level 4.0 (8192 МБ) — минимальный уровень для 1080p@30
                // по той же таблице, что h264LevelHex.
                var _encCfg=function(hint){ return {codec:'avc1.42e028',width:1920,height:1080,bitrate:4e6,framerate:30,hardwareAcceleration:hint} };
                _dcPend+=2;
                try{ VideoEncoder.isConfigSupported(_encCfg('prefer-hardware'))
                        .then(function(r){dc.vch2=(r&&r.supported)?1:0;_dcDone()},function(){dc.vch2=0;_dcDone()}) }
                catch(_){ dc.vch2=0; _dcDone() }
                try{ VideoEncoder.isConfigSupported(_encCfg('prefer-software'))
                        .then(function(r){dc.vcs2=(r&&r.supported)?1:0;_dcDone()},function(){dc.vcs2=0;_dcDone()}) }
                catch(_){ dc.vcs2=0; _dcDone() }
            }

            // Звуковой кодек. Спрашиваем РАБОЧУЮ конфигурацию, а не наличие
            // имени в window: у AudioEncoder имя может быть, а нужного кодека
            // в сборке нет — ровно та же ловушка, что «GPU есть» по адаптеру.
            // Взяты два кодека, которыми мы реально отдаём результат: AAC
            // (m4a, 891 экспорт /audio-enhancer за 30 дней) и Opus.
            if(typeof AudioDecoder!=='undefined' && AudioDecoder.isConfigSupported){
                dc.ade=0; _dcPend++;
                try{ AudioDecoder.isConfigSupported({codec:'mp4a.40.2',sampleRate:48000,numberOfChannels:2})
                        .then(function(r){dc.ade=(r&&r.supported)?1:0;_dcDone()},function(){dc.ade=0;_dcDone()}) }
                catch(_){ dc.ade=0; _dcDone() }
            }
            if(typeof AudioEncoder!=='undefined' && AudioEncoder.isConfigSupported){
                dc.aen=0; _dcPend++;
                try{ AudioEncoder.isConfigSupported({codec:'mp4a.40.2',sampleRate:48000,numberOfChannels:2,bitrate:192000})
                        .then(function(r){dc.aen=(r&&r.supported)?1:0;_dcDone()},function(){dc.aen=0;_dcDone()}) }
                catch(_){ dc.aen=0; _dcDone() }
            }

            if(dc.gpu){
                _dcPend++;
                try{
                    navigator.gpu.requestAdapter().then(function(a){
                        dc.gpuad=a?1:0;
                        if(!a){dc.gpudv=0;_dcDone();return}
                        // Устройство — единственный признак, по которому ORT
                        // реально пойдёт на видеокарту, а не откатится на wasm.
                        a.requestDevice().then(function(d){dc.gpudv=d?1:0;_dcDone()},
                                               function(){dc.gpudv=0;_dcDone()});
                    },function(){dc.gpuad=0;dc.gpudv=0;_dcDone()});
                }catch(_){dc.gpuad=0;dc.gpudv=0;_dcDone()}
            }else{
                dc.gpuad=0;dc.gpudv=0;
            }
            _dcDone();
        }
        });

        // File size limits removed — each tool defines its own limits in translations.
        // Browser handles OOM naturally; classifyError shows meaningful messages.

        // ── Rage Clicks — 3+ clicks within 800ms on same target THAT DID NOT RESPOND ──
        //
        // ⚠️⚠️ The "did not respond" half was missing until 2026-08-13, and without
        // it this detector measured "which tools have steppers, keypads and games"
        // rather than frustration. Measured over 30 days, the site-wide top of the
        // rage chart was: /iq-test backspace 6 666 · /join −/+ stepper 6 507 ·
        // /screen-burnin-test bar 2 489 · /checkers board cell 2 454 · /speed fine
        // step 2 375 · /online-piano key 3 482 · /video-blur step 1 324 ·
        // /cities-game map zoom 1 274 · /tank-duel ◀/▶ 2 306. Every one of them is
        // a control you are SUPPOSED to press repeatedly. Erasing a 7-digit answer
        // is 7 taps of ⌫ and scored as two "rage" events.
        //
        // The decisive measurement: on /iq-test, sessions that "rage-clicked" the
        // backspace finished the test in 94.7% of cases (2 720 of 2 871), against
        // 20.1% for sessions with no rage clicks at all. The signal was inverted —
        // it marked the most engaged users, not frustrated ones.
        //
        // How the field solves it (checked 2026-08-13):
        //   · Sentry gates the whole thing on responsiveness — a rage click is
        //     consecutive clicks on an UNRESPONSIVE element (no DOM update and no
        //     page scroll in the window). You cannot rage at something that answers.
        //   · Microsoft Clarity defines a dead click the same way: no URL change,
        //     no DOM mutation, no network request, no scroll.
        //   · FullStory ships an opt-out class (fs-ignore-rage-clicks), Heap ships
        //     built-in exclusions (their pagination "<" and ">"), PostHog excludes
        //     by text for pagination/spinners. Datadog has an open request for the
        //     same tag (browser-sdk#3621) and has not shipped it.
        // So: gate first (Sentry/Clarity), keep the manual opt-out as the override
        // for whatever the gate cannot see (FullStory/Heap/PostHog).
        //
        // ⚠️ Do NOT "simplify" this back to an immediate emit at n===3. Note that
        // the gate KEEPS the findings that were real: /cognitive-test's Level-1
        // cluster was clicks on an empty grid before the first highlight (nothing
        // to mutate → still fires), and /eight-bit-converter's cluster was a UI
        // frozen for 4.7 s (no mutation while frozen → still fires).
        var _rc={el:null,n:0,t:0,mut:0,scr:0,href:''};
        var _rcSkip={CANVAS:1,INPUT:1,VIDEO:1,AUDIO:1,TEXTAREA:1,SELECT:1};
        // Manual override, in the spirit of fs-ignore-rage-clicks. Needed only for
        // controls whose answer is invisible to a DOM observer (pure audio/canvas
        // feedback). Everything that repaints, toggles a class or rewrites text is
        // already handled by the gate below — verified on the piano (.pressed
        // class) and the steppers (they rewrite their value), so those are
        // deliberately NOT listed here: a genuinely frozen keypad must still be
        // reported.
        var _rcIgnore='[data-rapid],.fs-ignore-rage-clicks,[class*=seek],[class*=progress-bar],[class*=preview-bar],[class*=timeline],[contenteditable]';

        // Responsiveness probe. Armed only while a burst is in flight (≤1.5 s), so
        // there is no permanent document-wide observer on every page.
        var _rcMo=null,_rcMoOff=0;
        // ⚠️⚠️ The site chrome answers EVERY click, everywhere. Measured
        // 2026-08-13 on a button whose handler is empty: within 0–1 ms of each
        // click, the global "close the open menus" handlers toggle `class` on
        // #toolActionsMenu (.tool-actions) and #searchResults (.search-results).
        // Left unfiltered, that made the gate declare every dead control
        // "responsive" — the fixed detector then reported nothing but frozen
        // main threads, which is a far worse instrument than the noisy one it
        // replaced. Scoping the observer to the tool root instead was rejected:
        // toasts and modals are appended to <body>, and a button whose only
        // answer is a toast would then read as dead.
        function _rcNoise(n){
            if(!n||n.nodeType!==1)return true;
            var tg=n.tagName;
            if(tg==='SCRIPT'||tg==='STYLE'||tg==='LINK'||tg==='META')return true;
            return !!(n.closest&&n.closest('.tool-ad-slot,ins.adsbygoogle,iframe,head,.tool-actions,.search-results,.tool-sidebar,#ccBanner'));
        }
        /* Ответ САМОГО нажатого — его узел, его потомки или предок (кроме корня
           шумовой зоны) — засчитывается и внутри шумовой зоны. Без этого раскрытие
           рубрики в сайдбаре (класс `open` на .sb-grp, `aria-expanded` на кнопке)
           не было ответом никогда: тройной клик по заголовку рубрики — третья
           цель «ярости» на обоих шардах (RU 230 сессий, NL 38 за 15.10–29.10),
           и всё это — ответивший аккордеон. Мёртвая кнопка в сайдбаре
           по-прежнему ловится: у неё мутаций нет вовсе. */
        function _rcOwn(n){
            var el=_rc.el;
            if(!el||!n||n.nodeType!==1)return false;
            try{
                if(n===el||el.contains(n))return true;
                return n.contains(el)&&!n.matches('html,body,.tool-sidebar,.tool-actions,.search-results');
            }catch(_){return false;}
        }
        function _rcDisarm(){if(_rcMo){try{_rcMo.disconnect();}catch(_){}_rcMo=null;}}
        function _rcArm(){
            clearTimeout(_rcMoOff);
            // Must outlive the burst (2 gaps of up to 800 ms) PLUS the 400 ms
            // gate delay, or the probe stops watching before the verdict is read
            // and every burst looks unanswered — the exact inversion we are fixing.
            _rcMoOff=setTimeout(_rcDisarm,2500);
            if(_rcMo)return;
            try{
                _rcMo=new MutationObserver(function(recs){
                    // Attribution window. A page is never perfectly still — this
                    // one flips `hidden` on the rating-comments widget while idle
                    // (measured 2026-08-13: 1 record per 4 s at rest, but ~6 in
                    // the first 1.5 s while the page settles). Counting ANY
                    // mutation as "the control answered" would let unrelated
                    // churn silence a genuinely dead button. A press is only
                    // credited with what happens right after it.
                    if(Date.now()-_rc.t>350)return;
                    for(var i=0;i<recs.length;i++){
                        var r=recs[i],j;
                        if(r.type==='characterData'){
                            if(!_rcNoise(r.target&&r.target.parentNode)||_rcOwn(r.target&&r.target.parentNode)){_rc.mut=1;_rcDisarm();return;}
                            continue;
                        }
                        if(r.type==='attributes'){
                            if(!_rcNoise(r.target)||_rcOwn(r.target)){_rc.mut=1;_rcDisarm();return;}
                            continue;
                        }
                        for(j=0;j<r.addedNodes.length;j++){
                            if(r.addedNodes[j].nodeType===3||!_rcNoise(r.addedNodes[j])||_rcOwn(r.target)){_rc.mut=1;_rcDisarm();return;}
                        }
                        for(j=0;j<r.removedNodes.length;j++){
                            if(r.removedNodes[j].nodeType===3||!_rcNoise(r.removedNodes[j])||_rcOwn(r.target)){_rc.mut=1;_rcDisarm();return;}
                        }
                    }
                });
                // attributeFilter mirrors silent-click-detector: the tokens a
                // control actually flips to acknowledge a press. A bare
                // `attributes:true` would count ad-script churn as an answer.
                _rcMo.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,
                    attributeFilter:['class','style','hidden','aria-hidden','aria-pressed','aria-selected','aria-checked','aria-expanded','value','disabled','checked','src','transform','d']});
            }catch(_){}
        }
        // Sentry counts a page scroll as an answer too — a list that scrolls under
        // the finger is responding even when nothing in it mutates.
        window.addEventListener('scroll',function(){if(_rc.n)_rc.scr=1;},{passive:true});

        document.addEventListener('click',function(e){
            if(_rcSkip[e.target.tagName])return;
            if(e.target.closest(_rcIgnore))return;
            if(e.target.isContentEditable)return;
            var now=Date.now();
            if(e.target===_rc.el&&now-_rc.t<800){
                _rc.n++;_rc.t=now;
                // Keep the probe alive across the burst. Once an answer is seen
                // the observer is already disconnected and must stay that way —
                // re-arming would cost a document-wide observer for nothing.
                if(!_rc.mut)_rcArm();
                if(_rc.n===3){
                    // Find the meaningful target — walk up from SVG/SPAN to nearest button/link/interactive
                    var t=e.target;
                    var actionEl=t.closest('button,a,[role=button],[onclick],.btn')||t;
                    var tag=actionEl.tagName;
                    var id=actionEl.id||'';
                    // For SVG elements (rect/g/svg/path) actionEl.className is an
                    // SVGAnimatedString whose .toString() returns the literal
                    // "[object SVGAnimatedString]" — useless for diagnostics.
                    // Use .baseVal which holds the actual class string. The
                    // 30+ "[object SVGAnimatedString]" rage_click events on
                    // /checkers' SVG board were exactly this bug.
                    // Same handling lives in silent-click-detector.js.
                    var clsRaw=actionEl.className;
                    var cls=(typeof clsRaw==='string'?clsRaw:(clsRaw&&clsRaw.baseVal)||'').substring(0,60);
                    var txt=(actionEl.textContent||'').substring(0,40).trim();
                    // Capture aria-label / title — for icon-only buttons txt is empty,
                    // these are the only way to identify what was clicked. Also helps
                    // disambiguate when txt is the same across many buttons (e.g.
                    // "Stop" appearing on 5 different elements).
                    var aria=(actionEl.getAttribute('aria-label')||actionEl.getAttribute('title')||'').substring(0,40).trim();
                    var dis=actionEl.disabled||actionEl.getAttribute('aria-disabled')==='true'?1:0;
                    // Tool state: is file loaded? processing? result ready?
                    // [class*=result] and [id*=result] used to match the sidebar's
                    // `.search-results` container (always present, never hidden)
                    // on every tool page, making `st='result'` a permanent false
                    // positive (confirmed iq-test rage_click cluster 2026-06-22).
                    // Confine the match to elements INSIDE the main content area
                    // by walking from the click target up to the nearest tool
                    // root (.tool-page-content, .tool-container, or main) and
                    // only consider descendants of that scope.
                    // ⚠️ document.body can be null here: the page was rewritten
                    // under our listeners by the browser or an extension (Sentry
                    // QH, Yandex 26.8: the last clicks before the crash landed on
                    // <html> itself — the document had no body left). Describing
                    // the target must never throw; the document root is the scope.
                    var scopeRoot=actionEl.closest('main, .tool-page-content, .tool-container, [data-tool-root]')||document.body||document.documentElement;
                    var st='idle';
                    if(scopeRoot.querySelector('.progress-section.active,[class*=progress].active'))st='processing';
                    else if(scopeRoot.querySelector('.result-section:not(.hidden),[class*=result]:not(.hidden),[id*=result]:not(.hidden)'))st='result';
                    else if(scopeRoot.querySelector('[class*=upload].hidden,.upload-zone.hidden,.workspace.active'))st='loaded';
                    // Mobile detection
                    var mob='ontouchstart' in window?1:0;
                    // Embed short browser tag — every prior investigation needed a
                    // SQL JOIN with session_start to attribute rage-clicks to a
                    // browser. With _b on the event itself, single-query analysis.
                    var ua=navigator.userAgent;
                    // Вторая копия лестницы жила здесь и уже разъехалась с
                    // первой (у неё не было 'chr-ios'); теперь обе зовут один
                    // классификатор — разъехаться им больше нечем.
                    var br=(window.__brOf?window.__brOf(ua):'other');
                    // ── The gate. Everything above only DESCRIBES the target; the
                    // decision waits until we know whether the burst was answered.
                    // The delay lets the third click's own effect land — without it
                    // a control that repaints on every press still looks silent on
                    // the press that trips the counter.
                    var burst=_rc,startHref=_rc.href;
                    setTimeout(function(){
                        if(burst.mut||burst.scr||location.href!==startHref)return; // it answered — not rage
                        // `g:1` marks events that passed the responsiveness gate.
                        // Anything logged before 2026-08-13 has no `g` and is NOT
                        // comparable with these — the old detector counted every
                        // fast triple-click, answered or not.
                        window.__ae('rage_click',{tag:tag,id:id,cls:cls,txt:txt,aria:aria,dis:dis,st:st,mob:mob,n:burst.n,_b:br,g:1});
                    },400);
                }
            } else {
                _rc={el:e.target,n:1,t:now,mut:0,scr:0,href:location.href};
                _rcArm();
            }
        },{passive:true,capture:true});

        // ── Tool Abandon — user uploaded file but left without downloading result ──
        if(slug){
            var _hasFile=false,_hasResult=false;
            document.addEventListener('change',function(e){
                var t=e.target;if(t&&t.type==='file'&&t.files&&t.files[0])_hasFile=true;
            },true);
            document.addEventListener('drop',function(e){
                var f=e.dataTransfer&&e.dataTransfer.files;if(f&&f[0])_hasFile=true;
            },true);
            // Shared-uploader programmatic/share-target/paste injections enter via
            // tool-uploader.js emit()→finishEmit() WITHOUT a native change/drop
            // event (input.files is never set), so the two listeners above miss
            // them and had_file under-reported for those flows. finishEmit always
            // dispatches a bubbling `tool-uploader:file` for every accepted file —
            // catch it here too. Idempotent boolean; emits no telemetry of its own.
            document.addEventListener('tool-uploader:file',function(){_hasFile=true;},true);
            window.addEventListener('file-downloaded',function(){_hasResult=true});
            /* ── Как долго полоса НЕ менялась к моменту ухода ──
               Замер 2026-08-24: 19 368 сессий за 14 дней уходят со стадии
               `processing`, просидев в среднем 19 минут. Из одного этого числа
               нельзя понять, ждал человек работающий движок или смотрел в
               мёртвый экран, — а лечится это разным (часы против сторожа
               затыка). Поле `prog_still_s` разделяет их на живых людях.

               Опрос, а не MutationObserver: метрика ЕСТЬ «экран не изменился»,
               и опрос меряет ровно её, стоит O(несколько узлов) раз в секунду
               и не зависит от того, как тул перерисовывает полосу. Идёт только
               между выбором файла и результатом. */
            var _progLastMs=0,_progSig='',_progTimer=null,_progEver=false;
            var _progNodes=null,_progNodesAt=0;
            var _PROG_SEL='[role=progressbar],progress,[data-tprog-elapsed],[class*=progress],[id*=rogress]';
            function _progNodeList(){
                /* Селектор с подстрокой по классу бежит по всему DOM. На странице
                   в 600 КБ это было основной ценой замера (замерено). Полосы
                   появляются редко — список кэшируем и обновляем раз в 10 с. */
                var now=Date.now();
                if(_progNodes&&(now-_progNodesAt)<10000)return _progNodes;
                try{_progNodes=document.querySelectorAll(_PROG_SEL);}catch(_){_progNodes=[];}
                _progNodesAt=now;
                return _progNodes;
            }
            function _progSnapshot(){
                var out='',n=0;
                try{
                    var els=_progNodeList();
                    /* НИКАКИХ суждений о видимости. Первая версия звала
                       getClientRects() — он форсирует раскладку И врёт на position:fixed
                       (offsetParent там null). Вторая судила по атрибутам — и скрытые
                       КЛАССОМ узлы съедали квоту и вытесняли настоящую полосу
                       (в DOM она обычно последняя) — поймано тестом.
                       Неподвижный узел даёт постоянный вклад и ложного «изменилось»
                       не даёт, а снимок с кэшем стоит 0.005 мс — дешевле смотреть
                       шире, чем угадывать, кто из них на экране. */
                    for(var i=0;i<els.length&&n<14&&i<80;i++){
                        var e=els[i];
                        out+=(e.getAttribute('aria-valuenow')||'')+'|'
                            +(e.getAttribute('style')||'').slice(0,60)+'|'
                            +(e.tagName==='PROGRESS'?e.getAttribute('value')||'':'')+'|'
                            +(e.children.length?'':(e.textContent||'').slice(0,40))+'#';
                        n++;
                    }
                }catch(_){}
                return n?out:'';
            }
            function _progPoll(){
                if(_hasResult)return _progStop();
                var sig=_progSnapshot();
                if(!sig)return;                       /* полосы на экране нет */
                if(sig!==_progSig){_progSig=sig;_progLastMs=Date.now();_progEver=true;}
            }
            function _progStart(){
                if(_progTimer)return;
                _progLastMs=Date.now();
                _progTimer=setInterval(_progPoll,1000);
            }
            function _progStop(){
                if(_progTimer){clearInterval(_progTimer);_progTimer=null;}
            }
            /* включаем на первом же файле — до него полосы всё равно нет.
               `change` — только у поля ФАЙЛА: поле возраста в /dementia-test
               взводило прибор, и уход с теста без файла приходил «полоса стояла
               109 с» (жалоба 23.10; NL за неделю — 898 таких отчётов из 2 477
               с этим полем — показания о файле, которого не было). */
            ['change','drop','tool-uploader:file'].forEach(function(ev){
                document.addEventListener(ev,function(e){
                    if(ev==='change'&&!(e&&e.target&&e.target.type==='file'))return;
                    setTimeout(_progStart,0);
                },true);
            });
            function _progStillS(){
                if(!_progEver||!_progLastMs)return null;
                return Math.round((Date.now()-_progLastMs)/1000);
            }
            /* Единственная наружу — чтобы метрику можно было ПРОВЕРИТЬ тестом,
               а не поверить в неё. Только чтение. */
            window.__aeProgStill=function(){return{still_s:_progStillS(),moved:_progEver?1:0,armed:!!_progTimer};};
            // Also count tool_complete calls from blade files
            var _origComplete=window.__aeToolComplete;
            window.__aeToolComplete=function(p){_hasResult=true;_origComplete(p)};
            // ── P4: broader "session abandon" (no file required) ──
            // Catches users who never uploaded but spent time + scrolled + had
            // 0 success — exactly the bug-report c94e8764 shape (445 s on page,
            // scroll 71%, last_action:null, no tool_complete). The existing
            // tool_abandon above only fires for upload-then-leave; this one
            // fires for the silent-failure mic flows too.
            var _maxScrollPct=0;
            /* ── Was the tool's primary control ever ON SCREEN? ──
               Measured on /voice-translator 2026-08-19: its microphone sits
               1.4–2.1 viewport-heights down the page (the block order is fixed
               by convention: intro → how-to → H2 → tool). The obvious reading
               of "half the sessions never press it" is "they never found it",
               and this counter decides that instead of arguing it.
               ⚠️ It also fixes a blind spot in the gate below: the abandon
               report requires 30% scroll while the control enters the viewport
               at ~23% — so every session we could see had ALREADY seen the
               control, and the ones that had not were invisible by construction.
               A tool opts in with data-tool-control on its start button. */
            var _ctlSeen=null,_ctlObs=null;
            function _watchControl(){
                if(_ctlObs||typeof IntersectionObserver!=='function')return;
                // A tool may mark more than one control (this page has a
                // conversation mic AND a start button, one visible at a time).
                // Observing a display:none element would report "never seen"
                // forever — pick the one actually on the page.
                var all=document.querySelectorAll('[data-tool-control]'),el=null;
                for(var i=0;i<all.length;i++){ if(all[i].offsetParent!==null){el=all[i];break;} }
                if(!el)return;
                if(_ctlSeen===null)_ctlSeen=0;
                _ctlObs=new IntersectionObserver(function(es){
                    for(var i=0;i<es.length;i++){ if(es[i].isIntersecting){ _ctlSeen=1; if(_ctlObs){_ctlObs.disconnect();_ctlObs=null;} return; } }
                },{threshold:0.25});
                _ctlObs.observe(el);
            }
            if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',_watchControl);
            else _watchControl();
            // Controls can appear late (mode switches, capability gates resolving).
            setTimeout(_watchControl,2500);
            window.addEventListener('scroll',function(){
                var sh=document.documentElement.scrollHeight;
                var ih=window.innerHeight;
                var st=window.scrollY||document.documentElement.scrollTop||0;
                if(sh<=ih)return;
                var pct=Math.round((st+ih)/sh*100);
                if(pct>_maxScrollPct)_maxScrollPct=pct;
            },{passive:true});
            var _abandonReported=false;
            var _toolAbandonReported=false; // per-page dedup for tool_abandon emission
            /* ── How much of this visit happened with the tab hidden ──
               tool_abandon fires on the FIRST visibilitychange→hidden, which
               makes "abandon" and "switched tabs for a moment" the same event.
               Measured on /auto-captions (2026-07-24): 57% of desktop
               "abandons" were followed by a tool_complete in the SAME session —
               the user came back and finished. On mobile only 22% did.
               Without these fields the funnel cannot tell "left for good" from
               "backgrounded a long job", and the mobile-vs-desktop success gap
               (51% vs 87%) has no diagnosable cause. Cheap: two counters and a
               listener that already exists. */
            var _hiddenMs=0,_hiddenCount=0,_hiddenAt=0;
            document.addEventListener('visibilitychange',function(){
                if(document.visibilityState==='hidden'){_hiddenCount++;_hiddenAt=Date.now();}
                else if(_hiddenAt){_hiddenMs+=Date.now()-_hiddenAt;_hiddenAt=0;}
            });
            /* Shared so any tool can stamp the same numbers onto its own
               success payload — comparing hidden-time between the runs that
               finished and the runs that didn't is the whole point. */
            window.__visibilityStats=function(){
                return {hidden_ms:Math.round((_hiddenMs+(_hiddenAt?Date.now()-_hiddenAt:0))/1000)*1000,
                        hidden_count:_hiddenCount};
            };
            // Funnel stage inference. Five labels covering the AMC funnel:
            //   error      — last tool error captured this session
            //   done       — result downloaded / tool_complete fired
            //   processing — funnel reached server/wasm processing stage, OR
            //                tool_stage reports a processing-class stage
            //   uploading  — file was picked but never processed
            //   idle       — nothing happened (silent / no-pick abandon)
            // Reads from existing module-level state — no new globals.
            /* Имена стадий, которые означают ГОТОВНОСТЬ, а не занятость.
               `wasm_ready` = «движок прогрелся», `decoded` = «декодирование
               ЗАКОНЧИЛОСЬ». Регулярка ниже ловит их по подстрокам `wasm` и
               `decode` — поэтому вето стоит ПЕРЕД ней. Именно `wasm_ready` дал
               6781 из 8807 ложных «brosil vo vremya obrabotki» за 30 дней. */
            var _STAGE_READY=/^(.*_)?(ready|ok|done|loaded|decoded|warm|idle|complete)$/i;
            function _inferStage(){
                if(window.__LAST_TOOL_ERROR)return 'error';
                if(_hasResult)return 'done';
                /* ФАКТ вместо догадки: общий примитив держит скобку прогона.
                   Спрашиваем его первым — он знает то, чего имя стадии не
                   знает никогда. */
                if(window.__runMark&&window.__runMark.active())return 'processing';
                if(typeof _funnelSent!=='undefined' && _funnelSent && (_funnelSent.processing || _funnelSent.server_processing))return 'processing';
                /* Стена капа — СВОЙ исход. «Ему отказали» и «он бросил работу»
                   это разные вопросы к разным людям, а до сих пор 1182 отказа
                   за 30 дней лежали в корзине брошенной обработки. Условие
                   «и ни одного прогона за жизнь страницы» не даёт пометить
                   отказом того, кто до стены успел поработать. */
                if(window.__limitWallAt&&window.__runMark&&window.__runMark.started()===0)return 'refused';
                var ls=window.__lastStage||'';
                /* Последний рубеж — для тулов, которые не проходят ни через
                   __toolLimit, ни через FFmpegProcessor. Оставлен как был, но
                   без имён готовности. */
                if(ls && !_STAGE_READY.test(ls) && /process|encode|decode|render|infer|probe|wasm|init/i.test(ls))return 'processing';
                /* Было 'uploading'. У браузерного тула ничего никуда не
                   загружается, а три тула (photo-translate, document-translate,
                   pdf-to-excel) объявляют стадию `uploading` САМИ — и их
                   настоящие загрузки тонули в чужих. 'ready' = файл на месте,
                   человек не нажал ничего. */
                if(_hasFile)return 'ready';
                return 'idle';
            }
            function _maybeReportSessionAbandon(){
                if(_abandonReported)return;
                if(_hasResult)return;
                var t=Math.round((Date.now()-t0)/1000);
                if(t<120)return;          // engaged but didn't really try
                // Bounce filter — EXCEPT when the tool's control was never on
                // screen. "Stayed two minutes and never even saw the button" is
                // the one shallow-scroll case worth a row: it is the difference
                // between "did not want it" and "did not find it", and without
                // it that population cannot be counted at all.
                if(_maxScrollPct<30 && _ctlSeen!==0)return;
                _abandonReported=true;
                try{
                    /* last_stage + last_action together segment the 4 abandon classes
                       previously lumped together as `had_interaction:0`:
                         - bounce        — t<120 already filtered; user just opened the page
                         - confused      — had_file=1, last_stage=loaded/ready, last_action=file_picked → UI shown, user didn't act
                         - reload-then-leave — last_stage=null in current pageview (this IIFE saw nothing), but session has prior
                         - really-broken — last_stage=wasm_load_failed / probe_failed / etc., last_error_type set
                       Without last_stage, every `had_interaction:0` looks the same and triage is impossible. */
                    window.__ae('feature_use',{
                        slug:slug,
                        f:'abandon_no_complete',
                        time_on_page_s:t,
                        scroll_pct:_maxScrollPct,
                        ctl_seen:_ctlSeen,
                        had_file:_hasFile?1:0,
                        had_interaction:_interacted?1:0,
                        last_stage:window.__lastStage||null,
                        last_action:(window.__LAST_TOOL_ACTION&&window.__LAST_TOOL_ACTION.a)||null,
                        last_error_type:(window.__LAST_TOOL_ERROR&&(window.__LAST_TOOL_ERROR.error_type||window.__LAST_TOOL_ERROR.stage))||null,
                        stage:_inferStage(),
                        prog_still_s:_progStillS(),
                        prog_moved:_progEver?1:0,
                        _b:_br,mob:_mob
                    });
                }catch(_){}
            }
            // Loosened gate (fix 4): on tool pages, emit tool_abandon for silent
            // page→nopick abandons too, not just upload-then-leave. The funnel was
            // blind to the 50%+ of users who never picked a file. Time-on-page
            // floor (120s) survives to keep bounce noise out. Per-page dedup via
            // _toolAbandonReported (visibilitychange + pagehide can both fire).
            function _isToolPage(){
                if(slug)return true;
                try{return /\/tools?\//.test(location.pathname||'')}catch(_){return false}
            }
            function _maybeReportToolAbandon(){
                if(_toolAbandonReported)return;
                if(_hasResult)return;
                var d=Math.round((Date.now()-t0)/1000);
                // Old behavior: required _hasFile (upload-then-leave only).
                // New behavior on tool pages: drop that requirement, keep the
                // 120s engagement floor so bounce traffic stays out.
                if(_isToolPage()){
                    if(d<120 && !_hasFile)return;
                }else{
                    if(!_hasFile)return;
                }
                _toolAbandonReported=true;
                try{
                    window.__ae('tool_abandon',{
                        slug:slug,
                        d:d,
                        last_stage:window.__lastStage||null,
                        last_action:(window.__LAST_TOOL_ACTION&&window.__LAST_TOOL_ACTION.a)||null,
                        last_error_type:(window.__LAST_TOOL_ERROR&&(window.__LAST_TOOL_ERROR.error_type||window.__LAST_TOOL_ERROR.stage))||null,
                        scroll_pct:_maxScrollPct,
                        ctl_seen:_ctlSeen,
                        had_file:_hasFile?1:0,
                        had_interaction:(typeof _interacted!=='undefined'&&_interacted)?1:0,
                        stage:_inferStage(),
                        // hidden_count>0 with a later tool_complete = a
                        // backgrounded long job, NOT an abandon. run_elapsed_s
                        // says how far into the work the user left; 0 = no run
                        // was in flight. Tools publish it via __runElapsed.
                        hidden_ms:_hiddenMs,hidden_count:_hiddenCount,
                        // Свои часы тула, если он их публикует, иначе — время,
                        // проведённое в стадии «идёт работа». Второе слабее
                        // (считается от входа в стадию, а не от нажатия), но
                        // отличает «ушёл через 20 секунд» от «ушёл через
                        // четыре минуты», а до этой правки оба выглядели как
                        // ноль у 99.8 % событий.
                        /* Порядок источников — от точного к слабому:
                           часы тула → скобка общего примитива → время в
                           стадии. Средний источник появился вместе с
                           __runMark: он есть у 203 тулов, тогда как
                           window.__runElapsed объявлял РОВНО ОДИН. */
                        run_elapsed_s:(typeof window.__runElapsed==='function')
                            ? (window.__runElapsed()||0)
                            : ((window.__runMark&&window.__runMark.active())
                                ? window.__runMark.since()
                                : ((_inferStage()==='processing'&&window.__lastStageAt)
                                    ? Math.round((Date.now()-window.__lastStageAt)/1000) : 0)),
                        /* Сколько прогонов человек вообще запустил на этой
                           странице. 0 при stage=processing = отчёт врёт, и это
                           видно в самих данных, а не только в коде. */
                        runs:(window.__runMark&&window.__runMark.started())||0,
                        // Откуда взялось число — иначе две несравнимые шкалы
                        // (от нажатия и от входа в стадию) молча смешаются в
                        // одной колонке.
                        run_clock:(typeof window.__runElapsed==='function')?'tool'
                            :((window.__runMark&&window.__runMark.active())?'run':'stage'),
                        _b:_br,mob:_mob
                    });
                }catch(_){
                    try{window.__ae('tool_abandon',{slug:slug,d:d,stage:_inferStage()});}catch(__){}
                }
            }
            document.addEventListener('visibilitychange',function(){
                if(document.visibilityState==='hidden'){
                    _maybeReportToolAbandon();
                    _maybeReportSessionAbandon();
                }
            });
            // pagehide is the reliable signal on iOS Safari (visibilitychange
            // doesn't always fire when the user swipes back / closes the tab).
            window.addEventListener('pagehide',function(){
                _maybeReportToolAbandon();
                _maybeReportSessionAbandon();
            });
        }

        // ── Auto tool_complete for non-FFmpeg tools ──
        // Intercept URL.createObjectURL to detect blob results (canvas exports, audio renders, etc.)
        //
        // OPT-IN SCOPE (Phase S, 2026-06-02 follow-up to /pino/streams audit
        // process_lesson #4): the tracker historically fired for EVERY tool slug,
        // including games / UI-only tools that never produce file outputs. That
        // meant any blob URL the page touched (ios-audio-unmute's silent WAV,
        // a preview canvas screenshot, a worker source string) silently
        // registered as a tool_complete. tool_pipe-puzzle measured 48 % of
        // pipe-puzzle "completions" were the ios silent-WAV — phantom signal.
        //
        // New mechanism: tools opt OUT by declaring `<meta name="tool-output-
        // kind" content="none">` (game / UI / capture-only tools) or `"screen"`
        // (canvas-render that never downloads). Default is `file` for
        // backwards compatibility — every file-producing tool keeps working
        // with zero edits. Migrating a known false-positive tool is a
        // one-line meta-tag addition to its blade.
        //
        // Skip-list mechanism (kept): tools that produce intermediate blobs
        // (preview audio for A/B compare, original-vs-restored players, etc.)
        // call `window.__skipBlobAutoTrack(blob)` BEFORE URL.createObjectURL(blob)
        // so the next createObjectURL of that blob skips auto-tracking. Without
        // this, the first non-trivial blob URL ever created in the session
        // locks _hasResult=true and the real final output never fires tool_complete.
        //
        // Telemetry 2026-05-22 audit: 928 audio-enhancer sessions/7d had
        // tool_complete with src:"blob" size≈241KB (= 15s × 128kbps preview blob),
        // for inputs ranging 50-830 MB. Comment #485 from Floating Lions (ID,
        // 155 MB input, 235 KB tool_complete) was the trigger to find this —
        // the user got the preview rendered, never saw a real result, but the
        // auto-tracker reported "completion" with the preview size, inflating
        // completion-rate metrics by 30-40 % for audio-enhancer.
        //
        // Per-blob skip is preferred over per-tool opt-out because some tools
        // create both intermediate AND final blobs (audio-enhancer preview +
        // resultBlob, ai-music-cleaner A/B player + restored output).
        // Phase S opt-in gate: tools that NEVER produce file outputs (games,
        // UI tools, screen-result tools) declare `<meta name="tool-output-
        // kind" content="none">` (or "screen") and the entire tracker is a
        // no-op for them. Default "file" preserves existing behavior. The
        // __skipBlobAutoTrack escape hatch still works for file-producing
        // tools with intermediate preview blobs (audio-enhancer / gifsicle).
        var _outputKindMeta = document.querySelector('meta[name="tool-output-kind"]');
        var _outputKind = _outputKindMeta ? (_outputKindMeta.getAttribute('content') || 'file') : 'file';
        // Tracker installs ALWAYS so __skipBlobAutoTrack stays defined (some
        // shared modules — ios-audio-unmute, FFmpegProcessor — call it
        // unconditionally regardless of the page's tool kind). The kind
        // gate only suppresses the emission timer.
        if(slug){
            var _origCreateURL=URL.createObjectURL;
            var _blobCompleteTimer=null;
            // WeakSet of blobs to skip — registered via __skipBlobAutoTrack.
            var _skipBlobs = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
            window.__skipBlobAutoTrack = function(blob){
                if (_skipBlobs && blob) _skipBlobs.add(blob);
            };
            URL.createObjectURL=function(obj){
                var url=_origCreateURL.apply(this,arguments);
                // Phase S opt-in: short-circuit on tools that declared they
                // produce no file output. Skip-list mechanism still applies
                // to FILE-producing tools so their preview blobs don't fire.
                // 'server' — the result is DELIVERED BY THE SERVER, so the page must say
                // so with __aeToolComplete and the guess is switched off entirely. Added
                // 2026-08-19: on /voice-cover the guess had been wrong 801 times out of
                // 801 since 08-01 (every one was the person's own microphone take played
                // back, against 33 covers actually delivered). It hid three days of total
                // outage behind 30-50 daily 'completions' and put «выдано 2» on the refund
                // screen for a buyer who got nothing. A paid tool cannot INFER delivery.
                if (_outputKind === 'none' || _outputKind === 'screen' || _outputKind === 'server') return url;
                // Opt-out (at create time): tool already marked the blob as non-final.
                if (_skipBlobs && _skipBlobs.has(obj)) return url;
                // Only count blobs over 1KB, skip Safari's MediaSource init segments (1493 bytes video/mp4)
                var _blobType=obj&&obj.type||'';
                // File instances are user input (e.g. `URL.createObjectURL(file)` for a video preview),
                // not tool output. Without this guard, picking any non-trivial media file fires a bogus
                // tool_complete 2s later and inflates the success funnel.
                // Empty-type Blob filter — WASM-library workers (gifsicle, ffmpeg)
                // are constructed via `new Blob([workerSourceString])` with no
                // explicit MIME type, yielding `type === ''`. Without this guard
                // EVERY gifsicle.run() spawned a phantom tool_complete with the
                // worker source's byte count (size=339844) instead of the real
                // output. Telemetry 2026-05-20: 207 such phantoms across 12+
                // sessions, including bug-report #465 (Анна) where the false
                // event made it look like the tool produced 339 KB regardless
                // of input. Real outputs across this app always set an
                // explicit Blob type (`image/gif`, `audio/wav`, `application/pdf`,
                // etc.); any tool that legitimately produces empty-type output
                // should call __aeToolComplete({size, type}) directly.
                if(obj&&obj.size&&obj.size>1024&&!(obj instanceof File)&&_blobType!==''&&!(obj.size<2000&&_blobType.indexOf('video/')===0)&&_blobType.indexOf('wasm')===-1&&_blobType.indexOf('javascript')===-1&&_blobType.indexOf('text/')===-1){
                    // Debounce — many tools create multiple blobs in quick succession
                    clearTimeout(_blobCompleteTimer);
                    _blobCompleteTimer=setTimeout(function(){
                        // Re-check opt-out at fire time: a tool may have marked
                        // the blob AFTER createObjectURL returned (the typical
                        // pattern when FFmpegProcessor.process internally calls
                        // createObjectURL on its result, and the tool only
                        // sees the blob in the returned object). The 2 s
                        // debounce gives the tool time to register the blob
                        // in the skip-list before this emission window closes.
                        if(_skipBlobs && _skipBlobs.has(obj)) return;
                        if(!_hasResult){
                            _hasResult=true;
                            window.__ae('tool_complete',{slug:slug,src:'blob',size:obj.size,type:obj.type||''});
                        }
                    },2000);
                }
                return url;
            };
        }

        /* __exportFormat:begin */
        /* «Какой формат файла выбрал человек» — только про ФОРМАТ ФАЙЛА (16.10.2026).
           До этой даты сюда шёл любой select, у которого в name||id ПОДСТРОКОЙ
           встречались format/ext/output: `ext` ловил text/next/context/nsExType,
           `output` — качество и устройство вывода, `format` — формат времени и
           бумаги. Прод RU, 7 дней: 1 312 из 4 780 событий (27 %, 12 тулов) — не
           формат; самое частое значение панели «Форматы экспорта» (/pino/streams)
           было `source` (952) — select КАЧЕСТВА /repair-audio. /number-systems
           уже переименовывал свой id, чтобы сюда не попадать.
           Правило — два признака сразу:
             · имя: целое СЛОВО format/fmt/ext/extension в name||id (camelCase,
               дефис, подчёркивание делят слова) или явное data-export-format;
             · значение: формат файла (расширение или MIME — MIME сводится к
               подтипу) либо «как у исходника» (same/source/original/keep/auto):
               «24h», «a4», «serif», «320» — не формат файла.
           ⚠️ Программный change (карточки форматов, автовыбор тула) — считается:
           карточки format-cards двигают скрытый select без доверенного события. */
        window.__exportFormatOf=function(t){
            if(!t||t.tagName!=='SELECT')return '';
            var decl=t.getAttribute&&t.getAttribute('data-export-format');
            if(decl==='off')return '';
            if(decl===null){
                var words=String(t.name||t.id||'').replace(/([a-z0-9])([A-Z])/g,'$1 $2').replace(/([A-Z])([A-Z][a-z])/g,'$1 $2').toLowerCase().split(/[^a-z0-9]+/);
                var named=false;
                for(var i=0;i<words.length;i++){if(/^(format|fmt|ext|extension)$/.test(words[i])){named=true;break;}}
                if(!named)return '';
            }
            var v=String(t.value||'').toLowerCase().trim();
            var mime=/^(audio|video|image|application|text|model|font)\/([a-z0-9.+-]{1,24})$/.exec(v);
            if(mime)v=mime[2].replace(/^x-/,'');
            if(/^(same|source|original|keep|auto)$/.test(v))return v;
            if(/^(mp3|wav|wave|flac|ogg|oga|opus|m4a|m4r|m4b|aac|wma|aiff?|amr|ac3|mka|midi?|caf|mp4|m4v|mov|quicktime|webm|mkv|matroska|avi|3gp|wmv|flv|mpe?g|ts|ogv|gif|apng|png|jpe?g|webp|avif|heic|heif|bmp|tiff?|ico|svg|svg\+xml|jxl|pdf|docx?|xlsx?|pptx?|odt|ods|odp|rtf|txt|text|plain|md|markdown|html?|xml|json|csv|tsv|sql|epub|fb2|mobi|ics|vcf|srt|vtt|ass|ssa|sub|lrc|zip|7z|tar|gz|rar|iso|img|bin|dat|raw|stl|obj|glb|gltf|ply|3mf|dxf|dwg|ttf|otf|woff2?)$/.test(v))return v;
            return '';
        };
        /* __exportFormat:end */
        // ── Export Format Tracking — detect format selection from common UI patterns ──
        if(slug){
            var _lastFormat='';
            document.addEventListener('change',function(e){
                var v=window.__exportFormatOf(e.target);
                if(v&&v!==_lastFormat){
                    _lastFormat=v;
                    window.__ae('feature_use',{slug:slug,f:'export_format',v:v});
                }
            },true);
        }

        // ── Auto tool_complete for screen-result tools (no file download) ──
        // Detect results appearing via MutationObserver on common result class patterns
        if(slug){
            var _resultSent=false;
            var _resultClasses=['result','results','output','score','report','chart','analysis'];
            var _resultObs=new MutationObserver(function(mutations){
                // Opt-out: a tool whose REAL completion is a file download (e.g. photo-repair,
                // which shows an on-screen before/after AND downloads) sets
                // window.__skipScreenComplete=true so the screen reveal is NOT counted as a
                // completion. Without this it double-counts with the download tool_complete
                // and marks preview-without-save sessions as fake successes (masking abandonment).
                if(_resultSent||_hasResult||window.__skipScreenComplete)return;
                for(var i=0;i<mutations.length;i++){
                    var m=mutations[i];
                    if(m.type==='attributes'&&m.attributeName==='class'){
                        var cl=m.target.className;
                        if(typeof cl!=='string')continue;
                        var low=cl.toLowerCase();
                        // Element gained 'visible', 'active', 'show', 'open' class and contains a result keyword
                        if((low.indexOf('visible')!==-1||low.indexOf('active')!==-1||low.indexOf('show')!==-1)&&_resultClasses.some(function(r){return low.indexOf(r)!==-1})){
                            _resultSent=true;_hasResult=true;
                            window.__ae('tool_complete',_enrichComplete({slug:slug,src:'screen'}));
                            _resultObs.disconnect();
                            return;
                        }
                    }
                }
            });
            _resultObs.observe(document.body,{attributes:true,subtree:true,attributeFilter:['class']});
            // Auto-disconnect after 10 minutes to avoid memory leaks
            setTimeout(function(){_resultObs.disconnect()},600000);
        }

        // ── Server-side Processing — auto-instrument fetch/XHR POST to track funnel, perf, errors ──
        if(slug){
            // Tool AJAX URLs are /{locale}/{slug}/... — match current tool's slug,
            // not a /tools/ literal (routes don't have /tools/ prefix)
            var _slugMarker='/'+slug+'/';
            // Patch fetch()
            var _origFetch=window.fetch;
            window.fetch=function(url,opts){
                var isToolPost=opts&&opts.method&&opts.method.toUpperCase()==='POST'&&typeof url==='string'&&url.indexOf(_slugMarker)!==-1;
                if(!isToolPost)return _origFetch.apply(this,arguments);
                var fs=0;
                try{if(opts.body instanceof FormData){var f=opts.body.get('file')||opts.body.get('audio')||opts.body.get('video');if(f&&f.size)fs=f.size}}catch(e){}
                if(!_funnelSent.server_processing){_funnelSent.server_processing=1;window.__aeFunnel('processing',{via:'server',size:fs})}
                var t0s=performance.now();
                return _origFetch.apply(this,arguments).then(function(resp){
                    var ms=Math.round(performance.now()-t0s);
                    if(resp.ok){
                        window.__ae('perf',{slug:slug,ms:ms,size:fs,via:'server',status:resp.status});
                    }else{
                        resp.clone().text().then(function(body){
                            _emitServerNonOk(resp.status,body,fs,ms);
                        }).catch(function(){
                            _emitServerNonOk(resp.status,'',fs,ms);
                        });
                    }
                    return resp;
                }).catch(function(err){
                    var ms=Math.round(performance.now()-t0s);
                    var em=(err&&err.message||'').substring(0,500);
                    // Generic browser network signals — connection died, no
                    // server-side reach, no actionable bug. Route as
                    // tool_blocked with reason='network' so dashboards keep
                    // them out of the error rate but we still see frequency.
                    if(/Failed to fetch|Load failed|NetworkError|network request failed|Network request failed/i.test(em)){
                        if(window.__aeBlocked)window.__aeBlocked({slug:slug,reason:'network',err_msg:em,size:fs,ms:ms,br:_br,mob:_mob});
                        else window.__ae('tool_blocked',{slug:slug,reason:'network',err_msg:em,size:fs,ms:ms,br:_br,mob:_mob});
                    }else{
                        window.__ae('tool_error',{slug:slug,error_type:'server_network',err_msg:em,size:fs,ms:ms,br:_br,mob:_mob});
                    }
                    throw err;
                });
            };
            // Server returned non-2xx. Discriminate user-fixable validation
            // failures (4xx with a typed reason in the JSON body) from real
            // server bugs (5xx, opaque 4xx). The first kind belongs in
            // tool_blocked with a reason we can pivot on; lumping them under
            // tool_error inflates the error rate and buries actual bugs.
            //
            // Single-emitter rule (2026-06-02 etalon — closes 6586 same-second
            // duplicates / 7d in /pino/streams across text-to-speech /
            // voice-translator / speed-test): when the server sends a TYPED
            // error_kind via body.error, the tool's outer catch is the
            // canonical emitter — it owns the localized message, enriches the
            // payload with voice/locale/text_len/etc., and decides UX. The
            // wrapper here only emits as SAFETY NET for tools that DON'T catch
            // (small new tools that don't have an outer try/catch). So:
            //   typed reason present → tool owns it → wrapper SKIPS emission.
            //   untyped 4xx (422/429 no body.error) → safety-net emit.
            //   5xx / opaque 4xx → tool_error as before.
            // The contract is server-driven: any tool whose server emits a
            // typed `error_kind` automatically gets clean telemetry — no
            // per-slug registry, no flag-before-throw race, no convention to
            // remember. New tools that need clean telemetry simply have their
            // server return `{"error": "<snake_case_kind>"}`.
            function _emitServerNonOk(status,body,fs,ms){
                var reason='',kind='';
                if(status>=400&&status<500&&body){
                    // Two spellings of the same idea. `error` means "the tool's own catch
                    // owns this row" (skip below). `error_kind` — used by 10 handlers,
                    // voice-cover among them — was matched by NEITHER branch, so every one
                    // of those typed refusals landed in the safety net as an anonymous
                    // «validation». /voice-cover's 64 refusals over 14 days were therefore
                    // indistinguishable from each other, and the one user who wrote in
                    // could only be diagnosed by decoding nginx response byte counts.
                    // Keep emitting (nothing else emits for those tools) — but name it,
                    // in a NEW field. Overwriting `reason` would silently redefine two
                    // live series (422 'validation', 429 'rate_limit') mid-flight, and
                    // a dashboard comparing week over week would read the rename as a
                    // change in behaviour. Additive: old series intact, kind alongside.
                    try{var j=JSON.parse(body);
                        if(j&&typeof j.error==='string'&&j.error.length<60&&/^[a-z0-9_]+$/i.test(j.error))reason=j.error;
                        else if(j&&typeof j.error_kind==='string'&&j.error_kind.length<60&&/^[a-z0-9_]+$/i.test(j.error_kind))kind=j.error_kind;
                    }catch(_){}
                }
                if(reason){
                    // Typed error — tool's catch will emit with full enrichment.
                    return;
                }
                if(status===422||status===429){
                    // Untyped status the user can act on — safety-net emit.
                    var _p={slug:slug,error_type:'server_validation',status:status,reason:status===429?'rate_limit':'validation',size:fs,ms:ms,br:_br,mob:_mob};
                    if(kind)_p.kind=kind;
                    if(window.__aeBlocked)window.__aeBlocked(_p);
                    else window.__ae('tool_blocked',_p);
                    return;
                }
                window.__ae('tool_error',{slug:slug,error_type:'server_error',status:status,err_msg:window.__ffMsg(body,500),size:fs,ms:ms,br:_br,mob:_mob});
            }
            // Patch XMLHttpRequest for tools that use XHR instead of fetch
            var _origXHROpen=XMLHttpRequest.prototype.open;
            var _origXHRSend=XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.open=function(method,url){
                this.__isToolPost=method&&method.toUpperCase()==='POST'&&typeof url==='string'&&url.indexOf(_slugMarker)!==-1;
                return _origXHROpen.apply(this,arguments);
            };
            XMLHttpRequest.prototype.send=function(body){
                if(!this.__isToolPost)return _origXHRSend.apply(this,arguments);
                var xhr=this;
                var fs=0;
                try{if(body instanceof FormData){var f=body.get('file')||body.get('audio')||body.get('video');if(f&&f.size)fs=f.size}}catch(e){}
                if(!_funnelSent.server_processing){_funnelSent.server_processing=1;window.__aeFunnel('processing',{via:'server',size:fs})}
                var t0x=performance.now();
                xhr.addEventListener('load',function(){
                    var ms=Math.round(performance.now()-t0x);
                    if(xhr.status>=200&&xhr.status<400){
                        window.__ae('perf',{slug:slug,ms:ms,size:fs,via:'server',status:xhr.status});
                    }else{
                        // responseText is ONLY readable when responseType is ''
                        // or 'text'; a tool that asked for a blob/arraybuffer
                        // (any download-producing endpoint) makes this getter
                        // throw InvalidStateError — and it threw from inside the
                        // shared telemetry interceptor, i.e. observation broke
                        // the tool it was observing (TIMBRICA-FRONTEND-C9 on
                        // /trim's 422). Telemetry must never be able to do that:
                        // read the body only when the type allows it, and never
                        // let this handler throw at all.
                        var _body='';
                        try{
                            var rt=xhr.responseType;
                            if(!rt||rt==='text')_body=xhr.responseText||'';
                        }catch(e){}
                        try{_emitServerNonOk(xhr.status,_body,fs,ms);}catch(e){}
                    }
                });
                xhr.addEventListener('error',function(){
                    var ms=Math.round(performance.now()-t0x);
                    // Same as fetch — XHR error means connection died, user-side
                    // network issue, not a tool bug.
                    if(window.__aeBlocked)window.__aeBlocked({slug:slug,reason:'network',via:'xhr',size:fs,ms:ms,br:_br,mob:_mob});
                    else window.__ae('tool_blocked',{slug:slug,reason:'network',via:'xhr',size:fs,ms:ms,br:_br,mob:_mob});
                });
                return _origXHRSend.apply(this,arguments);
            };
        }

        // ── Tool Interact — first meaningful interaction (button click, slider change, play) ──
        if(slug){
            var _interacted=false;
            function trackInteract(action){
                if(_interacted)return;_interacted=true;
                window.__ae('tool_interact',{slug:slug,a:action,d:Math.round((Date.now()-t0)/1000)});
            }
            document.addEventListener('click',function(e){
                var t=e.target;if(!t)return;
                if(e.isTrusted===false)return;   // a click OUR code made is not a user's
                // Resolve to the nearest button/link first: clicking an <svg>
                // icon inside a button reports the SVG as e.target, so the bare
                // tagName check below dropped every icon-button click. Measured
                // 2026-08-05 on /camera-test — 72.6% of sessions started the
                // camera, only 14% ever registered a tool_interact.
                if(t.closest){var _c=t.closest('button,a');if(_c)t=_c;}
                var tag=t.tagName;
                // Process/export/download buttons
                if(tag==='BUTTON'||tag==='A'){
                    var txt=(t.textContent||'').toLowerCase();
                    var cls=(t.className||'').toString().toLowerCase();
                    if(cls.indexOf('btn')!==-1||cls.indexOf('export')!==-1||cls.indexOf('process')!==-1||cls.indexOf('download')!==-1||cls.indexOf('record')!==-1||cls.indexOf('play')!==-1||cls.indexOf('start')!==-1)
                        trackInteract('btn');
                    // Any other control the user pressed in the page body — a mode
                    // tab, a layout chip, a format chip. Kept under its own name so
                    // the historical 'btn' series stays comparable; navigation and
                    // chrome are excluded because they are not the tool.
                    else if(!t.closest('header,nav,footer,aside,.tool-sidebar'))
                        trackInteract('ctl');
                }
            },true);
            document.addEventListener('input',function(e){
                var t=e.target;if(!t)return;
                // ⚠️⚠️ A SYNTHETIC input is not an interaction. __toolSettings.bind
                // restores a saved slider by assigning .value and dispatching
                // `new Event('input')` — at PAGE LOAD. trackInteract latches on the
                // first event it sees, so that restore ate the slot and the user's
                // real first action was never recorded at all. Measured 2026-09-11
                // on intl over 30 days: of every tool_interact this tool emitted,
                // 97% were `slider` at d≤1s; vibration-test 100%, speaker-test 98%,
                // volume 95%, equalizer 89% — 4026 events site-wide that describe
                // our own page load. The metric was reporting on itself, and it is
                // the metric anyone reaches for to ask "did they engage before
                // leaving?". isTrusted is false for every dispatchEvent and true
                // for real input, which is exactly the distinction wanted here.
                if(e.isTrusted===false)return;
                if(t.type==='range')trackInteract('slider');
            },true);

            // Silent-click detection lives in the external module
            // public/js/silent-click-detector.js (loaded just below this
            // inline block). It was moved out of this inline <script> on
            // 2026-05-16: the MinifyHtml regex minifier intermittently
            // truncated a large inline script, dropping the detector and
            // every line after it. External files bypass MinifyHtml.
        }
    })();
    /* ALWAYS-ON last-action mirror (consent-independent).
         Wraps whatever __ae is at this point — real impl + silent-click
         wrapper if consent granted, or the no-op stub if declined. Mirrors
         meaningful events into window.__LAST_TOOL_ACTION so the feedback
         widget surfaces actionable diagnostic data (last_action /
         last_error_type) for declined-cookies users too. In-memory only,
         no network — GDPR-clean even with consent declined. Closes the
         diagnostic blind spot that surfaced in the 2026-05-07 Yandex /
         Android 15 / 2 GB bug-report (last_action:null, last_error:null
         despite the user clearly hitting an error). */
    /* __fileless:begin */
    /* Имя файла — текст человека, а не диагностика (16.10.2026, волна 2).
       Последнее действие (__LAST_TOOL_ACTION, ниже) уезжает в письмо
       обратной связи, в контекст чата поддержки и в `feedback_submit` ЖУРНАЛА
       АНАЛИТИКИ; туда же шла полезная нагрузка любого события. Тулы клали в
       неё имя файла: свои записи о загрузке (/audio-watermark, /equalizer,
       /voice-compressor), `tool_blocked{file}` и `tool_error{file_name}`
       /heic-converter, `tool_complete{name}` /pdf-to-jpg, выдача по ссылке
       сервера (`file_download{via:server_link, name}`). Правило одно, как у
       __errCtx и двери результата: от имени остаётся РАСШИРЕНИЕ. Чистит одна
       функция на входе в __ae — и для зеркала, и для отправки: следующий тул,
       положивший `name: file.name`, имя уже не унесёт. Разбор жалоб не слепнет:
       сам файл (имя, размер, тип) описывает __LAST_FILE — его читают письмо и
       карточка чата, а в журнал он не пишется.
       Ключи — только «имяподобные»; значение чистится, только если похоже на
       имя файла (точка и расширение с буквой): `name:'emoji_picker_insert'`
       и `name:'v1.2'` остаются. Сторож — tests/js/fileless-payload.test.mjs.

       Волна 3 (17.10.2026): имя ехало и СВОБОДНЫМ ТЕКСТОМ, и аварийным каналом.
       Прод RU, 7 дней: в /api/log-error (client-errors.log с IP, для ffmpeg-* — ещё и журнал)
       638 записей с именем — filebytes-prime-fail `key=ИМЯ|размер|время` 252, ffmpeg-exit
       `вход→ВЫХОД` (выход тулы называют по имени человека) 239, tool_stage_error с текстом тоста
       «Файл ИМЯ.mp4 не удалось…» 96, ffmpeg-reinit 49; в журнале — msg/err_msg тостов, `src`
       /photo-markup, `label` /thumbnail-maker. Теперь — реестр имён файлов, которые человек
       выбрал (change/drop/paste/tool-uploader:file, паспорт __LAST_FILE, FileBytes): каждое такое
       имя и приметная основа без расширения заменяются во ВСЕХ строковых полях на `*.расш`
       и `*`; та же функция чистит __aeCritical и голые navigator.sendBeacon('/api/log-error')
       (FFmpeg, кэш байтов файла). Эвристика «что-то.mp3 в тексте» отвергнута замером:
       имена с пробелами она режет до последнего слова («Иванов Пётр 5Б *.wav»), а на корпусе
       прода за 7 дней изменила 522 записи без единого имени человека (decoded.wav, repaired.mp4 —
       наши внутренние имена, диагностика). Прибор — fileless-bench (журнал hosttails 17.10). */
    window.__fileless=(function(){
        var KEYS={name:1,file:1,file_name:1,filename:1,fileName:1,fname:1,out_name:1,outName:1};
        /* Поля устройства события (слаг, страница, тип, UA) не чистятся: файл, названный как слаг
           или стадия, иначе стёр бы саму принадлежность события. */
        var SKIP={slug:1,page:1,type:1,ua:1,stage:1};
        function extOf(v){var m=/\.([A-Za-z0-9]{1,8})$/.exec(v);return (m&&/[A-Za-z]/.test(m[1]))?m[1].toLowerCase():null;}
        var seen=[];
        function note(n){
            try{
                n=String(n==null?'':n);if(n.length<3||n.length>255)return;
                for(var i=0;i<seen.length;i++)if(seen[i].n===n){if(i)seen.unshift(seen.splice(i,1)[0]);return;}
                var x=extOf(n),b=x?n.slice(0,-(x.length+1)):n;
                /* Основа без расширения заменяется, только если приметна: от 4 знаков и есть пробел,
                   цифра, заглавная или не латиница. «audio», «track» — слова сообщений, а не имена;
                   одни цифры («2024», «1080») — не имя человека, а замена портила бы «1920x1080» и даты. */
                var mark=b.length>=4&&/[\s\d\u0080-\uffffA-Z]/.test(b)&&!/^[\d\s._-]+$/.test(b);
                seen.unshift({n:n,b:mark?b:'',x:x||''});
                if(seen.length>40)seen.pop();
            }catch(_){}
        }
        function text(v){
            if(typeof v!=='string'||v.length<3)return v;
            try{var lf=window.__LAST_FILE;if(lf&&lf.name)note(lf.name);}catch(_){}
            var out=v;
            for(var i=0;i<seen.length;i++){
                var s=seen[i];
                if(out.indexOf(s.n)>=0)out=out.split(s.n).join('*'+(s.x?'.'+s.x:''));
                if(s.b&&out.indexOf(s.b)>=0)out=out.split(s.b).join('*');
            }
            return out;
        }
        var f=function(p){
            if(!p||typeof p!=='object'||Array.isArray(p))return p;
            var out=null;
            for(var k in p){
                var v=p[k];
                if(typeof v!=='string'||SKIP[k])continue;
                if(KEYS[k]){
                    var x=extOf(v);
                    if(x!==null){
                        if(!out){out={};for(var j in p)out[j]=p[j];}
                        delete out[k];
                        if(!out.ext)out.ext=x;
                        continue;
                    }
                }
                var t=text(v);
                if(t!==v){if(!out){out={};for(var j2 in p)out[j2]=p[j2];}out[k]=t;}
            }
            return out||p;
        };
        f.text=text;
        f.note=note;
        try{
            var feed=function(files){try{for(var i=0;files&&i<files.length;i++)if(files[i]&&files[i].name)note(files[i].name);}catch(_){}};
            document.addEventListener('change',function(e){var t=e.target;if(t&&t.type==='file')feed(t.files);},true);
            document.addEventListener('drop',function(e){feed(e.dataTransfer&&e.dataTransfer.files);},true);
            document.addEventListener('paste',function(e){feed(e.clipboardData&&e.clipboardData.files);},true);
            document.addEventListener('tool-uploader:file',function(e){var d=(e&&e.detail)||{};if(d.file)feed([d.file]);if(d.files)feed(d.files);},true);
        }catch(_){}
        /* Голые маяки аварийного канала (FFmpeg, кэш байтов файла) — та же чистка. */
        try{
            var ob=navigator.sendBeacon;
            if(typeof ob==='function'){
                navigator.sendBeacon=function(u,b){
                    try{
                        if(typeof u==='string'&&u.indexOf('/api/log-error')>=0&&typeof b==='string'&&b.indexOf('.')>=0){
                            var arr=JSON.parse(b),ch=false;
                            if(Array.isArray(arr))for(var i=0;i<arr.length;i++){
                                var it=arr[i];if(!it||typeof it!=='object')continue;
                                for(var k in it){if(k==='page'||k==='ua')continue;var v=it[k];if(typeof v==='string'){var t=text(v);if(t!==v){it[k]=t;ch=true;}}}
                            }
                            if(ch)b=JSON.stringify(arr);
                        }
                    }catch(_){}
                    return ob.call(navigator,u,b);
                };
            }
        }catch(_){}
        return f;
    })();
    /* Запись последнего действия самим тулом (загрузка файла и т. п.) — в той
       же форме, что у зеркала ниже ({a, t, p, ts}): её читают карточка чата
       поддержки (`a`) и уход со страницы (`last_action`). Рукописная форма
       `{tool, action, name, …}` была невидима обоим и несла имя файла. */
    window.__noteAction=function(a,p){
        try{window.__LAST_TOOL_ACTION={a:String(a||'?'),t:'tool',p:window.__fileless(p||null),ts:Date.now()};}catch(_){}
    };
    (function(){
        var _meaninglessOuter={tool_interact:1,rage_click:1,scroll_depth:1,time_on_page:1,ad_impression:1,ad_failed:1,ad_error:1,session_start:1,device_cap:1,page_view:1,silent_click:1};
        var _origForMirror = window.__ae || function(){};
        window.__ae = function(type, p){
            var _args = arguments;
            var _clean = window.__fileless(p);
            if (_clean !== p) { p = _clean; _args = Array.prototype.slice.call(arguments); _args[1] = p; }
            // Feedback-widget interactions (emoji picker, source-attribution) fire
            // AFTER the user decided to report — they are NOT the tool action that
            // caused the problem. Mirroring them poisoned last_action: the
            // 2026-06-27 /es/document-reader report showed last_action "feature:?"
            // (= emoji_picker_insert{source:feedback}) instead of the real last
            // action (the over-limit play attempt). Exclude source:feedback.
            var isFeedback = p && p.source === 'feedback';
            if (!_meaninglessOuter[type] && !isFeedback) {
                try {
                    var summary='';
                    if(type==='tool_interact')summary='interact:'+(p&&p.a||'?');
                    // tool_stage payload uses `stage` (canonical key); accept `to`
                    // for any legacy callers. Previously this only checked `to`,
                    // so 313 of 519 abandons on /checkers showed last_action:stage:?
                    // — telemetry was blind to the user's actual stage (in_game /
                    // over / etc.). Fixed 2026-05-22.
                    else if(type==='tool_stage')summary='stage:'+(p&&(p.stage||p.to)||'?');
                    else if(type==='tool_complete')summary='complete';
                    else if(type==='tool_blocked')summary='blocked:'+(p&&(p.reason||p.error_type)||'?');
                    else if(type==='tool_error')summary='error:'+(p&&p.error_type||'?');
                    // feature_use payloads use `f` (funnel events), `kind` (most tools),
                    // `action`, or `name` (shared widgets like the emoji picker) — read
                    // all four or the funnel logs an uninformative "feature:?".
                    else if(type==='feature_use')summary='feature:'+(p&&(p.f||p.kind||p.action||p.name)||'?');
                    else summary=type;
                    window.__LAST_TOOL_ACTION={a:summary,t:type,p:p||null,ts:Date.now()};
                } catch(_){}
                /* «Тул выдал результат» — общий сигнал для всего, что должно
                   просыпаться ПОСЛЕ выдачи (сейчас — указатель на кнопку
                   скачивания, window.__resultCue в timbrica-core.js). Живёт
                   ЗДЕСЬ, потому что это единственная точка, через которую
                   проходят ВСЕ объявления о завершении: и __aeToolComplete,
                   и прямой __ae('tool_complete'). Обёртка всегда-включённая,
                   поэтому сигнал доходит и при отказе от cookie — иначе
                   указатель не появился бы ровно у того, кто уже прислал
                   жалобу (у автора #5837 телеметрия молчала). */
                if(type==='tool_complete'){
                    try{document.dispatchEvent(new CustomEvent('tmb:tool-complete',{detail:p||null}));}catch(_){}
                }
            }
            return _origForMirror.apply(this, _args);
        };
    })();
    /* __fileless:end */

    /* ── INP attribution ───────────────────────────────────────────────────
       Search Console reports the origin failing Core Web Vitals on INP alone
       (276 ms mobile on /en; LCP and CLS are green). INP is a FIELD metric
       over real interactions, and we collected none of it — so every attempt
       to name the culprit from a lab run was guesswork. Two days of trying to
       reproduce it locally produced contradictory numbers on a loaded machine;
       a change shipped on that basis would have been a coin flip.

       This reports only interactions at or past the "needs improvement" line
       (200 ms), with the breakdown that says WHICH part is slow:
         delay  — input sat queued behind a busy main thread (blame long tasks)
         proc   — our own handlers ran long (blame JS)
         paint  — style/layout/paint after the handlers (blame DOM size + CSS)
       Volume is self-limiting: fast interactions are never sent, and a page
       reports at most 3 times. Good interactions are deliberately NOT sampled
       — CrUX already supplies the distribution; what it cannot tell us is the
       element.

       The page's worst interaction also ships once as `web_vital` {INP}. That
       type, its admin panel and its p75 aggregation have existed since the
       analytics dashboard was built — with nothing on the planet emitting it,
       so the panel has always been empty. Producer added here. */
    (function(){
        if(!window.PerformanceObserver||!window.PerformanceObserver.supportedEntryTypes)return;
        if(window.PerformanceObserver.supportedEntryTypes.indexOf('event')===-1)return;
        var SLOW_MS=200,MAX_REPORTS=3,sent=0,worst=0,pageWorst=0,vitalSent=0,dropped=0;

        /* Backgrounding artefact guard (added 2026-08-04, six hours after the
           first data landed).
           An interaction whose tab is swiped away has no "next paint" until the
           user comes back, so the entry's duration measures TIME AWAY, not
           slowness: the field showed 27 000 000 ms on a text-to-speech textarea
           and a 1 050 552 872 ms outlier in the vital. Only 1.8% of rows — and
           they moved the average for /text-to-speech to 14.6 MILLION ms, i.e.
           any mean computed over this table was meaningless while they were in.
           Dropping them is not cosmetic: a dashboard nobody can average is a
           dashboard nobody reads. `drop` ships with the vital so the artefact
           rate stays visible instead of becoming a silent exclusion. */
        /* Long Animation Frame attribution — the field answers what the lab
           could not.
           Local A/B runs on this machine could NOT isolate a fix: the drawer's
           animation, its 598-link DOM, content-visibility, ads, fonts — every
           candidate measured inside the noise, and the one textbook fix that
           looked certain (transform instead of left) came out WORSE. Meanwhile
           the field is unambiguous: our handlers cost 6–22 ms while the time
           sits in input delay and paint. LoAF names the script and the
           forced-layout share of the frame that blocked, on real devices, so
           the next fix can be chosen instead of guessed at. */
        /* 08.2026: frames were read straight off the performance timeline,
           because a bare second observer is delivered in the same batch as the
           `event` one and the interaction always won the race — attribution
           came out null on every measured run.
           ⚠️ 04.11.2026: the timeline keeps only the FIRST 200 long frames (measured
           04.11.2026, Chrome 156: 4 → 44 → … → 200, 200, 200 over 260 forced
           frames). A slow phone fills it during load and scrolling, and every
           later interaction then read «no long frame» — the attribution went
           blind exactly where it was needed, and that blindness looked like
           «time off the main thread». So the frames are kept in a ring of the
           most recent ones. The race that once ruled out a second observer
           (it is delivered in the same batch as `event`, and the interaction
           wins) is closed by takeRecords(): at report time it hands over the
           frames that are queued but not yet delivered. Cost: one push per
           long frame. Without LoAF support — the timeline, as before. */
        var _loafRing=[],_loafObs=null;
        function _loafKeep(es){
            for(var i=0;i<es.length;i++)_loafRing.push(es[i]);
            if(_loafRing.length>64)_loafRing.splice(0,_loafRing.length-64);
        }
        try{
            if(PerformanceObserver.supportedEntryTypes.indexOf('long-animation-frame')!==-1){
                _loafObs=new PerformanceObserver(function(l){_loafKeep(l.getEntries())});
                _loafObs.observe({type:'long-animation-frame',buffered:true});
            }
        }catch(_){_loafObs=null}
        function loafList(){
            if(_loafObs){try{_loafKeep(_loafObs.takeRecords())}catch(_){}return _loafRing}
            try{return performance.getEntriesByType('long-animation-frame')}catch(_){return null}
        }
        function loafFor(e){
            var list=loafList();
            if(!list||!list.length)return null;
            var end=e.startTime+e.duration,best=null;
            for(var i=list.length-1;i>=0;i--){
                var f=list[i];
                if(f.startTime>end)continue;
                if(f.startTime+f.duration<e.startTime)break;   // older than the interaction
                if(!best||f.duration>best.duration)best=f;
            }
            if(!best)return null;
            var top=null,scripts=best.scripts||[];
            for(var j=0;j<scripts.length;j++){
                if(!top||scripts[j].duration>top.duration)top=scripts[j];
            }
            return {
                b:Math.round(best.blockingDuration||0),
                // Filename only: a full sourceURL carries query strings, and
                // this payload is capped at 1 KB server-side.
                u:top?String(top.sourceURL||'').split('/').pop().split('?')[0].substring(0,40):'',
                f:top?String(top.sourceFunctionName||'').substring(0,30):'',
                fl:top?Math.round(top.forcedStyleAndLayoutDuration||0):0
            };
        }

        /* Every long frame the interaction touched, not just the longest one
           (04.11.2026). `lf` left two questions open on mobile Chrome (2 days,
           2 322 slow taps): 631 of them name `bundle.min.js·sentryWrapped` —
           the error SDK wraps every listener and timer, so the entry point is
           always its wrapper — and 42 % have no script to name at all (a
           blocking frame without scripts, blocking 0, or no long frame), i.e.
           time the lab cannot reproduce. `lx` answers both:
             o  frame start relative to the tap, d duration, b blocking,
             r  rendering (renderStart → end), sl style+layout part of it,
             sc all scripts, fl their forced style/layout,
             s  up to three scripts; `i` is the invoker, which names the element
                and the event even under a wrapper (`BUTTON#x.onclick`).
           `cov` — how much of the interaction long frames cover; `d − cov` is
           time the main thread did not hold (compositor, raster, GPU, the soft
           keyboard). Frames never overlap, so the sum IS the union. */
        var _INV={'classic-script':'cs','module-script':'ms','event-listener':'el','user-callback':'uc','resolve-promise':'rp','reject-promise':'jp'};
        function _file(u){return String(u||'').split('?')[0].split('#')[0].split('/').pop().substring(0,40)}
        function _invoker(x){
            var s=String(x.invoker||'');
            if(x.invokerType==='classic-script'||x.invokerType==='module-script')return _file(s);
            // Element names only — a blob/data address or a query string is not a name.
            return s.replace(/(blob:|data:)[^\]\s]*/g,'$1').replace(/\?[^\]\s]*/g,'').substring(0,50);
        }
        function framesFor(e){
            var list=loafList();
            if(!list)return null;
            var s0=e.startTime,end=s0+e.duration,hit=[],cov=0;
            for(var i=0;i<list.length;i++){
                var f=list[i],fe=f.startTime+f.duration;
                if(fe<s0||f.startTime>end)continue;
                cov+=Math.min(fe,end)-Math.max(f.startTime,s0);
                hit.push(f);
            }
            // The four longest, reported in time order (payload stays well under the ingest cap).
            hit=hit.slice().sort(function(a,b){return b.duration-a.duration}).slice(0,4)
                .sort(function(a,b){return a.startTime-b.startTime});
            var fr=[];
            for(var k=0;k<hit.length;k++){
                var F=hit[k],Fe=F.startTime+F.duration,sc=0,fl=0,ss=(F.scripts||[]).slice();
                for(var j=0;j<ss.length;j++){sc+=ss[j].duration||0;fl+=ss[j].forcedStyleAndLayoutDuration||0}
                ss.sort(function(a,b){return (b.duration||0)-(a.duration||0)});
                var top=[];
                for(var t=0;t<ss.length&&t<3;t++){
                    var x=ss[t];
                    top.push({t:_INV[x.invokerType]||String(x.invokerType||'').substring(0,12),
                        u:_file(x.sourceURL),f:String(x.sourceFunctionName||'').substring(0,30),
                        i:_invoker(x),d:Math.round(x.duration||0),fl:Math.round(x.forcedStyleAndLayoutDuration||0)});
                }
                fr.push({o:Math.round(F.startTime-s0),d:Math.round(F.duration),b:Math.round(F.blockingDuration||0),
                    r:F.renderStart>0?Math.round(Fe-F.renderStart):0,
                    sl:F.styleAndLayoutStart>0?Math.round(Fe-F.styleAndLayoutStart):0,
                    sc:Math.round(sc),fl:Math.round(fl),s:top});
            }
            return {fr:fr,cov:Math.round(cov)};
        }

        var SANE_MAX=30000,lastHidden=(document.visibilityState==='hidden')?0:-1;
        document.addEventListener('visibilitychange',function(){
            if(document.visibilityState==='hidden')lastHidden=performance.now();
        },true);
        function usable(e){
            if(e.duration>SANE_MAX)return false;
            if(document.visibilityState==='hidden')return false;
            // The tab went away at or after this interaction began — its paint
            // timestamp is when the user RETURNED, not when we rendered.
            if(lastHidden>=0&&lastHidden>=e.startTime)return false;
            return true;
        }

        /* `(detached)` was the single biggest bucket in this event and named
           nothing: 21 438 of 210 345 slow mobile interactions over 14 days
           (10.2%), mean 544 ms. It is not a fallback for weird targets — it is
           what PerformanceEventTiming.target returns once the node has left the
           document, and a tap that re-renders its own UI has always removed it
           by the time the observer runs one frame later.

           describe() itself works perfectly well on a detached node; only the
           entry's getter refuses. So keep a WEAK handle to what was tapped at
           DISPATCH time, when it is still attached, and describe that instead.
           Capture phase, because the app's own handler is what removes it.

           Cost is a store — no strings, no closest() — on the three event types
           that carry an interactionId. The rage-click listener already in this
           file does a closest() on every click, so this is the cheaper of the
           two things now bound to a tap. */
        var _tapRing=[],_TAP_MAX=8;
        function _tapRemember(e){
            try{
                var n=e.target;
                if(!n||n.nodeType!==1)return;
                _tapRing.push({t:e.timeStamp,r:(typeof WeakRef==='function')?new WeakRef(n):{deref:function(){return n}}});
                if(_tapRing.length>_TAP_MAX)_tapRing.shift();
            }catch(_){}
        }
        try{
            document.addEventListener('pointerdown',_tapRemember,{capture:true,passive:true});
            document.addEventListener('keydown',_tapRemember,{capture:true,passive:true});
            document.addEventListener('click',_tapRemember,{capture:true,passive:true});
        }catch(_){}
        /* Match on the event's own timestamp: entry.startTime and DOM
           event.timeStamp share the time origin, so the pair lines up to a
           fraction of a millisecond. 30 ms is generous for that and still far
           below the gap between two taps — wide enough and it would start
           naming the PREVIOUS tap, which is worse than admitting we lost it. */
        function recallTarget(startTime){
            var best=null,bd=1e9;
            for(var i=_tapRing.length-1;i>=0;i--){
                var d=Math.abs(_tapRing[i].t-startTime);
                if(d<bd){bd=d;best=_tapRing[i]}
            }
            if(!best||bd>30)return null;
            try{return best.r.deref()||null}catch(_){return null}
        }

        /* Bounded, non-identifying description of what was tapped. Never text
           content — a tap target can hold a user's own string (their file name,
           their note), and this event is not the place for it. */
        function describe(el){
            if(!el||el.nodeType!==1)return '(detached)';
            var s=el.tagName.toLowerCase();
            if(el.id)s+='#'+el.id;
            else{
                var c=(typeof el.className==='string'?el.className:'').trim().split(/\s+/)[0];
                if(c)s+='.'+c;
            }
            var named=el.closest&&el.closest('[data-slug],[aria-label],[data-action]');
            if(named&&named!==el){
                var a=named.getAttribute('data-action')||named.getAttribute('data-slug');
                if(a)s+='<'+a;
            }
            return s.substring(0,80);
        }

        try{
            /* Every interaction (16 ms floor) feeds the page's INP; only the
               slow ones get the attribution event. One observer, two outputs —
               a second observer would double the callback cost on exactly the
               devices already struggling. */
            new PerformanceObserver(function(list){
                var es=list.getEntries();
                for(var i=0;i<es.length;i++){
                    var e=es[i];
                    if(!e.interactionId)continue;
                    if(!usable(e)){dropped++;continue;}
                    if(e.duration>pageWorst)pageWorst=e.duration;
                    if(sent>=MAX_REPORTS||e.duration<SLOW_MS||e.duration<=worst)continue;
                    worst=e.duration;sent++;
                    /* Payload built now (the entry is only valid here), sent on
                       the NEXT task: both observers are notified in the same
                       one, and the event callback wins the race — measured, the
                       frame attribution came out null every single time. The
                       delay costs nothing (this is not a user-visible path) and
                       is what makes `lf` non-empty. */
                    (function(ev){
                        var _tgt=ev.target,_rec=0;
                        if(!_tgt){_tgt=recallTarget(ev.startTime);if(_tgt)_rec=1;}
                        var p={
                            d:Math.round(ev.duration),
                            delay:Math.round(ev.processingStart-ev.startTime),
                            proc:Math.round(ev.processingEnd-ev.processingStart),
                            paint:Math.round(ev.startTime+ev.duration-ev.processingEnd),
                            ev:ev.name,
                            sel:describe(_tgt),
                            // 1 = the name came from the weak handle, not the
                            // entry. Kept visible so a recalled name is never
                            // silently mixed with a directly observed one.
                            rc:_rec,
                            path:location.pathname.replace(/^\/[a-z]{2}(?=\/|$)/,'')||'/',
                            n:(performance.interactionCount||0)
                        };
                        // One task later: the frame the interaction sat in is
                        // only on the timeline once that frame has ENDED.
                        setTimeout(function(){
                            var f=loafFor(ev);
                            // script · function | forced-layout ms | blocking ms
                            p.lf=f?((f.u||'?')+(f.f?'·'+f.f:'')+'|fl'+f.fl+'|b'+f.b):null;
                            try{var x=framesFor(ev);if(x){p.lx=x.fr;p.cov=x.cov}}catch(_){}
                            /* When in the page's life: half of the slow taps on mobile
                               Chrome are the page's first or second interaction, with the
                               largest input delay (135 ms against 66 later) — is the page
                               still loading? t = ms since navigation, ld = 0 before
                               DOMContentLoaded ended, 1 before load ended, 2 after. */
                            try{
                                p.t=Math.round(ev.startTime);
                                var nv=performance.getEntriesByType('navigation')[0];
                                if(nv)p.ld=(!nv.domContentLoadedEventEnd||ev.startTime<nv.domContentLoadedEventEnd)?0:((!nv.loadEventEnd||ev.startTime<nv.loadEventEnd)?1:2);
                            }catch(_){}
                            try{window.__ae&&window.__ae('inp_slow',p)}catch(_){}
                        },0);
                    })(e);
                }
            }).observe({type:'event',durationThreshold:16,buffered:true});
        }catch(_){}

        /* Sent on a timer WHILE THE PAGE IS ALIVE, not at unload.
           The textbook place to report a page's INP is the first `hidden`, but
           this queue is flushed by a visibilitychange listener registered
           earlier in this file — so at hide time the flush runs first and a
           value pushed afterwards never leaves the device. Measured: the
           attribution event arrived, `web_vital` silently did not. A timer
           lands the row in the queue with the page still open, and hide stays
           as a fallback for anyone who leaves before it fires.
           Trade-off, deliberate: an interaction slower than everything before
           it that happens after the report is not counted. INP is normally
           settled by the first interactions, and a value that reliably arrives
           beats a truer one that does not. */
        function reportVital(){
            if(vitalSent||!pageWorst)return;
            vitalSent=1;
            try{window.__ae&&window.__ae('web_vital',{INP:Math.round(pageWorst),n:(performance.interactionCount||0),drop:dropped})}catch(_){}
        }
        setTimeout(reportVital,15000);
        document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')reportVital()});
        window.addEventListener('pagehide',reportVital);
    })();

    /* LCP / CLS / FCP / TTFB — производитель для тех же четырёх полей, которые
       панель уже агрегирует по 75-му перцентилю (AnalyticsController: LCP, INP,
       CLS, TTFB). До 2026-08-15 из них слался ТОЛЬКО INP: за неделю 308 381
       замер отклика и ЧЕТЫРЕ замера LCP. То есть метрика, по которой Google
       ранжирует сильнее всего, у нас не измерялась вовсе, а лабораторные
       прогоны на быстрой машине давали 1.4 с и выглядели успокаивающе — при
       замедлении процессора вчетверо (обычный Android) те же страницы дали
       2.2–3.1 с, то есть у порога 2.5 с и за ним. Спор о том, где мы на самом
       деле, решается только полем.

       ⚠️ Отдельный блок, а не дополнение к reportVital выше, по двум причинам:
       тот выходит по `!pageWorst` (страница БЕЗ взаимодействия не шлёт ничего —
       а её LCP нужен ровно так же), и весь его IIFE отключается там, где нет
       типа записи 'event' — LCP от этого не зависит.

       ⚠️ Отправка по таймеру, пока страница жива, а не на выгрузке — тот же
       урок, что записан у INP выше: очередь сбрасывает более ранний слушатель
       visibilitychange, и значение, положенное после него, с устройства не
       уходит. 15 с: к этому моменту LCP практически всегда устоялся.

       Выборка 50%: событие пришлось бы слать с КАЖДОГО просмотра, а не только с
       тех, где было взаимодействие. Половина даёт десятки тысяч замеров в сутки
       — для 75-го перцентиля с запасом, — и не удваивает таблицу, которой и так
       8.2 ГБ при хранении 30 дней. */
    (function(){
        if(!window.PerformanceObserver)return;
        if(Math.random()>=0.5)return;
        var lcp=0,cls=0,sent=0,lcpEl='',lcpUrl='',lcpLoad=0;
        function obs(type,cb){
            try{new PerformanceObserver(cb).observe({type:type,buffered:true})}catch(_){}
        }
        /* ⚠️ Число без элемента не чинится. До 2026-09-07 сюда писался ТОЛЬКО
           `LCP`, и на вопрос «что именно является LCP-элементом» поле не
           отвечало вовсе — ответ приходилось добывать лабораторным прогоном по
           одной странице за раз (разбор 06.09: LCP оказался абзацем
           `P.tool-intro-text`, то есть текстом, а не картинкой, — и это меняет
           весь список починок: шрифт и разбор <head>, а не вес изображений).
           `el` — тег+id+первый класс, `u` — адрес ресурса, если LCP картинка.
           Оба обрезаны: это ключ для группировки, а не разметка. */
        obs('largest-contentful-paint',function(l){
            var e=l.getEntries();if(!e.length)return;
            var x=e[e.length-1];
            lcp=x.startTime;
            lcpLoad=Math.round(x.loadTime||0);
            lcpUrl=(x.url||'').split('?')[0].slice(-80);
            try{
                var n=x.element;
                if(n){
                    var c=n.className;
                    c=(typeof c==='string'?c:(c&&c.baseVal)||'').trim().split(/\s+/)[0]||'';
                    lcpEl=(n.tagName||'').toLowerCase()+(n.id?'#'+n.id:'')+(c?'.'+c:'');
                    lcpEl=lcpEl.slice(0,60);
                }
            }catch(_){}
        });
        /* hadRecentInput отбрасывает сдвиги, вызванные самим пользователем
           (раскрытие аккордеона — не дефект вёрстки). Это же делает CrUX. */
        obs('layout-shift',function(l){
            var e=l.getEntries();
            for(var i=0;i<e.length;i++)if(!e[i].hadRecentInput)cls+=e[i].value;
        });
        function report(){
            if(sent)return;sent=1;
            var p={},fcp=null,nav=null;
            try{fcp=performance.getEntriesByName('first-contentful-paint')[0]}catch(_){}
            try{nav=performance.getEntriesByType('navigation')[0]}catch(_){}
            if(lcp>0)p.LCP=Math.round(lcp);
            if(fcp)p.FCP=Math.round(fcp.startTime);
            if(nav&&nav.responseStart>0)p.TTFB=Math.round(nav.responseStart);
            /* Каким путём пришёл документ: `nt` — тип навигации, `tx` — 1, если
               байты пришли по сети (0 — из кэша браузера, без сервера). Доля
               `tx:0` по `nt` — знаменатель к прибору page_freshness ниже. */
            if(nav){ p.nt=nav.type||''; if(typeof nav.transferSize==='number')p.tx=nav.transferSize>0?1:0; }
            /* CLS шлём всегда, включая 0: отсутствие сдвигов — это результат, а
               не пропуск, и без нулей 75-й перцентиль считался бы только по
               страницам, которые дёргаются. */
            p.CLS=Math.round(cls*1000)/1000;
            if(p.LCP===undefined&&p.FCP===undefined)return;  /* нечего сообщать */
            /* Атрибуция LCP: чем он является и из чего складывается. Без этих
               трёх полей число «2440 мс» не указывает ни на одну строчку кода.
               `dom` — размер DOM на момент отчёта: стиль и раскладка растут по
               нему, и это единственный дешёвый способ увидеть в поле, что
               страница раздулась (замер 06.09: 1193 узла до впрыска меню и
               4848 после). */
            if(lcpEl)p.el=lcpEl;
            if(lcpUrl)p.u=lcpUrl;
            if(lcpLoad>0)p.lt=lcpLoad;
            try{p.dom=document.getElementsByTagName('*').length}catch(_){}
            try{window.__ae&&window.__ae('web_vital',p)}catch(_){}
        }
        setTimeout(report,15000);
        document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')report()});
        window.addEventListener('pagehide',report);
    })();

    /* ── Прибор: страница из кэша браузера — тот ли у неё код (15.10.2026) ──
       Замер 14.10 по журналу nginx: 9,4 % запусков страниц тулов идут из
       копии, которую сервер не видел (запуск есть — `rate/check`, — а запроса
       самой страницы с того же адреса и браузера нет), и 61 % таких копий
       старше двух суток. Лаборатория 15.10: «Назад» мимо bfcache и вкладка,
       восстановленная после перезапуска браузера, — оба `back_forward`, оба
       берут документ из дискового кэша (через service worker) БЕЗ проверки на
       сервере, хотя у страницы `max-age=0, must-revalidate`, и исполняют код
       до деплоя (/document-translate 14.10: 62 с на 516 абзацев старым лейном
       вместо пары секунд). `no-store` отвергнут замером: bfcache пропадает у
       ВСЕХ (6 из 6 «Назад» — полная загрузка 4–6 с вместо 0,6–0,9 с).
       Разбор — docs/why/stale-page-copy.md.

       Только страницы тулов, чей документ пришёл из кэша (transferSize 0, не
       пререндер), плюс 2 % обычных загрузок как КОНТРОЛЬ: там отличий быть не
       должно, иначе врёт сам прибор.
         · исполняемая копия — ответ `only-if-cached` на свой адрес;
         · текущая — `no-cache` на тот же адрес (в кэш nginx; и ЭТО ЖЕ
           обновляет копию в браузере: следующий «Назад» или восстановленная
           вкладка получат свежую страницу); копия у воркера — swPut ниже;
         · разница — __pageCodeDiff ниже; `own` — изменился код самого тула;
         · `age_m` — возраст копии по Date её ответа против Date свежего;
         · `in_ms` — первое нажатие человека от начала навигации (-1 — не было):
           была бы страница ещё нетронутой к ответу — цена перезагрузки;
         · `ref` / `swc` — после обновления обе копии свежие;
         · `priv` — ответ личный: в счёт «код устарел» не идёт.
       Отчёт уходит только с согласием на аналитику (__ae); обновление копий —
       у всех. Запуск после загрузки тула: прибор не должен ей мешать. */
    /* page-code-diff:start */
    window.__pageCodeDiff=function(oldHtml,newHtml,slug,domBase){
        function key(u){
            var m=/^(?:https?:)?\/\/[^\/]+(\/[^#]*)$/.exec(u);
            if(m)u=m[1];
            if(u.charAt(0)!=='/')return null;
            m=/^\/jsv\/(\d+)\/([^?#]+)/.exec(u);
            if(m)return [m[2],m[1]];
            m=/^([^?#]+)\?(?:[^#]*&)?v=([^&#]+)/.exec(u);
            return m?[m[1],m[2]]:null;
        }
        function code(html){
            var a={},m,re=/<(?:script|link)\b[^>]*?\s(?:src|href)\s*=\s*["']([^"']+)["']/gi;
            while((m=re.exec(html))){ var k=key(m[1]); if(k)a[k[0]]=k[1]; }
            /* Своё у каждой отрисовки — CSRF-токен (вшит в __RATING_CFG и запасной
               _token) и nonce CSP: без замены два рендера ОДНОЙ страницы
               «отличаются» всегда (замер 15.10 на пяти тулах прода). */
            var vary=[],t=/<meta\s+name=["']csrf-token["']\s+content=["']([^"']+)["']/i.exec(html);
            if(t)vary.push(t[1]);
            t=/\snonce=["']([^"']+)["']/i.exec(html);
            if(t)vary.push(t[1]);
            var h=2166136261,re2=/<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
            while((m=re2.exec(html))){
                if(/\ssrc\s*=/i.test(m[1]))continue;
                var ty=/\stype\s*=\s*["']?([^"'\s>]+)/i.exec(m[1]);
                if(ty&&!/^(module|text\/javascript|application\/javascript)$/i.test(ty[1]))continue;
                var s=m[2];
                for(var o=0;o<vary.length;o++)s=s.split(vary[o]).join('');
                s=s.replace(/\s+/g,' ').trim();
                for(var i=0;i<s.length;i++){ h^=s.charCodeAt(i); h=Math.imul(h,16777619)>>>0; }
            }
            return {a:a,h:h};
        }
        var A=code(oldHtml),B=code(newHtml),n=0,own=0,add=0,gone=0,p=[];
        function mine(k){ return !!slug&&(k.indexOf('/'+slug+'/')>=0||k.indexOf('/'+slug+'.')>=0); }
        for(var k in B.a){
            if(A.a[k]===undefined){ add++; if(mine(k))own=1; }
            else if(A.a[k]!==B.a[k]){ n++; if(mine(k))own=1; if(p.length<3)p.push(k.split('/').slice(-2).join('/')); }
        }
        if(!domBase)for(var j in A.a){ if(B.a[j]===undefined){ gone++; if(mine(j))own=1; } }
        return {n:n,add:add,gone:gone,own:own,inl:domBase?-1:(A.h!==B.h?1:0),p:p.join(' ')};
    };
    /* page-code-diff:end */
    (function(){
        if(window.top!==window.self)return;
        var mt=document.querySelector('meta[name="tool-slug"]');
        var slug=mt&&mt.content;
        if(!slug||!window.fetch)return;
        var nav=null;
        try{nav=performance.getEntriesByType('navigation')[0]}catch(_){}
        if(!nav||typeof nav.transferSize!=='number')return;
        var fromCache=nav.transferSize===0&&!(nav.activationStart>0);
        var control=!fromCache&&Math.random()<0.02;
        if(!fromCache&&!control)return;
        var firstInput=-1;
        function onIn(){ if(firstInput<0)firstInput=Math.round(performance.now()); }
        try{
            window.addEventListener('pointerdown',onIn,{capture:true,passive:true});
            window.addEventListener('keydown',onIn,{capture:true,passive:true});
        }catch(_){}
        var url=location.pathname+location.search;
        /* `only-if-cached` требует mode same-origin; нет копии — null, а не ошибка. */
        function cached(){
            return fetch(url,{cache:'only-if-cached',mode:'same-origin',credentials:'same-origin'})
                .then(read,function(){return null;});
        }
        function read(r){
            if(!r||!r.ok)return null;
            return r.text().then(function(t){ return {t:t,d:Date.parse(r.headers.get('Date')||'')||0}; });
        }
        /* Копии в кэше нет (вытеснена; страницу отдал Cache Storage воркера) —
           сравниваем с тем, что видно в DOM: только адреса ресурсов, без
           встроенных скриптов (их текст в DOM не отличить от вставленных). */
        /* Вторая копия страницы — у service worker'а (`pages-*`): её он отдаёт,
           когда сеть не ответила за 4 с. Лаборатория 15.10: «Назад» берёт
           HTTP-кэш, а перезагрузка на медленной сети — ЭТУ копию, и без её
           обновления перезагрузка возвращала тот же старый код. Обновляется
           только запись, которая уже есть, и не личная страница — то же
           правило, что у самого воркера (`_declinePrivate` в sw.js). */
        function swPut(resp){
            if(!window.caches||!resp)return Promise.resolve(-1);
            if(/\b(private|no-store)\b/i.test(resp.headers.get('Cache-Control')||''))return Promise.resolve(-1);
            var key=location.href.split('#')[0];
            return caches.keys().then(function(names){
                return Promise.all(names.filter(function(n){return n.indexOf('pages')===0;}).map(function(n){
                    return caches.open(n).then(function(c){
                        return c.match(key,{ignoreVary:true}).then(function(m){
                            return m?c.put(key,resp.clone()).then(function(){return 1;}):0;
                        });
                    });
                }));
            }).then(function(a){ var k=0; for(var i=0;i<a.length;i++)k+=a[i]; return k; },function(){ return -1; });
        }
        function domHtml(){
            var out='';
            try{
                var els=document.querySelectorAll('script[src],link[href]');
                for(var i=0;i<els.length;i++){
                    var e=els[i],a=e.getAttribute('src')?'src':'href';
                    out+='<'+e.tagName.toLowerCase()+' '+a+'="'+e.getAttribute(a)+'">';
                }
            }catch(_){}
            return out;
        }
        function run(){
            var t0=performance.now();
            var p={f:'page_freshness',nt:nav.type||'',dt:nav.deliveryType||'',cache:fromCache?1:0,ctl:control?1:0,
                   sw:(navigator.serviceWorker&&navigator.serviceWorker.controller)?1:0,
                   dcl:Math.round(nav.domContentLoadedEventEnd||0)};
            function send(){
                p.in_ms=firstInput;
                p.ms=Math.round(performance.now()-t0);
                try{ window.__ae&&window.__ae('feature_use',p); }catch(_){}
            }
            var old=null;
            cached().then(function(o){
                old=o;
                var tf=performance.now();
                return fetch(url,{cache:'no-cache',credentials:'same-origin'}).then(function(r){
                    p.f_ms=Math.round(performance.now()-tf);
                    p.st=r.status;
                    /* Личная страница отличается от гостевой копии по природе —
                       такие строки из счёта «код устарел» исключаются. */
                    p.priv=/\b(private|no-store)\b/i.test(r.headers.get('Cache-Control')||'')?1:0;
                    var keep=r.ok?r.clone():null;
                    return read(r).then(function(f){ if(f)f.keep=keep; return f; });
                });
            }).then(function(fresh){
                if(!fresh){ send(); return; }
                var swDone=swPut(fresh.keep).then(function(k){ p.swc=k; });
                p.b=old?'cache':'dom';
                var d=window.__pageCodeDiff(old?old.t:domHtml(),fresh.t,slug,!old);
                for(var k in d)p[k]=d[k];
                if(old&&old.d&&fresh.d)p.age_m=Math.round((fresh.d-old.d)/60000);
                return Promise.all([cached(),swDone]).then(function(x){
                    var after=x[0];
                    if(after){ var r=window.__pageCodeDiff(after.t,fresh.t,slug); p.ref=(r.n+r.add+r.gone===0&&r.inl===0)?1:0; }
                    send();
                });
            }).catch(function(e){ p.err=String((e&&e.name)||e).slice(0,40); send(); });
        }
        /* Что раньше: 2,5 с после load или 8 с после DOMContentLoaded. На
           тяжёлой странице load может не прийти вовсе (лаборатория 15.10:
           /ru/qr-scanner не дождался его за 180 с), и прибор молчал бы. */
        var started=0;
        function go(){ if(started++)return; run(); }
        if(document.readyState==='complete')setTimeout(go,2500);
        else{
            window.addEventListener('load',function(){ setTimeout(go,2500); },{once:true});
            if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){ setTimeout(go,8000); },{once:true});
            else setTimeout(go,8000);
        }
    })();

    /* ── Прибор: ввод, который НЕ ДОШЁЛ до страницы (23.09.2026) ─────────────
       Обращение 20.09 (Cristina, uid 10000865, Премиум intl, Edge 153, сайт как
       установленное приложение): «llevo una semana que no me abre… hasta que
       no pasan dos horas no entra en la aplicación». По нашим данным её
       открытия были ЖИВЫМИ: страница нарисована за 0.8 с, session_start и
       web_vital ушли, флеш на закрытии сработал — а ни одного pointerdown и ни
       одной клавиши страница не получила, и через 30 с окно закрыли. Корень не
       у нас: Microsoft признала в Edge 153 (10.09) дефект «окно перестаёт
       отвечать на мышь и клавиатуру», починен в 153.0.4234.46 (17.09); тот же
       дефект Chromium 153 на Windows описал Salesforce (Chrome — 153.0.8010.48).

       Класс был НЕВИДИМ по построению: ввод не доходит до JS, значит ни один
       наш счётчик его не считает — такие сессии выглядят как «открыл и ушёл»,
       и разница между Edge 152 и 153 по доле сессий без действий тонула в
       шуме (38 % против 41 % на intl-PWA). Здесь считается именно эта форма:
       страница ВИДИМА заметное время, а ни одного pointerdown/keydown не
       пришло. `moves`/`wheels` — признак ПРИСУТСТВИЯ человека: мышь над
       страницей двигалась или колесо крутилось (при дефекте Chromium 153
       прокрутка работала, клики — нет). Нули = человек ушёл от экрана,
       не нули = человек пытался. Рост доли вторых у одной версии браузера —
       регрессия ввода в браузере, а не наш дефект; смотреть вместе с
       `device_cap.bf` (точная сборка).

       Один отчёт на страницу, на первом уходе (hidden/pagehide), только
       верхний документ. Слушатели пассивные, в захвате — ни одному тулу не
       мешают и от stopPropagation не зависят. Сторож —
       tests/Unit/NoInputSessionIsMeasuredTest.php. */
    (function(){
        if(window.top!==window.self)return;
        var MIN_VIS_MS=15000;
        var presses=0,keys=0,moves=0,wheels=0,vis=0,sent=0;
        var visBase=document.hidden?0:Date.now();
        function on(t,fn){ try{ window.addEventListener(t,fn,{capture:true,passive:true}) }catch(_){} }
        on('pointerdown',function(){presses++});
        on('touchstart',function(){presses++});
        on('keydown',function(){keys++});
        on('pointermove',function(){moves++});
        on('wheel',function(){wheels++});
        function visMs(){ return vis+(document.hidden||!visBase?0:Date.now()-visBase); }
        document.addEventListener('visibilitychange',function(){
            if(document.hidden){ if(visBase)vis+=Date.now()-visBase; visBase=0; }
            else visBase=Date.now();
        });
        function report(){
            if(sent)return;
            var v=visMs();
            if(presses||keys||v<MIN_VIS_MS)return;
            sent=1;
            var pwa=0;
            try{ pwa=(window.matchMedia&&window.matchMedia('(display-mode: standalone)').matches)||window.navigator.standalone===true?1:0 }catch(_){}
            try{
                var send=window.__aeNow||window.__ae;
                if(send)send('feature_use',{f:'no_input_session',vis_ms:Math.round(v),moves:moves,wheels:wheels,pwa:pwa});
            }catch(_){}
        }
        // Порядок важен: слушатель visibilitychange выше уже закрыл видимый отрезок.
        document.addEventListener('visibilitychange',function(){ if(document.hidden)report(); });
        window.addEventListener('pagehide',report);
    })();
